export default {
  hkMarket: {
    deskSubtitle: '直销可售目录＋一键上手＋模拟付成功 · stub≠真聚合／PayPal／Meta',
    sellableCatalogTitle: '直销可售收款目录（§1-11）',
    sellableCatalogHint: 'Apple／Google 挂本地聚合；PayPal 备援；加密入目录（真收待合规）。可选 BYO／Referral。',
    colTitle: '名称',
    colTrack: '商业轨',
    colEnabled: '启用',
    colMerchant: '商户占位',
    colNote: '说明'
  },
  produceOutputCatalog: {
    pageTitle: '出品挂钩',
    pageDesc: '以机型为主：一台设备挂哪些出品；再维护出品分类与场景组合，供 Leo 自动生产选机。',
    tabCategories: '出品分类',
    tabBinds: '机型挂出品',
    tabKits: '场景组合',
    categoryKey: '分类键',
    name: '名称',
    bucket: '大类',
    pickBucket: '请选择出品大类',
    bucketFreshDrink: '现制饮',
    bucketDessert: '甜品',
    bucketVending: '无人零售',
    bucketLightMeal: '轻食',
    bucketHotKitchen: '热厨',
    bucketBakery: '烘焙',
    status: '状态',
    sortNo: '排序',
    modelKey: '型号编码',
    deviceFamily: '设备族',
    pickModel: '请选择机型',
    pickDeviceFamily: '请选择设备族',
    bindRole: '挂接角色',
    boundOutputs: '挂接出品',
    secondaryOutputs: '其中副挂',
    secondaryHint: '勾在副挂的出品，对该机型算次要能力。',
    kitKey: '组合键',
    members: '成员设备',
    coverCategories: '覆盖出品',
    optional: '可选',
    startPipeline: '开始标准流水线',
    guideStarted: '已开启出品挂钩引导',
    guideStartFail: '开启引导失败'
  },
  trainingWorkBoard: {
    title: '训工作表',
    desc: '德国日训总账：按机型／内容筛选，一眼看清健康、卡住、口语燃料与训练回报。',
    toDesk: '决策台',
    refresh: '刷新',
    searchPh: '搜索标题／内容／型号',
    deviceFamily: '机型族',
    contentCategory: '内容类',
    status: '报告状态',
    workState: '工作态',
    stuckOnly: '只看卡住',
    fuelStallOnly: '只看空转绿',
    total: '全部',
    stuck: '卡住',
    healthy: '健康',
    recent: '近窗',
    fuelStall: '空转绿',
    fuelActive: '有燃料',
    roiTitle: '训练回报',
    roiAvg: '均分',
    roiImprove: '须改进',
    roiWaste: '浪费候选',
    roiPlateau: '平台期／低回报',
    roiNext: '下一刀',
    fuelTitle: '口语燃料',
    colTitle: '训练项',
    colContent: '内容',
    colFamily: '机型族',
    colCategory: '内容类',
    colFreq: '频率',
    colWorkState: '工作态',
    colFuel: '燃料',
    colFuelPending: '待审',
    colFuelT6: 'T6併入',
    colFuelPromoted: '晋升',
    colRoi: '回报档',
    colRoiScore: '分',
    colRoiReason: '回报建议',
    colStatus: '报告',
    colAge: '龄(h)',
    colReportAt: '报告时间',
    colModels: '型号键',
    colActions: '操作',
    nodeOpen: '打开总表',
    nodeFilter: '筛卡住',
    nodeDesk: '决策台处置',
    nodeDone: '完成',
    nodeTodo: '未开始',
    ws: { HEALTHY: '健康', STUCK: '卡住', RECENT: '近窗刚跑' },
    fuel: { FUEL_ACTIVE: '有燃料', FUEL_STALL: '空转', FUEL_OK: '待命', N_A: '—' },
    family: {
      tea_machine: '茶机',
      coffee_machine: '咖啡机',
      cross_cutting: '跨族',
      factory: '工厂'
    },
    category: {
      device_gate: '设备 Gate',
      routing_nl: '路由 NL',
      portal_nl: '门户 NL',
      hm_engine: 'HM 引擎',
      commerce_nl: '商城 NL',
      store_ops: '店务',
      intelligence: '智力',
      healer: 'Healer',
      factory: '工厂',
      other: '其他'
    }
  },
  aiSpendAudit: {
    title: '烧钱审计',
    desc: '所有 AI Token／美金烧钱集中审计：德国训练、云修单、边缘商家与可扩展科目。',
    reconcileOr: '对账 OpenRouter',
    importOr: '导入 OR 活动',
    refresh: '刷新',
    kpiMeasured: '实测 USD',
    kpiEstimate: '估算 USD',
    kpiCombined: '合计可见',
    kpiTokens: '实测 Token',
    kpiTrainStatus: '训练成本态',
    kpiHealer: 'Healer',
    group: '费用分组',
    deviceFamily: '设备族',
    applyFilter: '筛选',
    colCategory: '科目',
    colGroup: '分组',
    colMetering: '计量',
    colUsd: '本月 USD',
    colTokens: 'Token',
    colBudget: '预算',
    colStatus: '状态',
    colHint: '说明',
    detail: '明细',
    budgetPanel: '预算闸（写回）',
    healerMode: 'Healer 模式',
    rounds: '月轮次',
    trainBudget: '训练月预算 USD',
    saveHealer: '保存 Healer',
    saveTrainBudget: '保存训练预算',
    nodeOpen: '打开烧钱审计',
    nodeCap: '确认月帽',
    nodeDone: '已就绪',
    nodeTodo: '待办',
    loadFail: '加载烧钱审计失败',
    reconcileOk: '对账完成',
    importOk: '导入完成',
    saveOk: '已保存',
    stepOverview: '总览',
    stepCategories: '科目',
    stepDetail: '明细',
    stepBudget: '月帽',
    stepOps: '对账',
    stepOverviewTitle: '本月 AI 烧钱总览',
    stepOverviewLead: '先看合计与状态，再一步步点进科目与月帽——像大公司账单向导一样，一步一事。',
    stepCategoriesTitle: '按分类查看科目',
    stepCategoriesLead: '点选一张科目卡进入明细；可先按分组筛选。',
    stepDetailTitle: '科目明细',
    stepDetailLead: '本步只看当前科目的金额、计量与说明，不再堆整页 JSON。',
    stepBudgetTitle: '设定月帽与预算',
    stepBudgetLead: '云修单月美金／轮次，以及训练月预算，写回后立即生效。',
    stepOpsTitle: '对账与导入',
    stepOpsLead: '需要时对账 OpenRouter 或导入活动；做完即可离开本页。',
    groupAll: '全部分组',
    emptyCategories: '暂无科目，请刷新或检查德国账本。',
    pickCategoryFirst: '请先在上一步选一个科目',
    moreFields: '更多字段',
    healerBlock: 'Cursor 云修单',
    trainBlock: '德国训练预算',
    usdCap: '月美金上限',
    reconcileHint: '把 OpenRouter 账单与训练账本对齐。',
    importHint: '从 OpenRouter 活动导入本月用量。',
    doneBanner: '审计流程已走完；可随时回到总览再看。',
    prev: '上一步',
    next: '下一步',
    finish: '完成',
    finishOk: '烧钱审计向导已完成',
    chartsTitle: '图表分析',
    chartsLead: '按日／月／年／星期／时段看趋势；科目对比、分组占比、预算占用一目了然。',
    granDay: '按日',
    granMonth: '按月',
    granYear: '按年',
    granWeekday: '按星期',
    granHour: '按时段',
    chartTrend: '费用趋势对比',
    chartCategory: '科目金额对比',
    chartGroup: '分组占比',
    chartBudget: '预算 vs 已用',
    chartTrainSplit: '训练内部分拆（T9 / OpenRouter）',
    chartModels: 'OpenRouter 模型排行',
    chartEmpty: '暂无图表数据（账本为空时只显示科目卡）',
    seriesTraining: '德国训练',
    seriesHealer: '云修单',
    seriesEcs: '德国 ECS（估）',
    seriesCombined: '合计',
    seriesBudget: '预算',
    seriesSpent: '已用',
  },
  leoChat: {
    chat_1475da: "企业登录",
    chat_16f606: "整数；单位依设备/约定",
    chat_17dfdc: "我的偏好",
    chat_22f4eb: "用量与计费",
    chat_27e8b6: "标签（来自记忆偏好）",
    chat_29f404: "调理机配方",
    chat_30_can_4ab820: "近 30 日 CAN 解码帧",
    chat_30_can_8fe750: "近 30 日 CAN 计量合计",
    chat_30_e47539: "近 30 日已入账扣款",
    chat_30_token_16fa23: "近 30 日 AI 点数",
    chat_33613d: "对话",
    chat_40d6e4: "以访客身份继续（产品与公开咨询）",
    chat_43631f: "停止聆听",
    chat_4845c6: "处理中…",
    chat_553891: "填入并对齐设备",
    chat_5cd727: "返回对话",
    chat_62e9d1: "选择模式",
    chat_6888c5: "保存",
    chat_6adada: "控制台",
    chat_6d1197: "隐私政策、服务条款与免责声明",
    chat_7106a7: "机台商品",
    chat_71c576: "请输入密码",
    chat_755be2: "出品建档",
    chat_7847b8: "发送",
    chat_7e76c4: "尚未建立计费账户；保存后将以所选模式开始计量。",
    chat_805f8b: "使用此内容",
    chat_85406a: "跳过朗读",
    chat_965a50: "店铺管理员",
    chat_9b2c38: "输入消息",
    chat_9cbbd1: "最近一次识别",
    chat_a84cf9: "留空＝全局偏好；指定则为该机专属",
    chat_ab185d: "填入输入框",
    chat_abd535: "注册会员",
    chat_api_a76f41: "（订阅方案请由运营或 API 建立）",
    chat_app_c884f6: "若其他 App 已复制链接或机码，直接粘贴即可。",
    chat_b347b6: "目前计费设置",
    chat_b6d41c: "复制指令",
    chat_cta_title_7535dd: "cta.title",
    chat_curve_soft_7e9ea0: "例如 curve_soft",
    chat_d2de5e: "注册完成，请以会员身份重新登录后继续。",
    chat_d5e285: "我已阅读并同意",
    chat_d5edfc: "复制全文",
    chat_da4d71: "会员登录",
    chat_docs_leo_brain_ident_64cb16: "docs/leo_brain/IDENTITY_PROTOCOL.md",
    chat_docs_leo_brain_leo_p_6f7d10: "docs/leo_brain/LEO_PERSONALIZATION_SCENARIO.md",
    chat_e31e3a: "后台完整登录页",
    chat_e6a549: "关闭",
    chat_ea544c: "请输入账号",
    chat_ef5cb: "重新加载",
    chat_email_leo_fda298: "Email + 密码；登录后回到 Leo 对话并依步骤完成开通。",
    chat_eur_394b9b: "EUR",
    chat_f98d0d: "保存设置",
    chat_fe497b: "请以会员账号登录；店铺管理员请用「企业后台」分页。登录后依提示完成家用或商用设置。",
    chat_hintauth_a22705: "hintAuth",
    chat_https_localhost_qr_e4c72c: "需相机权限；建议 HTTPS 或 localhost。对准设备或产品上的 QR/条码。",
    chat_leo_323396: "Leo 用量与计费",
    chat_leo_99743: "Leo 导览",
    chat_leo_ac1503: "会员登录并进入 Leo",
    chat_leo_e3ca11: "Leo 开通步骤",
    chat_leo_e7dd0: "Leo",
    chat_leo_e9f6cd: "企业登录并进入 Leo",
    chat_loaderror_108d9d: "加载错误",
    chat_name_example_com_cb4900: "name@example.com",
    chat_night_owl_b82e53: "例如 night_owl",
    chat_png_d92bec: "下载 PNG",
    chat_qr_25f92d: "扫描与产品 QR",
    chat_qr_40dfbd: "生成 QR",
    chat_qr_a9ae66: "选取相册截图或照片，离线识别 QR/条码。",
    chat_session_inputplaceho_bbe0d1: "session.inputPlaceholderZh ||",
    chat_sku_qr_png_c9b88c: "将门店配方关键字、网址或 SKU 转成 QR，可下载 PNG 打印贴标。",
    chat_token_7959d6: "累计 AI 点数（全期间）",
    chat_token_can_dbc_28957f: "查看 Token 与车载 CAN/DBC 用量、钱包/账本扣款记录（请以会员登录，或后台账号已完成商用绑定）。",
    chat_user_ace2e8: "后台 User 账号；具备菜单权限者可操作设备与数据中心。",
    chat_voicemictitle_650ed3: "voiceMicTitle",
    chat_voicesiriarialabel_76d873: "voiceSiriAriaLabel",
    chat_wsstatustitle_f6c66f: "wsStatusTitle",
  },
  leoNl: {
      busy: "…",
      close: "Close",
      enable: "要为此语言启用 Leo NL 吗？",
      later: "稍后",
      no: "否",
      subProgress: "生成中…",
      subPrompt: "使用 AI 理解 %1$s 语音指令",
      titleProgress: "正在准备 Leo NL 语言理解…",
      titlePrompt: "要为此语言启用 Leo NL 吗？",
      titleReady: "Leo NL 语言包已就绪",
      yes: "是",
  },

  dineTable: {
    title: '桌码点单',
    desc: '一桌一码。没装 Leo 也能在网页点一单，同时推下载。同一页可嵌进 Facebook 等社群。',
    brand: '品牌商',
    retailer: '零售商',
    store: '门店',
    payMode: '付款时机',
    payFirst: '先付再出餐',
    payLater: '先点后付',
    saveMode: '保存',
    tableNo: '桌号',
    create: '建桌',
    refresh: '刷新',
    colNo: '桌号',
    colUrl: '桌贴网址',
    qr: '桌贴',
    stickerPreview: '桌贴预览',
    downloadJpg: '下载 JPG',
    downloadAllJpg: '全店桌贴打包',
    downloadOk: '已下载桌贴 JPG',
    downloadAllOk: '已下载全店桌贴 ZIP',
    downloadFail: '桌贴下载失败',
    scanHint: '扫码点单',
    poweredBy: 'Leo · 桌码点单',
    empty: '还没有桌',
    webLink: '社群点单链接',
    webHint: '可嵌进 Facebook 或其他社群，客人用网页点单',
    close: '清台',
    ordersTitle: '桌码订单／收款',
    orderCount: '单数',
    paidCount: '已收',
    unpaidCount: '未收',
    amount: '金额',
    paid: '付款',
    paidYes: '已付',
    paidNo: '未付',
    pickup: '取餐号',
    createdAt: '时间',
    ordersEmpty: '这家店还没有桌码单',
    ordersLoadFail: '桌码订单加载失败，请刷新或重新登录',
  },

  brandStorePayment: {
    title: '品牌付款',
    desc: '选地区 → 只选一家付款 → 填商户号 → 试付通过 → 标 LIVE。钱进店自己的商户户。',
    hintOneVendor: '每家店只能绑一家；换供应商须重新试付。',
    store: '门店',
    storePh: '选择门店',
    region: '地区',
    vendor: '付款方式',
    track: '开户方式',
    trackByo: '已有商户户（自填号）',
    trackReferral: '经我们介绍开户',
    merchantRef: '商户号',
    merchantRefPh: '公开 MID／Account；勿填 Secret',
    currency: '币种',
    secretWarn: '禁止填写 API Secret／私钥；只填公开商户号。',
    save: '保存绑定',
    trial: '标记试付通过',
    live: '标 LIVE',
    status: '状态',
    needStore: '请先选门店',
    needMid: '请填商户号',
    saveOk: '已绑定',
    trialOk: '已标记试付通过',
    liveOk: '已标 LIVE'
  },

  hkPspOpenAccount: {
    title: '开户管理',
    desc: '港区 Referral 开户案：AI 审件、送供应商、收信跟进；运营只读与例外处置。',
    hint: '仅 Referral 案；BYO 绑号不进此队列。',
    refresh: '刷新',
    status: '状态',
    vendor: '供应商',
    caseId: '案号',
    store: '门店',
    mid: '商户号',
    sla: 'SLA',
    updated: '更新时间',
    note: '说明',
    runAi: '重跑 AI',
    forceReject: '强制驳回',
    markHandled: '标记已人工处理',
    ok: '已处理'
  },

  brandOpenPack: {
    title: '自动开店',
    desc: '一关一关过。系统能认的直接做。唯一选择是现在买不买机器。',
    goPay: '去收款',
    level: '第 {n} 关 / {total}',
    photoTitle: '拍一张证件',
    photoHint: '营业执照或商业登记拍一张。系统自己填，你不用打字。',
    photoNext: '拍好了，下一关',
    machineTitle: '现在要买机器吗',
    machineHint: '不买也可以先开店。以后再买。',
    buyNow: '现在买，教我做产品',
    buyLater: '以后再买',
    productTitle: '产品图和描述',
    productHint: '随便讲几句、丢几张图，或什么都不填。AI 帮你补齐，你再核对确认。',
    productHintPh: '例如：冰美式，偏苦一点',
    productAi: 'AI 补齐',
    productSkip: '先跳过用模板',
    productConfirm: '确认这些产品',
    productName: '产品名',
    productDesc: '描述',
    productPrice: '价格',
    productNeedAi: '请先点 AI 补齐，或跳过。',
    productSkipped: '已用模板招牌，可继续。',
    menuTitle: '菜单和收款已经好了',
    menuHint: '不买机器就到这里。下一关去收款。',
    teachTitle: '做出第一杯',
    teachHint: '机器绑上之后，按画面做出第一杯。',
    next: '这一关完成',
    back: '退回上一关',
    stay: '这一关还没过，先留在这里。',
    doneTitle: '店开好了',
    doneMenu: '可以收款、卖菜单上的东西。',
    doneMachine: '下一关去学做出品。',
    colStep: '步骤',
    colDetail: '这一区要做的'
  },

  productShelf: {
    title: '产品上架',
    desc: '手填名称、售价；介绍和产品图可手填或交给 AI 真生成。自动出品须打开后台真页走完八步，不能假写配方。',
    storePh: '门店编号',
    load: '载入',
    manual: '普通品',
    auto: '自动出品',
    name: '产品名',
    price: '售价',
    description: '产品介绍',
    imageUrl: '产品图网址',
    kind: '种类',
    state: '状态',
    save: '存产品资料',
    ai: '交给 AI 补',
    publish: '确认上架',
    listed: '已上架',
    ready: '可交给 AI',
    waiting: '基础未齐',
    needStore: '请填门店编号',
    noEquipment: '店里还没有自动设备，配方和扫码先不能用',
    materialPh: '这一款用的物料名',
    saveMaterial: '记下这步物料',
    confirmStep: '做好这一步',
    now: '现在做',
    coachNow: '现在请做 · 第 {n} 步',
    coachHint: '打开后台真页做完这一步，回来刷新。禁止跳步、禁止手机假写配方。',
    finishCurrent: '请先完成当前步骤',
    needProduct: '请先保存这一款的名称和售价',
    openSoc: '打开后台这一步',
    refreshStep: '我做完了，刷新',
    fail: '没做成，请再试'
  },

  produceGuide: {
    title: '自动设备',
    desc: '先选想自动做茶、咖啡或饮料。我们只推荐商店里的一台，用一句话说明它怎么做。有价钱就现在买，没有就先留需求。',
    storePh: '门店编号',
    tea: '茶',
    coffee: '咖啡',
    drink: '饮料',
    look: '看推荐',
    combo: '也可以一整套：',
    demo: '看它怎么做',
    receiver: '收货人',
    phone: '电话',
    address: '地址',
    buy: '现在买',
    demand: '先留需求',
    empty: '商店里还没有对上的机器',
    done: '已记下',
    fail: '没做成，请再试'
  },

  brandAppListing: {
    title: '品牌上架',
    desc: '傻瓜一键：AI 帮你出名称／图标／商店文案，确认后一键打包上架草稿（XRROSS 代管帐）。',
    hint: '客户不用管打包与商店后台；付款须 LIVE 才可对外收款。',
    store: '门店',
    storePh: '选择门店',
    displayName: 'App 名称',
    storeTitle: '商店标题',
    shortDesc: '短介绍',
    fullDesc: '完整介绍',
    icon: '图标',
    iconEmpty: '尚未生成图标',
    status: '状态',
    btnAi: '帮我生成',
    btnConfirm: '确认素材',
    btnPublish: '一键上架',
    btnPipeline: '开始标准流水线',
    coachDo: '按当前步去做',
    aiOk: '已生成（可再改）',
    confirmOk: '素材已确认',
    publishOk: '已排队上架'
  },

  route: {
    // XRROSS_I18N_UNION_FILL_20260916 zh
    merchantData: '商家数据',
    homePage:'首页',
    dataDisplay:'数据展示',
    atlas:'地图',
    journal:'日志',
    details:'详情',
    systemSetting:'系统设置',
    aiTrusteeAdmin: 'AI 托管管理台',
    agentPermissionSteward: 'Agent 權限管家',
    socNotificationCenter: '通知中心',
    loginAccount:'账号管理',
    merchants:'商户管理',
    devices: "设备管理",
    material: "物料管理",
    deviceConfig: "设备配置",
    channelConfiguration: "通道配置",
    configProfileLibrary: "配置档案库",
    coffeeMachineChannelSlots: "X600H配方中心",
    configBindDispatch: "绑定与下发",
    leoKnowledgeGroup: '智能.Leo',
    leoKnowledgeModelFields: '型号知识字段',
    leoKnowledgeEquipmentTypeTypeKey: '设备类型 type_key',
    leoKnowledgeUpload: '知识上传',
    leoKnowledgeIngestBatch: '入库批次（自动创建）',
    leoKnowledgePhase1Ssot: 'Phase1 SSOT 管线',
    leoKnowledgeCapabilityMatrix: '能力矩阵',
    leoKnowledgeOnboarding: '智慧型号引导',
    leoKnowledgeTesterConsole: '测试员主控台',
    leoKnowledgePipelineHub: '管线总览',
    leoKnowledgeFeatureSurface: '功能→API 映射',
    leoKnowledgeProtocolDoc: '协议文档索引',
    leoKnowledgeRemoteTools: '遥控工具目录',
    leoKnowledgeLearning: '学习闭环',
    leoKnowledgeExternalIngest: '外部知识入库',
    leoKnowledgePortalHub: 'Leo 对话与营运',
    leoKnowledgePortalHubDesc: '从此打开 Leo 对话（主入口）与 Biz 营运功能；Console／Portal 仅内部运维。',
    leoKnowledgePortalHubHint: '主权台为气泡式智慧问答版面；门户为精简入口。如需 portalToken／ceoBearer，请在打开后于地址栏补充查询参数。',
    leoKnowledgeUiSurfaceSample: '视觉样板',
    leoKnowledgeUiSurfaceSample2: '视觉样板 · 样板2',
    leoKnowledgeUiSurfaceSample3: '视觉样板 · 样板3',
    uiSurfaceSampleMergedLead: '三套后台视觉样板合在一页，用上方 Tab 切换对照。',
    uiSurfaceSampleTab1: '样板1 · Ant Pro',
    uiSurfaceSampleTab2: '样板2 · Stripe',
    uiSurfaceSampleTab3: '样板3 · 紧凑',
    uiSurfaceSampleLead: '样板1（已定案试点）：Ant Design Pro 中密。全域 Token 已抽出；商家列表／设备列表已试套骨架。',
    uiSurfaceSampleLead2: '样板2 · Stripe／SaaS：淡紫主色、更大圆角、偏松留白、轻阴影。',
    uiSurfaceSampleLead3: '样板3 · 紧凑运营：青绿主色、小圆角、迷你控件、信息密度更高。',
    uiSurfaceSampleAlert: '仅视觉样板，表单与表格为示意数据，不调用后端；尚未套用到全站。请对照样板1／2／3 选风格。',
    uiSurfaceSampleTokenTitle: 'Design Token（候选）',
    uiSurfaceSampleDensity: '密度：中密（8 的倍数）',
    uiSurfaceSampleDensity2: '密度：中松（Stripe 节奏）',
    uiSurfaceSampleDensity3: '密度：紧凑（运营桌面）',
    uiSurfaceSampleBtnTitle: '按钮分级',
    uiSurfaceSampleBtnPrimary: '主要操作',
    uiSurfaceSampleBtnSecondary: '次要',
    uiSurfaceSampleBtnText: '文字按钮',
    uiSurfaceSampleBtnDanger: '危险',
    uiSurfaceSampleBtnMore: '更多',
    uiSurfaceSampleBtnCreate: '新建',
    uiSurfaceSampleListSkeleton: '列表页骨架：筛选｜表格｜底栏',
    uiSurfaceSampleFormTitle: '表单密度（中密）',
    uiSurfaceSampleFormRemark: '备注',
    uiSurfaceSamplePipelineTitle: '流水线节点＋教练卡金样（SocProcessRail + SocStepCoach）',
    uiSurfaceSamplePipelineMeta: '顶栏标准流水线＝节点轨＋蓝框教练大按钮；工单／页内共用；禁止另起样式',
    uiSurfaceSampleCoachTitle: '请完成：第 2 步（示范）',
    uiSurfaceSampleCoachHint: '蓝框＝现在要做的一步；点大按钮即可，不必在整页大海捞针。',
    uiSurfaceSampleCoachPrimary: '去做这一步',
    uiSurfaceSampleCoachSecondary: '开始／检查引导',
    uiSurfaceSamplePipelineStep1: '步骤一',
    uiSurfaceSamplePipelineStep2: '步骤二',
    uiSurfaceSamplePipelineStep3: '步骤三',
    uiSurfaceSamplePipelineStep4: '步骤四',
    uiSurfaceSampleColActions: '操作',
    uiSurfaceSampleActEdit: '编辑',
    uiSurfaceSampleActExport: '导出',
    uiSurfaceSampleTableFootHint: '底栏：左侧说明｜右侧分页',
    uiSurfaceSampleKpi_orders: '今日订单（示意）',
    uiSurfaceSampleKpi_online: '在线设备',
    uiSurfaceSampleKpi_alerts: '待处理告警',
    uiSurfaceSampleKpiSub: '样板数字',
    uiSurfaceSampleFilterTitle: '筛选区',
    uiSurfaceSampleKeyword: '关键字',
    uiSurfaceSampleKeywordPh: '名称或编号',
    uiSurfaceSampleStatus: '状态',
    uiSurfaceSampleStAll: '全部',
    uiSurfaceSampleStOn: '启用',
    uiSurfaceSampleStOff: '停用',
    uiSurfaceSampleReset: '重置',
    uiSurfaceSampleSelectPh: '请选择',
    uiSurfaceSampleTableTitle: '列表示意',
    uiSurfaceSampleColName: '名称',
    uiSurfaceSampleColRegion: '区域',
    uiSurfaceSampleColStatus: '状态',
    uiSurfaceSampleColUpdated: '更新时间',
    uiSurfaceSampleCompareTitle: '对照：全白区块 vs 分层灰底',
    uiSurfaceSampleCompareOld: '旧感：大面积纯白',
    uiSurfaceSampleCompareOldDesc: '内容与背景同色时，边界较不分明，长时间阅读容易累。',
    uiSurfaceSampleCompareNew: '建议：灰底上的白卡',
    uiSurfaceSampleCompareNewDesc: '主内容仍在白底上维持对比；页面级用浅灰承托，视线有落点。',
    leoPortalHubSovereign: '主权台（全屏）',
    leoPortalHubPortal: '门户',
    leoPortalHubDeviceIntegrationSection: '装置端整合',
    leoPortalHubDeviceIntegrationLink: '对外说明与工具（新标签页）',
    leoPortalHubRuntimeModuleLink: '装置云运行期 AAR（新标签页）',
    leoPortalHubSdkLabSection: 'XRROSS SDK（工程测试）',
    leoPortalHubSdkEngineerLabOpen: '全功能测试台（第一轨＋第二轨，新标签页）',
    leoPortalHubSdkPublicTrack1: '第一轨对外说明',
    leoPortalHubSdkPublicTrack2: '第二轨对外说明',
    leoPortalHubChatSection: '对话入口',
    leoPortalHubPreferences: '我的偏好',
    leoPortalHubLogin: '登录',
    leoPortalHubSectionOps: '运营控制台',
    leoPortalHubSectionOpsDesc: '后台实时对话流、CEO／门户主权窗口，适合大屏验收与值守。',
    leoPortalHubSectionPortal: '行动门户',
    leoPortalHubSectionPortalDesc: '精简入口，便于手机或对外展示。',
    leoPortalHubSectionChat: '智慧对话',
    leoPortalHubSectionChatDesc: 'Leo 智慧对话；下方可调整偏好或登录。',
    leoPortalHubSectionDeviceDesc: '对外说明、运行期模块与整合文档（均在新标签页打开）。',
    leoPortalHubSectionSdkDesc: '工程师用于两轨串接、回归与调试的统一测试台。',
    leoPortalHubCardSovereignDesc: '气泡式智慧问答、Markdown 与 SOP 步骤卡片。',
    leoPortalHubCardPortalDesc: '精简 Leo 门户；必要时在网址加上 portalToken／ceoBearer。',
    leoPortalHubCardLeoDesc: '默认 Leo 对话；一般运营、知识问答与遥控（全球会员同一入口）。',
    leoPortalHubCardPrefDesc: '人设、地区与个性化选项。',
    leoPortalHubCardLoginDesc: '使用后台账号登录后再使用写入／敏感能力。',
    leoPortalHubCardDeviceIntegrationDesc: '公开说明、Track1 工具与整合检核表。',
    leoPortalHubCardRuntimeDesc: 'Device Cloud 运行期／AAR 与 Track2 对照入口。',
    leoPortalHubCardSdkLabDesc: '集成测试环境，同时演练第一轨与第二轨行为。',
    leoPortalHubSdkFeaturedTag: '工程',
    leoPortalHubOpenNewTab: '点击以新标签页打开',
    leoPortalHubSdkCrossRefHint: '第一轨／第二轨对外说明请使用上方「装置端整合」两张卡片。',
    leoFloatDockTitle: 'Leo 对话',
    leoFloatDockMinimize: '最小化',
    leoFloatDockClose: '关闭',
    leoFloatDockResizeHint: '拖曳右下角调整窗口大小',
    leoFloatDockSwitchLabel: 'Leo 对话',
    leoFloatDockSwitchHint: '开启后打开 Leo SOC助手「对话」页（与说明书／智能引导同抽屉）；独立 Leo／Console／门户页仍用全页聊天。',
    socAssistantTabManual: '问说明书',
    socAssistantTabGuide: '智能引导',
    socSmartGuideLead: '说你是谁、要达到什么；系统开一张流水线并一直跟到结果，除非你删除。做完自动接下一段。',
    socSmartGuideStart: '开始进程',
    socSmartGuideMyProcesses: '我的进程',
    socSmartGuideCatalog: '或从进程目录选',
    socSmartGuideNetStats: '单位 {units} · 进程 {processes} · 交叉 {edges}',
    socSmartGuideIntentPlaceholder: '例如：我是新品牌老板，要从建品牌到出品',
    socSmartGuideEntry: '入口',
    socSmartGuideExit: '出口',
    socSmartGuideDemand: '需求',
    socSmartGuideResult: '结果',
    socSmartGuideHandoff: '这条做完了，接着开下一条',
    socSmartGuideRolePreview: '角色预览',
    socSmartGuideRoleCurrent: '当前账号',
    socSmartGuideProxyStore: '代跑店员线：门店编号',
    socSmartGuidePaused: '已暂停',
    socSmartGuideInProgress: '进行中',
    socSmartGuideNotices: '提醒',
    socSmartGuideNoticeNotDone: '没做',
    socSmartGuideNoticeWrong: '做错',
    socSmartGuideNoticeDue: '到期',
    socSmartGuideAck: '已知悉',
    socSmartGuideContinue: '继续',
    socSmartGuideDelete: '删除流水线',
    socSmartGuideDeleteConfirm: '删除后系统不再跟进这条线，确定？',
    socSmartGuideDeleted: '已删除流水线',
    socSmartGuideDeleteFail: '删除失败',
    socSmartGuideOpenPage: '打开',
    socProcessNetTogoTitle: '进程待办',
    socProcessNetTogoRemain: '还差 {n} 步',
    socProcessNetTogoAllDone: '这条线都过了',
    socProcessNetTogoHint: '打勾只认系统状态。点卡住的步骤跳真页，或开口跟 Leo 说、填同一张单。',
    socProcessNetTogoVoice: '跟 Leo 说',
    socProcessNetTogoClose: '关闭',
    socProcessNetTogoLoadFail: '待办清单载入失败',
    socProcessNetTogoNow: '目前',
    socSmartGuideSlotsHint: '先把缺的栏问完（聊天＝填同一张单）',
    socSmartGuideSlotSubmit: '写入',
    socAssistantTabChat: 'Leo 对话',
    xrrossIntroNavButton: '认识 XRROSS',
    xrrossIntroHub: '认识 XRROSS',
    xrrossIntroLeo: 'Leo',
    xrrossIntroSoc: 'SOC',
    xrrossIntroTrinity: '三位一体',
    xrrossIntroXhm: 'XHM',
    leoSmartIntro: '认识 Leo Smart',
    layoutThemeUseDark: '切换为深色主题',
    layoutThemeUseLight: '切换为浅色主题',
    leoProfileWorkbenchLeoMovedPrefix: 'C-Line · Leo：主权台、门户与 Leo 对话入口已移至侧栏「Leo 知识库」内之',
    leoProfileWorkbenchLeoMovedSuffix: '。',
    equipmentCategory: '设备类别',
    equipmentCategoryEdit: '设备类别-编辑',
    equipmentCategoryDel: '设备类别-删除',
    equipmentTypePermAdd: '设备类型-查询/新增（列表）',
    equipmentTypePermEdit: '设备类型-编辑',
    deviceSimulatorConsole: '模拟机控制台',
    leoDeviceOpsRolePolicy: '命令权限总表',
    leoDeviceOpsSemanticTraining: '语义训练工作台',
    leoTurnRoutingTrainingHub: 'T0 入口路由训练台',
    leoKnowledgePortalOpsInventory: 'Portal ops API 盘点台',
    leoKnowledgePortalOpsDailyHub: 'PORTAL_OPS 工作台',
    leoDeviceOpsReviewInbox: 'B 线审核待办',
    leoDeviceOpsDescriptionAutogen: 'Device_OPS 盤點台',
    leoDeviceOpsBLineDailyHub: 'B 线日常工作台',
    simulatorGroup: '模拟机',
    x600hGateway: 'X600H',
    xt90c2Simulator: 'XT90C2',
    blenderSimulator: 'Blender',
    maestroSimulator: 'Maestro模拟机',
    storefrontSimulator: '点单机Kiosk',
    productCenter: "出品管理",
    productCenterFolderOther: '其他产品',
    dataCenter: "数据中心",
    maintenance: "运维管理",
    filesCenter:'文件管理',
    menuSetting:'菜单设置',
    organization:'用户组织',
    loginAccount:'账号列表',
    authorization:'角色管理',
    merchants:'商户列表',
    deviceList:'设备列表',
    deviceAutoServiceGroup: '售后维修保养',
    supportTicketGroup: '售后支持',
    supportTicketCreate: '提交工单',
    supportTicketMine: '我的工单',
    supportTicketWorkbench: '售后工作台',
    supportPlaybook: '标准问答库',
    deviceServiceWorkbench: '售后工单工作台',
    deviceServiceMyAssignments: '我的维修任务',
    deviceServiceAssignees: '维修负责人',
    deviceServiceMaintenance: '保养计划',
    deviceServiceFaultPolicy: '故障开单策略',
    deviceServiceEnterprisePolicy: '企业自动售后策略',
    deviceServiceMobile: '维修任务（手机）',
    deviceServiceBills: '维修账单',
    deviceServiceAnalytics: '故障分析',
    storeMaterialStock: '库存总览',
    storeMaterialOrders: '采购订单',
    storeMaterialConsumable: '耗材 BOM',
    storeMaterialMq: 'MQ 配置',
    storeMaterialInvoice: '发票',
    storeMaterialBarcodeAlias: '扫码映射',
    storeMaterialCount: '仓库盘点',
    storeMaterialBomWizard: 'BOM向导',
    storeMaterialAnalytics: '物料使用报告',
    storeMaterialPhysicalMerge: 'SKU合并建议',
    channelCategory:'通道类型',
    productCategory:'出品类型',
    optionCategory:'规格类型',
    optionList:'规格列表',
    storeAccount:'店铺账号',
    stores:'店铺管理',
    modelName:'设备名称/型号',
    category:'物料类型',
    configDistribute:'通道下发',
    devicesChannels:'设备通道',
    productsList5:'出品列表5',
    produceFivePos:'产品5门店客制',
    posCenter:'POS中心',
    menuDistribute:'菜单下发',
    storeMenu:'店铺菜单',
    merchantsData:'商家统计数据',
    devicsData:'设备统计数据',
    productionData:'设备出品数据',
    maintanenceData:'设备售后数据',
    devicesWorkingData:'设备使用数据',
    afterSalesReminder:'售后提示',
    maintenanceTips:'保养提示',
    fileUpgrade:'文件升级',
    dataDowloan:'数据下载',
    materialList:'物料列表',
    accessoriesCategory:'小吃类型',
    accessoriesList:'小吃列表',
    businessCenter: '业务中心',
    afterSalesServiceGroup: '售后服务',
    storeMaterialGroup: '库存管理',
    appsBanner:'App横幅展示',
    advertisement:'广告清单',
    advertBind:'广告绑定',
    advertDistribute:'广告下发',
    membersCenter:'会员列表',
    orderCenter:'订单列表',
    packBag:'打包袋子',
    appsCenter:'app管理',
    productsList2:'出品列表2',
    XTSeriesData:'配料机数据',
    calibrationData:'校准数据',
    fullPipeData:'满管数据',
    productionData:'出品数据',
    materialDate:'物料数据',
    qualityData:'单杯数据',
    alertsLog:'故障日志',
    cleaningLog:'清洗记录',
    coffeeData:'咖啡机数据',
    coffeeMachineProductionData:'X600H 出品数据',
    coffeeMachineSingleCupData:'X600H 单杯数据',
    coffeeSumData:'品质数据',
    taxCenter:'税务中心',
    taxManagement:'税务管理',
    taxAllocation:'税务配置',
    dataOfTeaExtractorMachine:'萃茶机数据',
    teaMachineMaterial: '物料损耗',
    teaEarlyBrewWork: '多机互联工作',
    dispenserPrecision: '精準度',
    dispenserMaterialLoss: '物料损耗',
    dispenserMultiMachine: '多机互联',
    ecosystemMallGroup: '生态商城',
    ecosystemMallTopology: '商店拓扑',
    ecosystemMallFeaturedBuyEyebrow: '主力推荐 · 家用直购',
    ecosystemMallFeaturedBuyTitle: 'Xrross X600H · $499',
    ecosystemMallFeaturedBuyDesc: '家用智能咖啡机：一键进结账，填地址即可付款。',
    ecosystemMallFeaturedBuyCta: '立即购买 X600H',
    ecosystemMallFeaturedBuyBrowse: '先看目录',
    ecosystemMallCapGridTitle: '商城能做什么',
    ecosystemMallCapGridDesc: '这里是全部能力（不藏）。鼠标移到每一格，会弹出该功能的简单说明与联动一句；蓝框建议＝现在最该做的一步。',
    ecosystemMallCapHoverHint: '移上查看说明',
    ecosystemMallTipBuyX600h: '进入家用结帐，用 Stripe／PayPal 买 X600H（海外默认 Stripe）。',
    ecosystemMallTipOrientPipeline: '带你逛商城：能力格 → 家用／商用 → 选店 → 点能力。',
    ecosystemMallTipGapFillPipeline: '选店后补齐本店缺口：拓扑 → 建议 → 模拟或留资 → 可下单。',
    ecosystemMallTipColorScheme: '只改画布配色，不影响功能。',
    ecosystemMallTipBrowseCatalog: '先逛目录与拓扑，不急着下单。',
    ecosystemMallTipHomePipeline: '家用结帐标准流水线：选商品 → 填地址 → 付款 → 完成。',
    ecosystemMallTipBackTopology: '回商城主画面（拓扑／能力格）。',
    ecosystemMallTipReload: '重新载入本页资料。',
    ecosystemMallTipPayStripe: '用 Stripe 安全付款（海外默认）。',
    ecosystemMallTipPayPaypal: '用 PayPal 付款（可选）。',
    ecosystemMallTipTrialPipeline: '先试后买流水线：开试用 → 看结果 → 直购或留意向。',
    ecosystemMallTipEntryContinue: '依简报建议做下一步。',
    ecosystemMallTipEntrySwitch: '在家用焦点与商用焦点之间切换（功能不减）。',
    ecosystemMallTipEntryAdvanced: '展开或收起进阶图表／专家细节。',
    ecosystemMallTipTrackHome: '家用焦点：偏直购／家用设备。',
    ecosystemMallTipTrackCommercial: '商用焦点：偏店务／产线／缺口。',
    ecosystemMallTipAppDlPipeline: '带你下载本区正式 App（与 OTA 同一账本）。',
    ecosystemMallTipAppDlReload: '重新整理可下载清单。',
    ecosystemMallCapBadgeSuggest: '建议',
    ecosystemMallCapBadgeCurrent: '目前',
    ecosystemMallCapBadgeNeedStore: '需选店',
    ecosystemMallCapC1Title: '商店拓扑',
    ecosystemMallCapC1Blurb: '用拓扑图看本店已有／还缺什么',
    ecosystemMallCapC1Link: '联动：点设备看跟其他机怎么一起工作',
    ecosystemMallCapC2Title: '搜索推荐',
    ecosystemMallCapC2Blurb: '用关键词找下一台',
    ecosystemMallCapC2Link: '联动：依你店况／已有设备推荐缺口',
    ecosystemMallCapC3Title: '产线组合',
    ecosystemMallCapC3Blurb: '开这类店要哪几台',
    ecosystemMallCapC3Link: '联动：一整条店务产线一起配齐',
    ecosystemMallCapC4Title: '试用模拟',
    ecosystemMallCapC4Blurb: '先云端试再决定买',
    ecosystemMallCapC4Link: '联动：试完可回拓扑补缺口或直购',
    ecosystemMallCapC5Title: '组合演示',
    ecosystemMallCapC5Blurb: '看整条店务怎么联动',
    ecosystemMallCapC5Link: '联动：多机一起跑的店务故事',
    ecosystemMallCapC6Title: '家用直购／订单',
    ecosystemMallCapC6Blurb: '买硬件、付款、查单',
    ecosystemMallCapC6Link: '联动：买回家后进 Leo／拓扑同一生态',
    ecosystemMallCapC7Title: '商业计划',
    ecosystemMallCapC7Blurb: '买／升级商业方案',
    ecosystemMallCapC7Link: '联动：方案能力挂回店与设备',
    ecosystemMallCapC8Title: '购买意向',
    ecosystemMallCapC8Blurb: '留下我要这台／要装',
    ecosystemMallCapC8Link: '联动：意向进履约，再回拓扑补节点',
    ecosystemMallCapC9Title: '售前问答',
    ecosystemMallCapC9Blurb: '问联动／怎么买／怎么试',
    ecosystemMallCapC9Link: '联动：问清楚再进模拟或意向',
    ecosystemMallCapC10Title: '应用下载',
    ecosystemMallCapC10Blurb: '下载本区正式 App',
    ecosystemMallCapC10Link: '联动：手机／机端同一账本生态',
    ecosystemMallCapC11Title: '虚拟店／家',
    ecosystemMallCapC11Blurb: '摆布局、看建议放置',
    ecosystemMallCapC11Link: '联动：虚拟摆好对回真实店缺口',
    ecosystemMallCapC12Title: '产品展示',
    ecosystemMallCapC12Blurb: '用格子一张张看商品与介绍',
    ecosystemMallCapC12Link: '联动：点商品可去结帐／试用／回拓扑图',
    ecosystemMallProductDisplayDesc: '格子展示全部商品（与拓扑图、产线组合并列）。点一张卡看说明，再决定买或试。',
    ecosystemMallProductDisplayToolbar: '商品格子',
    ecosystemMallProductDisplayCount: '共 {n} 件',
    ecosystemMallProductDisplaySearchPh: '搜名称／编码',
    ecosystemMallProductDisplayDefaultPitch: '云端就绪 · 可联动',
    ecosystemMallProductDisplayAlreadyHere: '你已在产品展示',
    ecosystemMallProductDisplaySeeTopology: '在拓扑图看联动',
    ecosystemMallProductDisplayScopeLabel: '设备范围',
    ecosystemMallProductDisplayScopeAll: '全部设备',
    ecosystemMallProductDisplayScopeStore: '本店设备',
    ecosystemMallProductDisplayNeedStore: '本店范围需先选店',
    ecosystemMallProductDisplayNoStore: '未选店',
    ecosystemMallProductDisplayStoreAlert: '本店设备：请先在上方选一家店，才会列出本店已有／建议补的商品。',
    ecosystemMallProductDisplayCatalogAlert: '全部设备：展示商城目录全量；选店后会标记本店已有。',
    ecosystemMallProductDisplayEmpty: '目前没有可展示的商品。可改「全部设备」、换店，或确认目录已上架 ACTIVE。',
    ecosystemMallProductDisplaySideEmpty: '点左侧商品卡片，展开与拓扑商店相同的产品详情与媒资。',
    ecosystemMallProductDisplaySideEmptyHint: '含封面／影片、概览、规格与功能章节；可直购、试用或到拓扑看联动。',
    ecosystemMallDetailCapacity: '产能提升',
    ecosystemMallDetailLabor: '人工降幅',
    ecosystemMallDetailMedia: '产品细节与动态艺廊',
    ecosystemMallDetailMediaPending: '待补图',
    ecosystemMallDetailMediaPreview: '产品预览',
    ecosystemMallDetailVideo: '产品影片',
    ecosystemMallDetailCover: '商城封面',
    ecosystemMallDetailAvatar: '拓扑头像',
    ecosystemMallDetailModelImg: '型号图',
    ecosystemMallDetailScene: '情境',
    ecosystemMallDetailTabOverview: '概览',
    ecosystemMallDetailTabSpecs: '规格',
    ecosystemMallDetailTabFeatures: '功能',
    ecosystemMallDetailKeySpecs: '重点规格',
    ecosystemMallDetailSeeAll: '查看全部',
    ecosystemMallDetailSpecsLoading: '规格载入中…',
    ecosystemMallDetailSpecsEmpty: '尚无已采用规格。',
    ecosystemMallDetailSpecsFail: '规格载入失败',
    ecosystemMallDetailSpecSearchPh: '搜索规格项目…',
    ecosystemMallDetailGuide: '引导体验',
    ecosystemMallDetailAllChapters: '全部章节',
    ecosystemMallDetailPrev: '上一章',
    ecosystemMallDetailNext: '下一章',
    ecosystemMallDetailProof: '能力证明挂点',
    ecosystemMallDetailOpen: '打开',
    ecosystemMallDetailNoChapters: '此型号尚无功能章节。',
    ecosystemMallDetailBackChapters: '返回章节列表',
    ecosystemMallDetailChapter: '章节',
    ecosystemMallDetailChapterHint: '点击查看步骤详情',
    ecosystemMallDetailModel: '型号',
    ecosystemMallDetailFamily: '族别',
    ecosystemMallDetailRole: '店务角色',
    ecosystemMallDetailOverlayOwned: '本店已有 · 已连云端',
    ecosystemMallDetailOverlayMissing: '云端已就绪，店里还缺这台',
    ecosystemMallDetailOverlayAvailable: '目录可选 · 云端已就绪',
    ecosystemMallOrientRailTitle: '带你认识生态商城',
    ecosystemMallGapFillPipeline: '带我补齐这家店',
    ecosystemMallGapFillRailTitle: '本店缺口补齐',
    ecosystemMallGuideChromeTitle: '流程引导',
    ecosystemMallGuideExpand: '展开引导',
    ecosystemMallGuideCollapse: '收合引导',
    ecosystemMallGuideCollapsedHint: '已收合，工作区优先',
    ecosystemMallGuideSkipOrient: '稍后再导览',
    ecosystemMallGuideSkipOrientDone: '已略过导览，可直接看拓扑',

    ecosystemMallHomeCheckoutPipeline: '家用直购流水线',
    ecosystemMallTrialThenBuyTitle: '先试用再买',
    ecosystemMallTrialThenBuyDesc: '试过再开直购或留购买意向；模拟与真机主档隔离，功能不减。',
    ecosystemMallTrialThenBuyPipeline: '带我试完再买',
    ecosystemMallTrialThenBuyRailTitle: '试用→购买',
    ecosystemMallTrialThenBuyListTitle: '我的试用模拟机',
    ecosystemMallTrialThenBuyAllStatus: '全部状态',
    ecosystemMallTrialThenBuyCleanup: '清理过期',
    ecosystemMallTrialThenBuyEmpty: '尚无试用模拟机',
    ecosystemMallTrialThenBuyStatus: '状态',
    ecosystemMallTrialThenBuyExpires: '过期',
    ecosystemMallTrialCoachPick: '请先选要试的商品',
    ecosystemMallTrialCoachOpen: '开通／查看试用模拟',
    ecosystemMallTrialCoachResult: '看结果后可直购或留意向',
    ecosystemMallTrialHintPick: '可从拓扑点设备再开模拟；本页看已开通清单。',
    ecosystemMallTrialHintOpen: '刷新可看本账号试用 SN；与真机隔离。',
    ecosystemMallTrialHintResult: '直购与意向两条入口都在，不会藏。',
    ecosystemMallSideBuyNow: '直接购买这台',
    ecosystemMallSideSimOpen: '先体验模拟制作',
    ecosystemMallSideSimClose: '收起模拟',
    ecosystemMallSideIntentNeedStore: '请先选店再留「我要这台」',
    ecosystemMallSideIntentPotential: '我要这台（留下意向）',
    ecosystemMallSideIntentOwned: '这台本店已有',
    ecosystemMallAppDownloads: '应用下载',
    ecosystemMallAppDownloadsDesc: 'Leo 产品页。苹果走 App Store；安卓海外走 Google Play，中国大陆走本区节点安装（与 OTA 同一份）。',
    ecosystemMallAppDlReload: '重新载入',
    ecosystemMallAppDlChannels: '下载通道',
    ecosystemMallAppDlAndroid: '安卓直装',
    ecosystemMallAppDlInstallNow: '立即下载安装',
    ecosystemMallAppDlNoApk: '本区暂无直装包',
    ecosystemMallAppDlAndroidReady: '侦测到安卓。点按钮即可下载本区已发布的 Leo 手机包。',
    ecosystemMallAppDlAndroidWait: '本区还没有对客户开放的安装包，请稍候或走商店上架。',
    ecosystemMallAppDlVersion: '版本',
    ecosystemMallAppDlUnknownSrc: '若系统提示未知来源，请允许安装此应用。',
    ecosystemMallAppDlPlayReview: 'Google Play 尚未开放。',
    ecosystemMallAppDlIosReview: 'App Store 即将上架。',
    ecosystemMallAppDlReviewing: '审核中',
    ecosystemMallAppDlComing: '即将上架',
    ecosystemMallAppDlDesktopHint: '苹果走 App Store。安卓海外走 Google Play，中国大陆走本区节点安装。也可复制链接发给同事。',
    ecosystemMallAppDlCopyLink: '复制本页链接',
    ecosystemMallAppDlOpenSoc: '打开 SOC 后台',
    ecosystemMallAppDlCopySoc: '复制 SOC 链接',
    ecosystemMallAppDlSocHint: 'SOC 是网页后台，用浏览器打开即可；你现在就在这里。',
    ecosystemMallAppDlCopied: '已复制',
    ecosystemMallAppDlSmartAndroid: '这是安卓手机：可直接下载安装 Leo。',
    ecosystemMallAppDlSmartAndroidPlay: '这是安卓手机（海外）：请打开 Google Play 安装 Leo。',
    ecosystemMallAppDlSmartAndroidNode: '这是安卓手机（中国大陆）：请用本区节点安装，与 OTA 同一份。',
    ecosystemMallAppDlSmartAndroidNoApk: '这是安卓手机，但本区还没有直装包。海外请走 Google Play。',
    ecosystemMallAppDlSmartIos: '这是苹果手机：请从 App Store 安装 Leo.Smart。',
    ecosystemMallAppDlSmartDesktop: '这是电脑：请用安卓手机打开本页安装，或复制链接。',
    ecosystemMallAppDlRoleLeo: '手机大脑',
    ecosystemMallAppDlRoleSoc: '你在这里',
    ecosystemMallAppDlRoleXhm: '店里机器 · 下轮',
    ecosystemMallAppDlTopo: '商城拓扑 · 三位一体',
    ecosystemMallAppDlEdgeLeoSoc: '手机 → 后台',
    ecosystemMallAppDlEdgeSocXhm: '后台 → 机器',
    ecosystemMallAppDlCapLeo: 'Leo 管人怎么跟机器说话；安卓可先直装。',
    ecosystemMallAppDlCapSoc: 'SOC 是中枢：账号、店、远端都从这里走。',
    ecosystemMallAppDlCapXhm: '机端 App 下轮再放；现在先把手机 Leo 装上。',
    ecosystemMallAppDlStartPipeline: '开始标准流水线',
    ecosystemMallAppDlPipelineStarted: '已开始标准流水线',
    ecosystemMallAppDlDeveloper: 'XRROSS',
    ecosystemMallAppDlCategory: '生活 · 人机 · 店铺',
    ecosystemMallAppDlPlayBtn: 'Google Play',
    ecosystemMallAppDlIosBtn: 'App Store',
    ecosystemMallAppDlQrTitle: '扫码下载',
    ecosystemMallAppDlQrHint: '扫码打开下载页。苹果进 App Store。安卓：海外进 Google Play，中国大陆走本区节点安装。',
    ecosystemMallAppDlQrSave: '下载二维码',
    ecosystemMallAppDlQrOpen: '打开下载页',
    ecosystemMallAppDlShots: '预览',
    ecosystemMallAppDlShotVoice: '开口出杯',
    ecosystemMallAppDlShotTopo: 'Leo → SOC → 机器',
    ecosystemMallAppDlShotLife: '生活里的人机',
    ecosystemMallAppDlShotWork: '店里干活',
    ecosystemMallAppDlAbout: '简介',
    ecosystemMallAppDlAboutBody: 'Leo 是人机生活方式的手机入口：你开口，店里的机器做事。手机连 SOC 后台，后台连茶机／咖机／出杯线。不是聊天机器人清单，是同一条拓扑上的生活、工作与生意。',
    ecosystemMallAppDlFeatTalk: '开口就能泡茶、问状态、跟机器说话',
    ecosystemMallAppDlFeatTopo: '三位一体：手机 Leo → SOC 中枢 → 店里机器',
    ecosystemMallAppDlFeatLife: '生活点单、店员干活、老板看店，人机都在场',
    ecosystemMallAppDlFeatOta: '安装包与本区 OTA 同一账本，发版即商店直装跟着变',
    ecosystemMallAppDlWhatsNew: '新内容',
    ecosystemMallAppDlWhatsNewBody: '本区已发布 {ver}，与检查更新同一包。',
    ecosystemMallAppDlWhatsNewEmpty: '本区还没有对客户开放的安装包。',
    ecosystemMallAppDlInfo: '信息',
    ecosystemMallAppDlInfoDev: '开发者',
    ecosystemMallAppDlInfoPkg: '套件名',
    ecosystemMallAppDlInfoAge: '年龄分级',
    ecosystemMallAppDlAgeVal: '4+',
    ecosystemMallSocOps: '运营商店',
    ecosystemMallPortraits: '客户画像',
    ecosystemMallPortraitsDesc: '按企业／账号判断设备商或运营商，并结合规模、运营与生命周期做精准推广。',
    ecosystemMallPortraitsStatsTitle: '画像统计',
    ecosystemMallPortraitsStatEntTotal: '企业画像数',
    ecosystemMallPortraitsStatUserTotal: '用户画像数',
    ecosystemMallPortraitsChartType: '企业 · 主体类型分布',
    ecosystemMallPortraitsChartBrand: '企业 · 品牌树语境',
    ecosystemMallPortraitsChartHabit: '企业 · 习惯域 Top 命中',
    ecosystemMallPortraitsChartLifecycle: '企业 · 生命周期分群',
    ecosystemMallPortraitsKpiOverrideRate: '身份覆写率 I-1',
    ecosystemMallPortraitsColHabit: '习惯 Top',
    ecosystemMallPortraitsColCommercial: '商业两类',
    ecosystemMallPortraitsColScale: '规模(机/店/活)',
    ecosystemMallPortraitsColLifecycle: '生命周期',
    ecosystemMallPortraitsCommercialFilter: '商业画像',
    ecosystemMallPortraitsLifecycleFilter: '生命周期',
    ecosystemMallPortraitsCommercialVendor: '设备商',
    ecosystemMallPortraitsCommercialChain: '实体连锁运营商',
    ecosystemMallPortraitsLifecycleChampion: '冠军',
    ecosystemMallPortraitsLifecycleGrowing: '成长',
    ecosystemMallPortraitsLifecycleStable: '稳定',
    ecosystemMallPortraitsLifecycleAtRisk: '流失风险',
    ecosystemMallPortraitsLifecycleDormant: '沉睡',
    ecosystemMallPortraitsScaleSummary: '机{eq}／店{kids}／活{days}天',
    ecosystemMallPortraitsExplainTitle: '为何是这类／这群',
    ecosystemMallPortraitsHabitProduce: '出品配方',
    ecosystemMallPortraitsHabitMaterial: '物料BOM',
    ecosystemMallPortraitsHabitDevice: '设备机队',
    ecosystemMallPortraitsHabitAfterSales: '售后维保',
    ecosystemMallPortraitsHabitData: '数据分析',
    ecosystemMallPortraitsHabitStore: '店务订单',
    ecosystemMallPortraitsHabitHq: '总部组织',
    ecosystemMallPortraitsHabitMonetization: '加购计费',
    ecosystemMallPortraitsHabitOther: '其他',
    ecosystemMallPortraitsTabEnterprise: '企业画像',
    ecosystemMallPortraitsTabUser: '用户画像',
    ecosystemMallPortraitsTypeFilter: '主体类型',
    ecosystemMallPortraitsStatusFilter: 'SOC租户状态',
    ecosystemMallPortraitsBrandCtxFilter: '品牌树语境',
    ecosystemMallPortraitsColBrandCtx: '品牌树',
    ecosystemMallPortraitsStatusOemSelf: '设备商自身',
    ecosystemMallPortraitsStatusDistSelf: '分销商自身',
    ecosystemMallPortraitsStatusSocBrand: '独立SOC品牌',
    ecosystemMallPortraitsStatusDeviceCust: '设备商下客户',
    ecosystemMallPortraitsStatusUnknown: '未知',
    ecosystemMallPortraitsBrandCtxRoot: '根／独立',
    ecosystemMallPortraitsBrandCtxPhysical: '实体品牌树下',
    ecosystemMallPortraitsBrandCtxOem: '设备商树下',
    ecosystemMallPortraitsTypeOem: '设备生产商',
    ecosystemMallPortraitsLeoXidInstalled: 'Leo App · 已装 X-ID',
    ecosystemMallPortraitsLeoXidActive30d: 'Leo App · 30天活跃 X-ID',
    ecosystemMallPortraitsColLeoApp: 'Leo App',
    ecosystemMallPortraitsLeoStatusActive: '30天活跃',
    ecosystemMallPortraitsLeoStatusInstalled: '已安装',
    ecosystemMallPortraitsLeoStatusNotInstalled: '未安装',
    ecosystemMallPortraitsLeoEntSummary: '已装 {installed} · 活跃 {active}',
    ecosystemMallPortraitsLeoAppFilter: 'Leo App 状态',
    ecosystemMallPortraitsLeoPushBannerTitle: '现客一轮：推广 Leo 手机智能助手',
    ecosystemMallPortraitsLeoPushBannerDesc: '还有客户未装 Leo App。请到应用下载页分享给同事，同一 Xrross 账号免费安装。',
    ecosystemMallPortraitsLeoPushCta: '去应用下载',
    ecosystemMallAppDlSmartTitle: 'Leo 手机智能助手',
    ecosystemMallAppDlShareColleague: '分享给同事',
    ecosystemMallAppDlShareOk: '分享卡已就绪',
    ecosystemMallAppDlShareFail: '分享失败，请稍后再试',
    ecosystemMallPortraitsTypeDistributor: '业务分销商',
    ecosystemMallPortraitsTypePhysical: '实体连锁运营者',
    ecosystemMallPortraitsReload: '重新载入',
    ecosystemMallPortraitsRecompute: '重算画像',
    ecosystemMallPortraitsRecomputeOk: '重算完成',
    ecosystemMallPortraitsRecomputeFail: '重算失败',
    ecosystemMallPortraitsLoadFail: '载入失败',
    ecosystemMallPortraitsColName: '企业名',
    ecosystemMallPortraitsColAccount: '账号',
    ecosystemMallPortraitsColEnterpriseId: '企业ID',
    ecosystemMallPortraitsColType: '画像类型',
    ecosystemMallPortraitsColStatus: 'SOC租户状态',
    ecosystemMallPortraitsColConfidence: '置信度',
    ecosystemMallPortraitsColComputed: '计算时间',
    ecosystemMallPortraitsColActions: '操作',
    ecosystemMallPortraitsSignals: '信号',
    ecosystemMallPortraitsOverride: '覆写',
    ecosystemMallPortraitsOverrideOk: '已覆写锁定',
    ecosystemMallPortraitsOverrideOkDetail: '已覆写锁定为「{type}」（请看「类型」栏；OEM／分销在「商业」栏都显示设备商属正常）',
    ecosystemMallPortraitsOverrideFail: '覆写失败',
    ecosystemMallPortraitsLocked: '已锁定',
    ecosystemMallPortraitsUnlock: '解锁',
    ecosystemMallPortraitsUnlockConfirm: '解锁后将按组织基线重算类型，确定？',
    ecosystemMallPortraitsUnlockOk: '已解锁并重算',
    ecosystemMallPortraitsUnlockFail: '解锁失败',
    ecosystemMallPortraitsColDeviceMode: '机队用法',
    ecosystemMallPortraitsDeviceModeFilter: '机队用法',
    ecosystemMallPortraitsDeviceNoFleet: '无机队',
    ecosystemMallPortraitsDeviceIdle: '机队闲置',
    ecosystemMallPortraitsDeviceOffline: '离线偏重',
    ecosystemMallPortraitsDeviceLowOut: '在线低产',
    ecosystemMallPortraitsDeviceHigh: '高产出',
    ecosystemMallPortraitsDeviceOps: '运维偏密',
    ecosystemMallPortraitsDeviceFault: '故障关注',
    ecosystemMallPortraitsDeviceBalanced: '运转平衡',
    ecosystemMallPortraitsAdvice: '建议',
    ecosystemMallPortraitsAdviceTitle: '机队建议（可执行）',
    ecosystemMallPortraitsAdviceNext: '下一步：',
    ecosystemMallPortraitsKpiAdviceP1: '优先建议数',
    ecosystemMallPortraitsDeviceUsageSummary: '在线 {online}/{eq} · 出杯 {cups} · 运维 {ops} · 闲置机 {idle}',
    ecosystemMallImmersivePromo: '沉浸推广',
    ecosystemMallAdOrchestrate: '广告编排',
    ecosystemMallChannelCommand: '渠道总控',
    ecosystemMallBEndCrm: 'B端CRM',
    ecosystemMallPromoContent: '推广内容',
    ecosystemMallCompanyPay: '公司收款',
    ecosystemMallCompanyPayDesc: '海外收款 Stripe 为主、PayPal 并存；国内微信另线。App／官网卖货进公司户。Stub 不是真收款。',
    ecosystemMallCompanyPayReload: '重新加载',
    ecosystemMallCompanyPayChannel: '来源',
    ecosystemMallCompanyPayOrderNo: '订单号',
    ecosystemMallCompanyPaySku: '商品',
    ecosystemMallCompanyPayName: '名称',
    ecosystemMallCompanyPayAmount: '金额',
    ecosystemMallCompanyPayStatus: '状态',
    ecosystemMallCompanyPayEmail: 'Email',
    ecosystemMallCompanyPayTracking: '物流单号',
    ecosystemMallCompanyPayAction: '操作',
    ecosystemMallCompanyPayShip: '发货',
    ecosystemMallCompanyPayLedger: 'PayPal 账本',
    ecosystemMallCompanyPayIntent: '账本号',
    ecosystemMallCompanyPaySurface: '面',
    ecosystemMallCompanyPayRef: '本地单',
    ecosystemMallCompanyPayTime: '时间',
    ecosystemMallCompanyPayCarrier: '承运商',
    ecosystemMallCompanyPayCancel: '取消',
    ecosystemMallCompanyPayShipOk: '确认发货',
    ecosystemMallHomeCheckoutTitle: '家用直购结账',
    ecosystemMallHomeCheckoutDesc: '选商品、填收货地址，再用 PayPal 安全付款；完成后会寄确认信到你的 Email。',
    ecosystemMallHomeCheckoutBackTopology: '回拓扑',
    ecosystemMallHomeCheckoutReload: '重新加载',
    ecosystemMallHomeCheckoutNextAddress: '下一步：填收货地址',
    ecosystemMallHomeCheckoutBackSku: '回选商品',
    ecosystemMallHomeCheckoutPlaceOrder: '确认下单',
    ecosystemMallHomeCheckoutPayStripe: 'Stripe 付款',
    ecosystemMallHomeCheckoutPayPaypal: 'PayPal 付款',
    ecosystemMallHomeCheckoutCapture: '确认已付款（测试）',
    ecosystemMallHomeCheckoutCaptureLive: '我已完成 PayPal 付款',
    ecosystemMallHomeCheckoutBuyPanel: '立即购买',
    ecosystemMallHomeCheckoutEmptyCatalog: '目前暂无可购买商品，请稍后再试',
    ecosystemMallHomeCheckoutSku: '商品',
    ecosystemMallHomeCheckoutQty: '数量',
    ecosystemMallHomeCheckoutName: '收货人',
    ecosystemMallHomeCheckoutPhone: '电话',
    ecosystemMallHomeCheckoutEmail: 'Email',
    ecosystemMallHomeCheckoutAddress: '地址',
    ecosystemMallHomeCheckoutCity: '城市',
    ecosystemMallHomeCheckoutPostal: '邮编',
    ecosystemMallHomeCheckoutCountry: '国家',
    ecosystemMallHomeCheckoutPayChannel: '付款方式',
    ecosystemMallHomeCheckoutOrderLine: '订单 {no} · {status} · {amount}',
    ecosystemMallHomeCheckoutStubNote: '测试模式（仅超管）：点「确认已付款」可走完验收，不是真收款。',
    ecosystemMallHomeCheckoutStripeDefaultHint: '海外默认 Stripe（也可改 PayPal）',
    ecosystemMallHomeCheckoutStripeTabHint: '请在 Stripe 窗口完成付款；付完后可查订单／收邮件通知。',
    ecosystemMallHomeCheckoutStripeOpened: '已开启 Stripe，请在该窗口完成付款',
    ecosystemMallHomeCheckoutPaypalTabHint: '请在 PayPal 窗口完成付款，再回来点「我已完成 PayPal 付款」。',
    ecosystemMallHomeCheckoutBuyAgain: '再买一台',
    ecosystemMallHomeCheckoutHqOrders: '订单账本（总部履约）',
    ecosystemMallHomeCheckoutNoOrders: '暂无订单',
    ecosystemMallHomeCheckoutWechat: '微信支付',
    ecosystemMallHomeCheckoutStepSku: '选商品',
    ecosystemMallHomeCheckoutStepAddress: '填地址',
    ecosystemMallHomeCheckoutStepPay: '付款',
    ecosystemMallHomeCheckoutStepDone: '完成',
    ecosystemMallHomeCheckoutCoachSku: '请选要购买的商品',
    ecosystemMallHomeCheckoutCoachAddress: '请填收货信息',
    ecosystemMallHomeCheckoutCoachPay: '请完成付款',
    ecosystemMallHomeCheckoutCoachDone: '已付款',
    ecosystemMallHomeCheckoutHintSku: '点选商品卡片后继续。',
    ecosystemMallHomeCheckoutHintAddress: 'Email 用于订单确认与 PayPal。',
    ecosystemMallHomeCheckoutHintPay: '用 PayPal 付款，完成后回来确认即可。',
    ecosystemMallHomeCheckoutNeedSku: '请先选商品',
    ecosystemMallHomeCheckoutCatalogFail: '商品加载失败，请稍后再试',
    ecosystemMallHomeCheckoutSkuNoPrice: '此商品暂无标价，可留下意向再讨论，或改选其他商品。',
    ecosystemMallHomeCheckoutHqFail: '订单账本加载失败（非超管可略过）',
    ecosystemMallHomeCheckoutNeedName: '请填收货人',
    ecosystemMallHomeCheckoutNeedPhone: '请填电话',
    ecosystemMallHomeCheckoutNeedEmail: '请填有效 Email',
    ecosystemMallHomeCheckoutNeedAddress: '请填地址',
    ecosystemMallHomeCheckoutNeedCity: '请填城市',
    ecosystemMallHomeCheckoutNeedCountry: '请填国家',
    ecosystemMallHomeCheckoutNeedLogin: '请先登录再结账',
    ecosystemMallHomeCheckoutOrderCreated: '订单已建立，请继续付款',
    ecosystemMallHomeCheckoutOrderFail: '下单未成功，请检查资料后再试',
    ecosystemMallHomeCheckoutNeedOrder: '请先下单',
    ecosystemMallHomeCheckoutPaypalStub: '测试 PayPal 已就绪（超管可确认付款）',
    ecosystemMallHomeCheckoutPaypalOpened: '已开启 PayPal，请在该窗口完成付款',
    ecosystemMallHomeCheckoutPayFail: '暂时无法开始付款，请稍后再试',
    ecosystemMallHomeCheckoutPaid: '已收到付款，谢谢！',
    ecosystemMallHomeCheckoutPaidThanks: '订单 {no} 已付款。确认信已寄至 {email}，发货后会再通知。',
    ecosystemMallHomeCheckoutStatusPaid: '已付款',
    ecosystemMallHomeCheckoutStatusPending: '待付款',
    ecosystemMallHomeCheckoutStatusShipped: '已发货',
    ecosystemMallHomeCheckoutCaptureFail: '尚无法确认付款。若已在 PayPal 付过，请稍候再试一次。',
    ecosystemMallHomeCheckoutWechatFail: '无法开微信支付',
    ecosystemMallHomeCheckoutNeedTracking: '请填物流单号',
    ecosystemMallHomeCheckoutShipFail: '发货失败',
    ecosystemMallCompanyPayLive: 'PayPal 凭证已配置（sandbox／live）',
    ecosystemMallCompanyPayLiveMode: 'PayPal Live — 真收款',
    ecosystemMallCompanyPaySandboxMode: 'PayPal Sandbox — 测试单',
    ecosystemMallCompanyPayStub: '目前为 stub，不是真收款',
    ecosystemMallCompanyPayLoadFail: '加载失败（须超管）',
    ecosystemMallCompanyPayNeedTracking: '请填物流单号',
    ecosystemMallCompanyPayShipped: '已标记发货',
    ecosystemMallCompanyPayShipFail: '发货失败',
    ecosystemMallCompanyPayEmptyOrders: '暂无卖货订单',
    ecosystemMallCompanyPayEmptyLedger: '暂无收款账本',
    ecosystemMallCompanyPayStubCol: '是否模拟',
    ecosystemMallCompanyPayStubYes: '是（模拟）',
    ecosystemMallCompanyPayKindHome: '家用 App',
    ecosystemMallCompanyPayKindWebsite: '官网',
    ecosystemMallCompanyPayStatusPending: '待付款',
    ecosystemMallCompanyPayStatusPaid: '已付款',
    ecosystemMallCompanyPayStatusShipped: '已发货',
    ecosystemMallCompanyPayStatusDelivered: '已送达',
    ecosystemMallCompanyPayStatusBound: '已绑机',
    ecosystemMallCompanyPayStatusCancelled: '已取消',
    ecosystemMallCompanyPayIntentCreated: '已建单',
    ecosystemMallCompanyPayIntentApproved: '已授权',
    ecosystemMallCompanyPayIntentCaptured: '已入账',
    ecosystemMallCompanyPayIntentCapturedStub: '模拟入账',
    ecosystemMallCompanyPayIntentFailed: '失败',
    ecosystemMallCompanyPaySurfaceHome: '家用直购',
    ecosystemMallCompanyPaySurfaceWebsite: '官网结账',
    ecosystemMallCompanyPaySurfaceAddon: 'SOC 加购',
    ecosystemMallCompanyPaySurfacePlan: '商业计划',
    ecosystemMallCompanyPaySurfaceContract: '品牌合同',
    ecosystemMallPriceBook: '价目表',
    ecosystemMallBillingPromo: '计费促销',
    ecosystemMallBillingPromoDesc: '定义品牌商签约促销活动，并向指定品牌发放优惠券；标价仍以价目表为准，优惠券仅在结账时减免。',
    ecosystemMallBillingPromoHqOnly: '计费促销仅平台总部可用；品牌商请使用「服务签约」查看合同与付款。',
    ecosystemMallBillingPromoReload: '重新加载',
    ecosystemMallBillingPromoNewCampaign: '新建活动',
    ecosystemMallBillingPromoNlCompose: '口语创建',
    ecosystemMallBillingPromoNlComposeTitle: '用自然语言描述优惠',
    ecosystemMallBillingPromoNlComposeHint: '例如：品牌 1119 加购 Track B 减 1000 元，领券后 30 天有效。解析后请在表单确认再保存。',
    ecosystemMallBillingPromoNlComposePh: '口述优惠玩法、对象、核销范围与有效期…',
    ecosystemMallBillingPromoNlComposeParse: '解析预览',
    ecosystemMallBillingPromoNlComposeApply: '填入表单',
    ecosystemMallBillingPromoNlComposeSummary: '解析摘要',
    ecosystemMallBillingPromoNlComposeConfidence: '置信度',
    ecosystemMallBillingPromoNlComposeWarnings: '待确认',
    ecosystemMallBillingPromoEditCampaign: '编辑活动',
    ecosystemMallBillingPromoTabCampaigns: '促销活动',
    ecosystemMallBillingPromoTabCoupons: '已发优惠券',
    ecosystemMallBillingPromoColName: '活动名称',
    ecosystemMallBillingPromoColKind: '活动类型',
    ecosystemMallBillingPromoColOffer: '优惠方式',
    ecosystemMallBillingPromoColAudience: '适用对象',
    ecosystemMallBillingPromoColStatus: '状态',
    ecosystemMallBillingPromoColCouponCode: '优惠券编号',
    ecosystemMallBillingPromoColCampaign: '所属活动',
    ecosystemMallBillingPromoColIssued: '发放时间',
    ecosystemMallBillingPromoActivate: '启用',
    ecosystemMallBillingPromoPause: '暂停',
    ecosystemMallBillingPromoIssue: '发券',
    ecosystemMallBillingPromoRevoke: '作废',
    ecosystemMallBillingPromoManualIssue: '手动发券',
    ecosystemMallBillingPromoBrandId: '品牌商',
    ecosystemMallBillingPromoBrandIdPh: '请输入品牌商编号',
    ecosystemMallBillingPromoBrandIds: '指定品牌商',
    ecosystemMallBillingPromoBrandIdsHint: '多个编号请用逗号分隔',
    ecosystemMallBillingPromoFilterCampaign: '筛选活动',
    ecosystemMallBillingPromoFilterStatus: '状态筛选',
    ecosystemMallBillingPromoSearch: '搜寻',
    ecosystemMallBillingPromoOfferPct: '折扣比例（%）',
    ecosystemMallBillingPromoCampaignValidity: '活动有效期',
    ecosystemMallBillingPromoCouponValidity: '优惠券有效期',
    ecosystemMallBillingPromoRelativeDays: '发券后有效天数',
    ecosystemMallBillingPromoNamePh: '例如：新客首年八折',
    ecosystemMallBillingPromoNameRequired: '请填写活动名称',
    ecosystemMallBillingPromoEmpty: '暂无数据',
    ecosystemMallBillingPromoSaved: '活动已保存',
    ecosystemMallBillingPromoIssued: '优惠券已发放',
    ecosystemMallBillingPromoRevoked: '优惠券已作废',
    ecosystemMallBillingPromoStatusUpdated: '活动状态已更新',
    ecosystemMallBillingPromoEnum_status_ALL: '全部',
    ecosystemMallBillingPromoEnum_status_DRAFT: '草稿',
    ecosystemMallBillingPromoEnum_status_ACTIVE: '进行中',
    ecosystemMallBillingPromoEnum_status_PAUSED: '已暂停',
    ecosystemMallBillingPromoEnum_status_ARCHIVED: '已归档',
    ecosystemMallBillingPromoEnum_status_EXPIRED: '已过期',
    ecosystemMallBillingPromoEnum_couponStatus_ALL: '全部',
    ecosystemMallBillingPromoEnum_couponStatus_ISSUED: '已发放',
    ecosystemMallBillingPromoEnum_couponStatus_REDEEMED: '已核销',
    ecosystemMallBillingPromoEnum_couponStatus_EXPIRED: '已过期',
    ecosystemMallBillingPromoEnum_couponStatus_REVOKED: '已作废',
    ecosystemMallBillingPromoEnum_kind_STANDARD_PACK: '标准套餐',
    ecosystemMallBillingPromoEnum_kind_SEASONAL: '限期大促',
    ecosystemMallBillingPromoEnum_kind_TARGETED: '定向大客户',
    ecosystemMallBillingPromoEnum_kind_AI_ORCHESTRATED: '智能推广',
    ecosystemMallBillingPromoEnum_offer_DISCOUNT_PCT: '百分比折扣',
    ecosystemMallBillingPromoEnum_offer_DISCOUNT_FIXED: '固定金额减免',
    ecosystemMallBillingPromoEnum_offer_BUNDLE_PRICE_CAP: '打包封顶价',
    ecosystemMallBillingPromoEnum_offer_FREE_TRIAL_EXTEND: '延长试用',
    ecosystemMallBillingPromoEnum_offer_CROSS_GRANT: '交叉赠券',
    ecosystemMallBillingPromoEnum_offer_AI_POINTS_BONUS: '赠送 AI 点数',
    ecosystemMallBillingPromoEnum_audience_ALL_ELIGIBLE_BRANDS: '全部合格品牌商',
    ecosystemMallBillingPromoEnum_audience_BRAND_ALLOWLIST: '指定品牌白名单',
    ecosystemMallBillingPromoEnum_audience_BRAND_DENYLIST: '黑名单排除',
    ecosystemMallBillingPromoEnum_audience_PORTRAIT_QUERY: '依客户画像',
    ecosystemMallBillingPromoEnum_audience_AI_AGENT: '智能圈选',
    ecosystemMallBillingPromoEnum_audience_HYBRID: '规则与智能混合',
    ecosystemMallBillingPromoEnum_campaignValidity_PERMANENT: '永久有效',
    ecosystemMallBillingPromoEnum_campaignValidity_FIXED_WINDOW: '固定时段',
    ecosystemMallBillingPromoEnum_couponValidity_PERMANENT_UNTIL_REDEEMED: '永久（至核销）',
    ecosystemMallBillingPromoEnum_couponValidity_RELATIVE_FROM_ISSUE: '发券后 N 天',
    ecosystemMallBillingPromoEnum_couponValidity_INHERIT_CAMPAIGN: '跟随活动期',
    ecosystemMallBillingPromoSectionOffer: '优惠配置',
    ecosystemMallBillingPromoSectionAudience: '精准客群',
    ecosystemMallBillingPromoSectionCrossSell: '连带推销',
    ecosystemMallBillingPromoRedeemTarget: '核销范围',
    ecosystemMallBillingPromoGrantScope: '发券绑定',
    ecosystemMallBillingPromoTriggerEvent: '自动触发',
    ecosystemMallBillingPromoAutoIssue: '达成条件后自动发券',
    ecosystemMallBillingPromoTracksMissing: '缺档产品线（交叉促销）',
    ecosystemMallBillingPromoUserIds: '指定账号',
    ecosystemMallBillingPromoUserIdsHint: '多个用户编号以逗号分隔，千人千面精准发券',
    ecosystemMallBillingPromoColGrantScope: '绑定范围',
    ecosystemMallBillingPromoColUser: '指定账号',
    ecosystemMallBillingPromoColRedeemTarget: '核销于',
    ecosystemMallBillingPromoUserIdPh: '请输入用户编号（可选）',
    ecosystemMallBillingPromoOfferFixed: '减免金额',
    ecosystemMallBillingPromoTrialDays: '延长试用（天）',
    ecosystemMallBillingPromoBonusPoints: '赠送 AI 点数',
    ecosystemMallBillingPromoBundleCap: '打包封顶价',
    ecosystemMallBillingPromoBundleSkus: '打包 SKU',
    ecosystemMallBillingPromoCrossGrantSku: '交叉赠送 SKU',
    ecosystemMallBillingPromoCrossGrantHint: '例：已开 Track B 可发设备／Leo 加购券，支持硬件＋软件连带',
    ecosystemMallBillingPromoEnum_audience_USER_ALLOWLIST: '指定账号白名单',
    ecosystemMallBillingPromoEnum_redeemTarget_ANY_BILLING_CHECKOUT: '合并结账台',
    ecosystemMallBillingPromoEnum_redeemTarget_TRACK_A_CONTRACT: 'Track A 设备数据合同',
    ecosystemMallBillingPromoEnum_redeemTarget_TRACK_B_ADDON: 'Track B SOC／Leo 加购',
    ecosystemMallBillingPromoEnum_redeemTarget_HARDWARE_ORDER: '硬件采购单',
    ecosystemMallBillingPromoEnum_grantScope_BRAND: '品牌商共享',
    ecosystemMallBillingPromoEnum_grantScope_ENTERPRISE_NODE: '组织节点',
    ecosystemMallBillingPromoEnum_grantScope_STORE: '单店',
    ecosystemMallBillingPromoEnum_grantScope_USER: '指定账号独享',
    ecosystemMallBillingPromoEnum_grantScope_PORTRAIT_COHORT: '画像分群',
    ecosystemMallBillingPromoEnum_trigger_MANUAL_HQ: 'HQ 手动',
    ecosystemMallBillingPromoEnum_trigger_TRACK_A_ACTIVE: 'Track A 签约生效',
    ecosystemMallBillingPromoEnum_trigger_TRACK_B_ACTIVE: 'Track B 加购生效',
    ecosystemMallBillingPromoEnum_trigger_HARDWARE_PAID: '硬件付款完成',
    ecosystemMallBillingPromoEnum_trigger_AI_ISSUE: '智能推广发券',
    ecosystemMallBillingPromoEnum_tracksMissing_TRACK_A: '尚未开通 Track A',
    ecosystemMallBillingPromoEnum_tracksMissing_TRACK_B: '尚未开通 Track B',
    mySubscriptionPlan: '我的方案',
    mySubscriptionPlanDesc: '已签档位摘要与 A/B 线说明；签约与付款走签约台，价格与促销见生态商城。',
    mySubscriptionPlanGoContract: '打开签约台',
    mySubscriptionPlanGoMall: '去商城看价格',
    mySubscriptionPlanGoPriceBook: 'HQ 价目表',
    mySubscriptionPlanTiersTitle: '四档月费（USD）',
    mySubscriptionPlanTierCol: '档',
    mySubscriptionPlanSceneCol: '适用场景',
    mySubscriptionPlanPriceCol: '月费',
    mySubscriptionPlanTrackCol: 'Track',
    mySubscriptionPlanTier1Scene: '纯 SOC，无自动生产设备',
    mySubscriptionPlanTier2Scene: '全店打包（SOC + 全部自动生产设备，台数不限）',
    mySubscriptionPlanTier3Scene: '纯设备数据，不含 SOC 店务',
    mySubscriptionPlanTier3Price: '按台月费（茶/咖/饮料 $10，PT5 $5）',
    mySubscriptionPlanTier4Scene: 'SOC + 设备（非 $199 全店打包）',
    mySubscriptionPlanHint: '② 与 ④ 同店互斥；实际签约以签约台为准；标价与促销以生态商城为准。',
    subscriptionBillingFolder: '订阅与账单',
    deviceEndpointDataFolder: '机端数据',
    mallPricingCollectFolder: '定价与收款',
    ecosystemMallPriceBookDesc: '加购与家用硬件标价真源。仅东京 HQ 可改未税价／税区；本区若为边缘则只读镜像。PayPal 用 USD，微信用 CNY。',
    ecosystemMallPriceBookEdgeBanner: '改价由东京总部全球统一。本区只读镜像；东京不可用时卖场以最后一次扇出为准，禁止在本区新增或改价。',
    ecosystemMallPriceBookTokyoBanner: '本区是全球写入中心。保存未税标价／税区后会扇出到 111 与已跟读产区。',
    ecosystemMallPriceBookReload: '重新加载',
    ecosystemMallPriceBookRefreshFx: '刷新汇率',
    ecosystemMallPriceBookFxNote: '汇率 {asOf} · {src}（1 USD）',
    ecosystemMallPriceBookFxTaxPanel: '汇率与税区 · {fx} · 税区 {taxCount} 条',
    ecosystemMallPriceBookFxSection: 'USD 汇率',
    ecosystemMallPriceBookStale: '汇率超过 48 小时未刷新，请点刷新或等每日自动拉取',
    ecosystemMallPriceBookCoverageGap: '尚有 {count} 项功能或设备未在价目表定价（OFF/缺价），签约与加购将被拦截，请补价并启用',
    ecosystemMallPriceBookCcy: '币种',
    ecosystemMallPriceBookRatePerUsd: '对 1 USD',
    ecosystemMallPriceBookSkus: 'SKU 标价',
    ecosystemMallPriceBookKind: '类型',
    ecosystemMallPriceBookSku: 'SKU',
    ecosystemMallPriceBookName: '名称',
    ecosystemMallPriceBookList: '标价',
    ecosystemMallPriceBookListExTax: '标价（未税）',
    ecosystemMallPriceBookExTaxBanner: '全球一套未税标价；各地税点在「税区」维护，签约报价时再加税。',
    ecosystemMallPriceBookTaxRegions: '节点税区（本地加税）',
    ecosystemMallPriceBookTaxRegionsHint: '价目表不含税。CN=软件服务6%，CN_HW=硬件货物13%；报价选税区后自动加税。',
    ecosystemMallPriceBookTaxRegionCode: '税区码',
    ecosystemMallPriceBookTaxRegionName: '税区名称',
    ecosystemMallPriceBookTaxName: '税种',
    ecosystemMallPriceBookTaxRate: '税率',
    ecosystemMallPriceBookTaxNotes: '备注',
    ecosystemMallPriceBookTaxEditTitle: '编辑税区',
    ecosystemMallPriceBookLoadFail: '加载失败（须超管）',
    ecosystemMallPriceBookRefreshOk: '汇率已更新',
    ecosystemMallPriceBookRefreshFail: '汇率刷新失败',
    ecosystemMallPriceBookAdd: '新增',
    ecosystemMallPriceBookEdit: '编辑',
    ecosystemMallPriceBookSave: '保存',
    ecosystemMallPriceBookSaveOk: '已保存',
    ecosystemMallPriceBookSaveFail: '保存失败',
    ecosystemMallPriceBookKindAddon: '加购',
    ecosystemMallPriceBookKindHome: '家用硬件',
    ecosystemMallPriceBookKindCommercial: '商用硬件',
    ecosystemMallPriceBookListCcy: '标价币',
    ecosystemMallPriceBookListedHkd: '目录 HKD',
    ecosystemMallPriceBookColumnPricing: '计费',
    ecosystemMallPriceBookPricingSection: '计价方式',
    ecosystemMallPriceBookPaymentSection: '付款模板',
    ecosystemMallPriceBookProductClass: '产品类',
    ecosystemMallPriceBookProductSoc: 'SOC 软件',
    ecosystemMallPriceBookProductDeviceData: '设备数据/后台',
    ecosystemMallPriceBookProductHardware: '硬件本体',
    ecosystemMallPriceBookProductAiPoints: 'AI 点数',
    ecosystemMallPriceBookBillingCycle: '计费周期',
    ecosystemMallPriceBookUnitPrice: '单价',
    ecosystemMallPriceBookMinContractMonths: '最少签约月数',
    ecosystemMallPriceBookDayCountHint: '按天现结',
    ecosystemMallPriceBookDayCountHintBody: '签约时填使用天数；价目表只定「每天单价」。',
    ecosystemMallPriceBookTiers: '阶梯价',
    ecosystemMallPriceBookDeviceCountTiers: '台数阶梯折扣',
    ecosystemMallPriceBookDeviceCountTiersHint: '单台底价按本行标价；各档折扣相对底价。未设单价视为 0。',
    ecosystemMallPriceBookDeviceCountTierBand: '档位',
    ecosystemMallPriceBookDeviceCountTierMin: '最少台',
    ecosystemMallPriceBookDeviceCountTierMax: '最多台',
    ecosystemMallPriceBookDeviceCountTierDiscount: '折扣系数',
    ecosystemMallPriceBookDeviceCountTierNegotiated: '总部协商',
    ecosystemMallPriceBookDeviceCountTierReset: '恢复标准五档',
    ecosystemMallPriceBookStoreCountTiers: '店数阶梯折扣',
    ecosystemMallPriceBookStoreCountTiersHint: '单店底价按本行标价；各档折扣相对底价。0 店＝0 元。',
    ecosystemMallPriceBookStoreCountTierBand: '档位',
    ecosystemMallPriceBookStoreCountTierMin: '最少店',
    ecosystemMallPriceBookStoreCountTierMax: '最多店',
    ecosystemMallPriceBookStoreCountTierDiscount: '折扣系数',
    ecosystemMallPriceBookStoreCountTierNegotiated: '总部协商',
    ecosystemMallPriceBookStoreCountTierReset: '恢复标准五档',
    ecosystemMallPriceBookAddTier: '加阶梯',
    ecosystemMallPriceBookRemoveTier: '删除',
    ecosystemMallPriceBookTrialDays: '试用天数',
    ecosystemMallPriceBookCancelAnytime: '随时可取消',
    ecosystemMallPriceBookDefaultPayment: '默认付款',
    ecosystemMallPriceBookPayNet: '放账',
    ecosystemMallPriceBookPayPrepaid: '预付全款',
    ecosystemMallPriceBookPayDeposit: '定金+尾款',
    ecosystemMallPriceBookPayInstallment: '分期',
    ecosystemMallPriceBookDepositPct: '订金比例%',
    ecosystemMallPriceBookStatus: '状态',
    ecosystemMallPriceBookStatusActive: '启用',
    ecosystemMallPriceBookStatusOff: '停用',
    ecosystemMallPriceBookNameZh: '简中名',
    ecosystemMallPriceBookNameTw: '繁中名',
    ecosystemMallPriceBookNameEn: '英文名',
    ecosystemMallPriceBookNameJa: '日文名',
    ecosystemMallPriceBookCancel: '取消',
    ecosystemMallPriceBookFilterPreset: '快捷筛选',
    ecosystemMallPriceBookPresentationTab: '客户分块 L0–L6',
    ecosystemMallPriceBookPresentationTabAll: '全部',
    ecosystemMallPriceBookBlock_FREE_INCLUDED: 'L0 · 买机已含',
    ecosystemMallPriceBookBlock_BUNDLE_TIER: 'L1 · 月费套餐',
    ecosystemMallPriceBookBlock_TRACK_A: 'L2 · 设备数据',
    ecosystemMallPriceBookBlock_TRACK_B: 'L3 · 店铺运营',
    ecosystemMallPriceBookBlock_BUNDLE_DISCOUNT: 'L4 · 组合说明',
    ecosystemMallPriceBookBlock_HARDWARE: 'L5 · 硬件',
    ecosystemMallPriceBookBlock_AI_POINTS: 'L6 · 消耗点数',
    ecosystemMallPriceBookBlockDesc_FREE_INCLUDED: '买机／开店已含：Leo 基础、基础店务可见，不另收月费。',
    ecosystemMallPriceBookBlockDesc_BUNDLE_TIER: '四档月费套餐：客户先选购法，再对应下方 SKU 标价。',
    ecosystemMallPriceBookBlockDesc_TRACK_A: 'Track A · 按台设备数据／连云月费（茶机、咖啡机等）。',
    ecosystemMallPriceBookBlockDesc_TRACK_B: 'Track B · 按店／模块的 SOC 店务加购（店务进阶、总部、金流等）。',
    ecosystemMallPriceBookBlockDesc_BUNDLE_DISCOUNT: '套餐互斥与升级规则：② 全店打包 vs ④ SOC+按台 同店只能二选一。',
    ecosystemMallPriceBookBlockDesc_HARDWARE: '一次性硬件采购标价（非月费）。',
    ecosystemMallPriceBookBlockDesc_AI_POINTS: 'AI 点数等按量消耗包。',
    ecosystemMallPriceBookBundleColTier: '档',
    ecosystemMallPriceBookBundleColPlan: '套餐',
    ecosystemMallPriceBookBundleColScenario: '客户场景',
    ecosystemMallPriceBookBundleColIncludes: '含什么',
    ecosystemMallPriceBookBundleT1Title: '① 纯 SOC $49/店/月',
    ecosystemMallPriceBookBundleT1Desc: '要用店务／SOC，店内没有自动生产设备',
    ecosystemMallPriceBookBundleT1Includes: '标准 SOC 运营模块；不含 A 线设备数据',
    ecosystemMallPriceBookBundleT2Title: '② 全店打包 $199/店/月',
    ecosystemMallPriceBookBundleT2Desc: '店内有自动生产设备（现制饮品等），台数不限',
    ecosystemMallPriceBookBundleT2Includes: 'SOC + 该店所有自动生产设备数据费（同一店内台数不限）',
    ecosystemMallPriceBookBundleT3Title: '③ 纯设备按台',
    ecosystemMallPriceBookBundleT3Desc: '只要机器连云，不要 SOC 店务包',
    ecosystemMallPriceBookBundleT3Includes: '仅 A 线设备数据月费；不含 SOC',
    ecosystemMallPriceBookBundleT3PriceHint: '按台标准月费（见右侧 SKU）',
    ecosystemMallPriceBookBundleT4Title: '④ SOC $99 + 按台',
    ecosystemMallPriceBookBundleT4Desc: '既要 SOC 又要设备，但不走 $199 全店打包',
    ecosystemMallPriceBookBundleT4Includes: 'SOC 基础 $99/店/月 + 每台设备数据费另计',
    ecosystemMallPriceBookBundleRuleT2T4Title: '② 与 ④ 同店互斥',
    ecosystemMallPriceBookBundleRuleT2T4Body: '同一店、同一账期只能选一种：要么 $199 全包，要么 $99 底费 + 按台加计；不可叠加。',
    ecosystemMallPriceBookBundleRuleUpgradeTitle: '升级路径',
    ecosystemMallPriceBookBundleRuleUpgradeBody: '① 纯 SOC 后来接自动生产设备 → 须升级到 ④ 或 ②；③ 纯设备加购 SOC → 转 ④ 或（若符合）②。',
    ecosystemMallPriceBookBundleRulePromoTitle: '① 推广价',
    ecosystemMallPriceBookBundleRulePromoBody: '$49 为推广期标价；Campaign 结束可恢复标准价（HQ 价目表另列）。',
    ecosystemMallPriceBookBundleRuleDeviceScopeTitle: '② $199 含哪些设备',
    ecosystemMallPriceBookBundleRuleDeviceScopeBody: '计入全包：茶机、咖啡机、饮料机、搅拌、Maestro 等自动现制设备；不含 kiosk／广告屏／收银／排号／车机等；云瞳等 B 线加购另议。',
    ecosystemMallPriceBookQuoteSectionTab: '报价区块',
    ecosystemMallPriceBookQuoteTabAll: '全部',
    ecosystemMallPriceBookQuoteTabA: '块 A · 设备数据',
    ecosystemMallPriceBookQuoteTabB: '块 B · 店务运营',
    ecosystemMallPriceBookQuoteTabC: '块 C · 组合套餐',
    ecosystemMallPriceBookQuoteTabOther: '硬件／点数',
    ecosystemMallPriceBookQuoteSectionCol: '报价区块',
    ecosystemMallPriceBookQuoteSection_TRACK_A_DEVICE_DATA: 'A · 设备数据',
    ecosystemMallPriceBookQuoteSection_TRACK_B_STORE_OPS: 'B · 店务',
    ecosystemMallPriceBookQuoteSection_TRACK_B_HQ: 'B · 总部',
    ecosystemMallPriceBookQuoteSection_TRACK_B_ANALYTICS: 'B · 分析',
    ecosystemMallPriceBookQuoteSection_TRACK_B_INTEGRATION: 'B · 整合',
    ecosystemMallPriceBookQuoteSection_TRACK_B_DEVICE_ADDON: 'B · 设备加购',
    ecosystemMallPriceBookQuoteSection_BUNDLE_FULL_STACK: 'C · 全店打包',
    ecosystemMallPriceBookQuoteSection_HARDWARE: '硬件',
    ecosystemMallPriceBookQuoteSection_AI_POINTS: 'AI 点数',
    ecosystemMallPriceBookQuoteSection_FREE_INCLUDED: '买机已含',
    ecosystemMallPriceBookFilterSearch: '搜索',
    ecosystemMallPriceBookFilterSearchPh: 'SKU／名称／关键字',
    ecosystemMallPriceBookFilterSegment: '客群',
    ecosystemMallPriceBookFilterSegmentAll: '全部客群',
    ecosystemMallPriceBookSegmentHome: '家用',
    ecosystemMallPriceBookSegmentCommercial: '商用',
    ecosystemMallPriceBookSegmentAll: '通用',
    ecosystemMallPriceBookFilterCategory: '产品族',
    ecosystemMallPriceBookFilterCategoryAll: '全部产品族',
    ecosystemMallPriceBookCatHomeHardware: '家用硬件',
    ecosystemMallPriceBookCatHomeAddon: '家用附加包',
    ecosystemMallPriceBookCatCommercialHardware: '商用硬件',
    ecosystemMallPriceBookCatCommercialStoreOps: '店务模块',
    ecosystemMallPriceBookCatCommercialHq: '总部多店',
    ecosystemMallPriceBookCatCommercialIntegration: '金流整合',
    ecosystemMallPriceBookCatCommercialAiData: 'AI／数据',
    ecosystemMallPriceBookCatCommercialOther: '商用其他',
    ecosystemMallPriceBookCatAiPoints: 'AI 点数包',
    ecosystemMallPriceBookCatUniversal: '通用加购',
    ecosystemMallPriceBookCatOther: '其他',
    ecosystemMallPriceBookFilterStatusAll: '全部状态',
    ecosystemMallPriceBookFilterKindAll: '全部类型',
    ecosystemMallPriceBookFilterCurrencyAll: '全部币别',
    ecosystemMallPriceBookFilterPricing: '计费方式',
    ecosystemMallPriceBookFilterPricingAll: '全部计费',
    ecosystemMallPriceBookFilterPriceBand: '价格带',
    ecosystemMallPriceBookFilterPriceBandAll: '全部价格',
    ecosystemMallPriceBookPriceBandFree: '免费（0元）',
    ecosystemMallPriceBookPriceBandLow: '入门（<500 CNY）',
    ecosystemMallPriceBookPriceBandMid: '标准（500–3000）',
    ecosystemMallPriceBookPriceBandHigh: '高阶（>3000）',
    ecosystemMallPriceBookFilterClear: '清除筛选',
    ecosystemMallPriceBookFilterSelectAll: '全选',
    ecosystemMallPriceBookFilterClearAll: '清空',
    ecosystemMallPriceBookFilterMultiAll: '全部（可多选）',
    ecosystemMallPriceBookFilterResult: '显示 {shown}／{total} 项',
    ecosystemMallPriceBookPresetAll: '全部',
    ecosystemMallPriceBookPresetHomeHardware: '家用硬件',
    ecosystemMallPriceBookPresetHomeAddon: '家用附加包',
    ecosystemMallPriceBookPresetCommercialHardware: '商用硬件',
    ecosystemMallPriceBookPresetCommercialSoftware: '商用软件模块',
    ecosystemMallPriceBookPresetAiPoints: 'AI 点数包',
    ecosystemMallPriceBookPresetActiveOnly: '仅启用',
    ecosystemMallPriceBookColumnSegment: '客群',
    ecosystemMallPriceBookColumnCategory: '产品族',
    ecosystemMallPriceBookPricingTrialThenPaid: '试用后付费',
    ecosystemMallPriceBookPricingAiPointsPack: 'AI 点数包',
    ecosystemMallPriceBookPricingPerDeviceYear: '按设备／年',
    ecosystemMallPriceBookPricingPerDeviceMonth: '按台／月',
    ecosystemMallPriceBookPricingPerDeviceDay: '按台／天（现结）',
    ecosystemMallPriceBookPricingPerDevicePeriod: '按台／期',
    ecosystemMallPriceBookPricingPerStoreMonth: '按店／月',
    ecosystemMallPriceBookPricingPerStoreDay: '按店／天（现结）',
    ecosystemMallPriceBookPricingTieredAnnualPool: '年费台数阶梯',
    ecosystemMallPriceBookPricingSocStoreSubscription: 'SOC 按店订阅',
    ecosystemMallPriceBookDeviceScope: '计费范围',
    ecosystemMallPriceBookDeviceFamily: '设备族',
    ecosystemMallPriceBookModelKey: '型号代码',
    ecosystemMallPriceBookModelKeyPh: '如 PT5、X600H（与设备族二选一或填型号优先）',
    ecosystemMallPriceBookModelKeyShort: '型号 {key}',
    ecosystemMallPriceBookDeviceScopeHint: '设备数据费须指定设备族或型号，签约时才会按对应台数计价。',
    ecosystemMallPriceBookDeviceScopeRequired: '请填设备族或型号代码',
    ecosystemMallPriceBookDeviceFamilyTeaMachine: '泡茶机',
    ecosystemMallPriceBookDeviceFamilyCoffeeMachine: '咖啡机',
    ecosystemMallPriceBookDeviceFamilyDispenser: '饮料机',
    ecosystemMallPriceBookDeviceFamilyKiosk: '点餐机',
    ecosystemMallPriceBookDeviceFamilySignage: '广告屏',
    ecosystemMallPriceBookPricingPerStoreYear: '按店／年',
    ecosystemMallPriceBookPricingPerHouseholdYear: '按家庭／年',
    ecosystemMallPriceBookPricingOneTimeSku: '一次性',
    ecosystemMallPriceBookPricingModuleAddon: '模块加购',
    ecosystemMallPriceBookPricingCustomQuote: '项目报价',
    ecosystemMallCommerceMatrix: '商业全景',
    ecosystemMallCommerceMatrixDesc: 'SKU 域包、菜单归类、标价与健康检查；未归类页对租户不可见。',
    ecosystemMallCommerceMatrixEdgeBanner: '挂包／新增域包由东京总部全球统一。本区只读镜像；东京不可用时以最后一次扇出为准，禁止在本区新增。',
    ecosystemMallCommerceMatrixTokyoBanner: '本区是全球写入中心。绑菜单／标受众／新增域包后会扇出到 111 与已跟读产区。',
    ecosystemMallCommerceMatrixReload: '重新加载',
    ecosystemMallCommerceMatrixOpenPriceBook: '价目表',
    ecosystemMallCommerceMatrixBlockerHint: '存在未归类或缺价项，请先治理后再对外。',
    ecosystemMallCommerceMatrixPassHint: '商业化矩阵健康检查通过。',
    ecosystemMallCommerceMatrixHealthSummary: '未归类页 {unassigned} · 阻断 {blockers} · 架构不一致 {archMismatch}',
    ecosystemMallCommerceMatrixArchMismatchHint: '有 {n} 个域包 SKU 与价目表 product_class／quote_section 不一致，请在价目表修正架构栏。',
    ecosystemMallCommerceMatrixArchMismatchShort: '架构不一致',
    ecosystemMallCommerceMatrixArchCols: '架构栏',
    ecosystemMallCommerceMatrixArchWriteNote: '架构栏（product_class／quote_section）仅能在「价目表」修改；本页只改金额／绑菜单／新增域包。',
    ecosystemMallCommerceMatrixSkuSection: 'SKU 域包',
    ecosystemMallCommerceMatrixTreeSection: '菜单权限树 · 商业全景（与侧栏对齐）',
    ecosystemMallCommerceMatrixOrphanSkuSection: '未绑定菜单的 SKU',
    ecosystemMallCommerceMatrixMenuSection: '菜单归类（仅页面）',
    ecosystemMallCommerceMatrixTier: '层级',
    ecosystemMallCommerceMatrixMenuCount: '菜单数',
    ecosystemMallCommerceMatrixMenuNames: '含菜单',
    ecosystemMallCommerceMatrixTrialDays: '试用天',
    ecosystemMallCommerceMatrixHealth: '健康',
    ecosystemMallCommerceMatrixAudience: '受众',
    ecosystemMallCommerceMatrixMenuName: '名称',
    ecosystemMallCommerceMatrixActions: '操作',
    ecosystemMallCommerceMatrixFilterAll: '全部',
    ecosystemMallCommerceMatrixFilterBlocker: '阻断',
    ecosystemMallCommerceMatrixFilterUnassigned: '未归类',
    ecosystemMallCommerceMatrixFilterInternal: '内部',
    ecosystemMallCommerceMatrixLoadFail: '加载失败（须超管）',
    ecosystemMallCommerceMatrixFilterKeyword: '关键字',
    ecosystemMallCommerceMatrixFilterKeywordPh: 'SKU／名称／域包',
    ecosystemMallCommerceMatrixFilterReset: '重置',
    ecosystemMallCommerceMatrixFilterResultCount: '显示 {shown}／{total}',
    ecosystemMallCommerceMatrixFilterHealth: '健康',
    ecosystemMallCommerceMatrixFilterTier: '层级',
    ecosystemMallCommerceMatrixFilterSegment: '分段',
    ecosystemMallCommerceMatrixFilterPriceStatus: '标价',
    ecosystemMallCommerceMatrixFilterPriceHas: '有标价',
    ecosystemMallCommerceMatrixFilterPriceMissing: '缺标价',
    ecosystemMallCommerceMatrixFilterCurrency: '币别',
    ecosystemMallCommerceMatrixFilterDomain: '域包',
    ecosystemMallCommerceMatrixFilterPillar: '根柱',
    ecosystemMallCommerceMatrixFilterAudience: '受众',
    ecosystemMallCommerceMatrixFilterSkuBinding: 'SKU 绑定',
    ecosystemMallCommerceMatrixFilterSkuHas: '已绑 SKU',
    ecosystemMallCommerceMatrixFilterSkuNo: '未绑 SKU',
    ecosystemMallCommerceMatrixFilterHealthOk: '正常',
    ecosystemMallCommerceMatrixFilterHealthWarn: '警告',
    ecosystemMallCommerceMatrixFilterHealthBlocker: '阻断',
    ecosystemMallCommerceMatrixFilterAudienceBrandOps: '品牌营运',
    ecosystemMallCommerceMatrixFilterUnassigned: '未归类',
    ecosystemMallCommerceMatrixPillarSystem: '系统设置',
    ecosystemMallCommerceMatrixPillarDevice: '设备·XHM',
    ecosystemMallCommerceMatrixPillarSoc: '营运·SOC',
    ecosystemMallCommerceMatrixPillarLeo: 'Leo',
    ecosystemMallCommerceMatrixPillarMall: '生态商城',
    ecosystemMallCommerceMatrixPillarOther: '其他',
    ecosystemMallCommerceMatrixDomain: '域包',
    ecosystemMallCommerceMatrixSegment: '分段',
    ecosystemMallCommerceMatrixBindTarget: '挂到',
    ecosystemMallCommerceMatrixBindApply: '挂入选中',
    ecosystemMallCommerceMatrixBindNeedSelect: '请先勾选菜单，再选要挂的包',
    ecosystemMallCommerceMatrixBindOk: '已挂入',
    ecosystemMallCommerceMatrixBindPolicy: '生效策略',
    ecosystemMallCommerceMatrixBindPolicyNewOnly: '仅新订阅（推荐）',
    ecosystemMallCommerceMatrixBindPolicyGrandfather: '旧客保留打包',
    ecosystemMallCommerceMatrixBindPolicyImmediate: '立即全量（高风险）',
    ecosystemMallCommerceMatrixCreateDomain: '新增域包',
    ecosystemMallStartUnifyPipeline: '开始标准流水线',
    ecosystemMallGovernanceGapJump: '整治缺口',
    ecosystemMallCommerceMatrixCreateDomainHint: '新增安全；改菜单进出默认仅新订阅生效，已购客户权限不变。',
    ecosystemMallCommerceMatrixCreateDomainEnName: '域英文名',
    ecosystemMallCommerceMatrixCreateDomainQuoteSection: '报价分块',
    ecosystemMallCommerceMatrixCreateDomainProductClass: '产品类',
    ecosystemMallCommerceMatrixCreateDomainNeed: '请完成必填项（菜单／域名／柱）',
    ecosystemMallCommerceMatrixCreateDomainOk: '域包已创建',
    ecosystemMallCommerceMatrixCreateDomainOkSku: '域包已创建，SKU={sku}',
    ecosystemMallCommerceMatrixCreateDomainFail: '创建域包失败',
    ecosystemMallCommerceMatrixWizardStepMenus: '选菜单',
    ecosystemMallCommerceMatrixWizardStepConfirmMenus: '确认菜单',
    ecosystemMallCommerceMatrixWizardStepName: '命名',
    ecosystemMallCommerceMatrixWizardStepBilling: '周期',
    ecosystemMallCommerceMatrixWizardStepPay: '付款',
    ecosystemMallCommerceMatrixWizardStepPrice: '价格',
    ecosystemMallCommerceMatrixWizardStepDone: '确认',
    ecosystemMallCommerceMatrixWizardPickMenusHint: '像授权树一样勾选要打进本域包的菜单页（须同一柱）。',
    ecosystemMallCommerceMatrixWizardSelectedCount: '已选 {n} 个菜单页',
    ecosystemMallCommerceMatrixWizardPillar: '柱：{pillar}',
    ecosystemMallCommerceMatrixWizardNameZh: '显示名（可选）',
    ecosystemMallCommerceMatrixWizardAutoSkuHint: 'SKU 由系统按域名自动生成，保存时保证唯一。',
    ecosystemMallCommerceMatrixWizardBillingHint: '选择支持的计费周期（可多选；主周期优先年＞月＞日）。',
    ecosystemMallCommerceMatrixWizardCycleDay: '天',
    ecosystemMallCommerceMatrixWizardCycleMonth: '月',
    ecosystemMallCommerceMatrixWizardCycleYear: '年',
    ecosystemMallCommerceMatrixWizardPayHint: '选择支持的付款方式（可多选）。',
    ecosystemMallCommerceMatrixWizardPayPrepaid: '预付',
    ecosystemMallCommerceMatrixWizardPrev: '上一步',
    ecosystemMallCommerceMatrixWizardNext: '下一步',
    ecosystemMallCommerceMatrixWizardFinish: '确认创建',
    ecosystemMallCommerceMatrixWizardNeedMenus: '请先勾选至少一个菜单页',
    ecosystemMallCommerceMatrixWizardMultiPillar: '所选菜单跨多个柱，请只选同一柱',
    ecosystemMallCommerceMatrixWizardNeedBilling: '请至少选一个计费周期',
    ecosystemMallCommerceMatrixWizardNeedPay: '请至少选一种付款方式',
    ecosystemMallCommerceMatrixWizardNeedPrice: '请填写大于 0 的价格',
    ecosystemMallCommerceMatrixBindFail: '挂入失败',
    ecosystemMallCommerceMatrixMakeFree: '改为免费',
    ecosystemMallCommerceMatrixMakeFreeConfirm: '会把此收费包内的页面改到免费基础包，租户不用买也能看。确定？',
    ecosystemMallCommerceMatrixMakeFreeOk: '已改为免费',
    ecosystemMallCommerceMatrixFreeTier: '免费',
    ecosystemMallCommerceMatrixPaidTier: '收费',
    ecosystemMallCommerceMatrixBindHint: '受众／域包列可直接改（含标内部）；勾选可批量。',
    ecosystemMallCommerceMatrixAudienceApply: '改受众',
    ecosystemMallCommerceMatrixAudienceNeedSelect: '请先勾选页面并选择受众',
    ecosystemMallCommerceMatrixAudienceOk: '受众已更新',
    ecosystemMallCommerceMatrixAudienceFail: '受众更新失败',
    ecosystemMallCommerceMatrixAudienceJsonBoundWarn: '{n} 个页面由 JSON 种子归类，无法改为未归类',
    ecosystemMallCommerceMatrixBatchSelected: '已选 {n} 个页面',
    ecosystemMallCommerceMatrixClearSelection: '清除勾选',
    ecosystemMallCommerceMatrixInlineDomainPh: '选择域包',
    ecosystemMallCommerceMatrixBindPillarMixed: '请只勾选同一柱的页面后再批量绑域包',
    ecosystemMallCommerceMatrixBindPillarOther: '此页未挂到五根柱，请先调整菜单树',
    ecosystemMallCommerceMatrixBindPillarMismatch: '{n} 个页面与域包柱不匹配，已跳过',
    ecosystemMallCommerceMatrixMenuId: '菜单 ID',
    ecosystemMallCommerceMatrixTierFreeBasic: '免费基础包',
    ecosystemMallCommerceMatrixTierAddon: '加购包',
    ecosystemMallCommerceMatrixTierNone: '无',
    ecosystemMallCommerceMatrixAudienceInfraFolder: '基础文件夹',
    ecosystemMallCommerceMatrixHealthOk: '正常',
    ecosystemMallCommerceMatrixHealthWarn: '警告',
    ecosystemMallCommerceMatrixHealthBlocker: '阻断',
    ecosystemMallCommerceMatrixDomain_socMonDomainBasicOps: 'SOC 营运基础',
    ecosystemMallCommerceMatrixDomain_socMonDomainStoreOpsPlus: '门店营运加购',
    ecosystemMallCommerceMatrixDomain_socMonDomainHqMulti: '总部多店加购',
    ecosystemMallCommerceMatrixDomain_socMonDomainPayIntegrate: '支付整合加购',
    ecosystemMallCommerceMatrixDomain_socMonDomainAnalytics: '分析 AI 加购',
    ecosystemMallCommerceMatrixDomain_socMonDomainSmartGuidePlus: '智能引导加购',
    ecosystemMallCommerceMatrixDomain_leoMonDomainBasic: 'Leo 基础',
    ecosystemMallCommerceMatrixDomain_leoMonDomainHomeAddon: 'Leo 首页加购',
    ecosystemMallCommerceMatrixDomain_leoMonDomainComAddon: 'Leo 组件加购',
    ecosystemMallCommerceMatrixDomain_leoMonDomainAiPoints: 'Leo AI 点数',
    ecosystemMallCommerceMatrixDomain_ecMonDomainMallBrowse: '商城浏览基础',
    ecosystemMallCommerceMatrixDomain_ecMonDomainBusinessPlan: '商业计划加购',
    ecosystemMallCommerceMatrixDomain_deviceMonDomainBasicCenter: '设备中心基础',
    ecosystemMallCommerceMatrixDomain_deviceMonDomainAfterSales: '售后服务基础',
    ecosystemMallCommerceMatrixDomain_deviceMonDomainInCar: '车载基础',
    ecosystemMallCommerceMatrixDomain_deviceMonDomainHardwarePartner: '硬件伙伴基础',
    ecosystemMallCommerceMatrixDomain_deviceMonDomainFamilySlot: '设备族槽位',
    ecosystemMallCommerceMatrixDomain_brandServiceModeA: '签约模式 A（设备数据）',
    ecosystemMallCommerceMatrixDomain_brandServiceModeB: '签约模式 B（SOC/Leo 加购）',
    ecosystemMallCommerceMatrixDomain_subscriptionBillingFolder: '订阅账单',
    ecosystemMallCommerceMatrixDomain_deviceEndpointDataFolder: '设备端数据',
    ecosystemMallSocOpsDesc: '标准体验包（标准收费）或定制体验包（额外收费）。定制需先确认人力／设备／模块／权限再出模拟包。',
    ecosystemMallSocOpsToDevices: '设备星图',
    ecosystemMallSocOpsFullSim: '看完整一天',
    ecosystemMallSocOpsPlayDay: '一键播一天',
    ecosystemMallSocOpsDayPlaying: '演示中…',
    ecosystemMallSocOpsDayLabel: '一天怎么转',
    ecosystemMallSocOpsRailCup: '杯',
    ecosystemMallSocOpsRailCupHint: '下单→出杯→取货',
    ecosystemMallSocOpsRailStock: '料',
    ecosystemMallSocOpsRailStockHint: '做一杯扣一点，缺了建议补',
    ecosystemMallSocOpsRailPeople: '人',
    ecosystemMallSocOpsRailPeopleHint: '引导与总部协同',
    ecosystemMallSocOpsRailCash: '钱',
    ecosystemMallSocOpsRailCashHint: '支付、分析与情报',
    ecosystemMallSocOpsRailMore: '其他模块',
    ecosystemMallSocOpsMode: '呈现方式',
    ecosystemMallSocOpsModeTopo: '拓扑图',
    ecosystemMallSocOpsModeList: '模块列表',
    ecosystemMallSocOpsReload: '重新载入',
    ecosystemMallSocOpsGuideToggle: '体验包',
    ecosystemMallSocOpsGuideHide: '收起体验包',
    ecosystemMallSocOpsPickCard: '点卡片查看这个运营域能替店做什么。',
    ecosystemMallSocOpsPickNode: '点左侧节点，看这个运营域能替店做什么。',
    ecosystemMallSocOpsPickHint: '也可点上方「杯 / 料 / 人 / 钱」高亮对应流程。',
    ecosystemMallSocOpsYear: '年',
    ecosystemMallSocOpsInBasic: '含在基础包',
    ecosystemMallSocOpsStartTrial: '开始试用',
    ecosystemMallSocOpsTrySim: '本域体验',
    ecosystemMallSocOpsCombo: '组合演示',
    ecosystemMallSocOpsAddPack: '加入运营套餐',
    ecosystemMallSocOpsRemovePack: '移出套餐',
    ecosystemMallSocOpsConfirmPay: '确认开通／付费',
    ecosystemMallSocOpsPaying: '开通中…',
    ecosystemMallSocOpsMakePlan: '生成方案',
    ecosystemMallSocOpsPayOk: '已确认开通',
    ecosystemMallSocOpsPayFail: '开通失败',
    ecosystemMallSocOpsPayNeedTrial: '请先试用后再确认开通',
    ecosystemMallSocOpsAutoHuman: '自动 vs 找人',
    ecosystemMallSocOpsAuto: '自动：',
    ecosystemMallSocOpsHuman: '找人：',
    ecosystemMallSocOpsCaps: '开了能做什么',
    ecosystemMallSocOpsRelations: '上下游关系',
    ecosystemMallSocOpsUpstream: '依赖',
    ecosystemMallSocOpsDownstream: '驱动',
    ecosystemMallSocOpsRelNone: '无（由云端直连）',
    ecosystemMallSocOpsDemoTitle: '本域自动流程',
    ecosystemMallSocOpsDemoClose: '收起',
    ecosystemMallSocOpsPackTitle: '运营套餐 · {n} 个域',
    ecosystemMallSocOpsPackEst: '预估年费 ¥{amount}',
    ecosystemMallSocOpsPackClear: '清空',
    ecosystemMallSocOpsPackTrial: '一键试用套餐',
    ecosystemMallSocOpsPackTrialOk: '已开启 {n} 个域试用',
    ecosystemMallExpGuideTitle: '先选体验包类型',
    ecosystemMallExpGuideSub: '标准包可直接体验；定制包需先确认人力／设备／模块／权限，再出整店模拟包。',
    ecosystemMallExpKindStandard: '标准体验包',
    ecosystemMallExpKindStandardHint: '固定套餐，选好就能体验或付款开通',
    ecosystemMallExpKindCustom: '定制体验包',
    ecosystemMallExpKindCustomHint: '先确认整店配置，再一键出模拟包',
    ecosystemMallExpFeeStandard: '标准收费',
    ecosystemMallExpFeeExtra: '额外收费',
    ecosystemMallExpFeeExtraHint: '定制配置与出包服务另计',
    ecosystemMallExpStepPickStandard: '① 选一个标准包',
    ecosystemMallExpStandardLineA: '按标准包试用开域并进入模拟店（设备若未自动放入，可在虚拟店补放）。',
    ecosystemMallExpStandardLineB: '按标准包付款正式开通软件域。',
    ecosystemMallExpStaffTitle: '人力',
    ecosystemMallExpStaffHint: '确认模拟店要几个店长、几个店员（先记配置，不谎称账号已开）。',
    ecosystemMallExpDevicesTitle: '設備',
    ecosystemMallExpDevicesHint: '勾选要放入模拟店的设备。',
    ecosystemMallExpModulesTitle: '模块',
    ecosystemMallExpModulesHint: '勾选要开通试用的运营域。',
    ecosystemMallExpPermsTitle: '权限',
    ecosystemMallExpPermsHint: '選店長／店員权限預設。',
    ecosystemMallExpConfirmTitle: '确认出包',
    ecosystemMallExpConfirmHint: '核对无误后出定制模拟包并进入体验。',
    ecosystemMallExpManagerCount: '店长人数',
    ecosystemMallExpStaffCount: '店员人数',
    ecosystemMallExpPermsHonest: '此處只保存权限預設配置；若後端尚未開帳號，清單會標「已記錄」而非「已完成」。',
    ecosystemMallExpConfirmHonest: '出包後會顯示真實 checklist：軟件試用／模擬店／設備放置／人力與权限是否僅記錄。',
    ecosystemMallExpSumStaff: '人力：店长 {m}、店员 {s}',
    ecosystemMallExpSumDevices: '设备 {n} 台',
    ecosystemMallExpSumModules: '模块 {n} 個',
    ecosystemMallExpSumPerms: '权限預設 {n} 項',
    ecosystemMallExpPrev: '上一步',
    ecosystemMallExpNext: '下一步',
    ecosystemMallExpIssuePack: '确认并出模拟包',
    ecosystemMallExpIssuing: '出包中…',
    ecosystemMallExpIssueOk: '定制模拟包已发出，正在进入体验',
    ecosystemMallExpIssueFail: '出包未完成（见下方清单，未谎称成功）',
    ecosystemMallExpDraftInvalid: '請先完成人力／設備／模块／权限勾選',
    ecosystemMallExpChecklistTitle: '出包结果（诚实状态）',
    ecosystemMallExpCheckModules: '軟件模块試用',
    ecosystemMallExpCheckStore: '模拟店工作区',
    ecosystemMallExpCheckDevices: '设备放入模拟店',
    ecosystemMallExpCheckStaff: '店长／店员配置',
    ecosystemMallExpCheckStaffHonest: '配置已记录；账号开通需后端能力，前端不虚报已开好',
    ecosystemMallExpCheckPerms: '权限預設配置',
    ecosystemMallExpCheckPermsHonest: '权限預設已記錄；未等同角色已授權完成',
    ecosystemMallExpStatusDone: '已完成',
    ecosystemMallExpStatusRecorded: '已记录（待后端）',
    ecosystemMallExpStatusFailed: '失败',
    ecosystemMallExpStatusPending: '待操作',
    ecosystemMallExpStatusSkipped: '未处理',
    ecosystemMallExpModOrder: '订单',
    ecosystemMallExpModProduce: '出杯',
    ecosystemMallExpModPickup: '取货',
    ecosystemMallExpModStock: '库存',
    ecosystemMallExpModPay: '支付',
    ecosystemMallExpModHq: '总部',
    ecosystemMallExpModGuide: '引导',
    ecosystemMallExpModAnalytics: '分析',
    ecosystemMallExpModIntel: '情报',
    ecosystemMallExpDevKiosk: '点餐屏',
    ecosystemMallExpDevTea: '出品／茶机',
    ecosystemMallExpDevQueue: '叫号屏',
    ecosystemMallExpDevPos: '收银机',
    ecosystemMallExpDevSignage: '广告屏',
    ecosystemMallExpPermManager: '店长：全店运营',
    ecosystemMallExpPermStaff: '店员：日常店务',
    ecosystemMallExpPermStaffPickup: '店員：僅取货',
    ecosystemMallSocOpsBridgeHwTitle: '建议搭配的硬件',
    ecosystemMallSocOpsBridgeHonest: '未加载设备快照时只显示目录建议，绝不谎称店内已有／已配齐。',
    ecosystemMallSocOpsBridgeGoHw: '去设备星图',
    ecosystemMallSocOpsBridgeFromHw: '已从设备星图带入推荐上下文（软件态以本页拓扑为准）',
    ecosystemMallSocOpsBridgeFromHwPay: '硬件侧建议走成交线：请确认标准包后付款开通',
    ecosystemMallSocOpsDualTitle: '体验完以后，只有两条线',
    ecosystemMallSocOpsDualSub: '先选标准权限包。体验线：配好包 → 建模拟店 → 后台模拟跑；成交线：付款直接正式开通。',
    ecosystemMallSocOpsLineATag: '线 A · 体验',
    ecosystemMallSocOpsLineATitle: '标准权限包 → 模拟店',
    ecosystemMallSocOpsLineADesc: '我们按所选标准包开通试用权益，并在后台建好模拟商店，你直接进去跑。',
    ecosystemMallSocOpsLineAStep1: '配置标准权限包（试用开域）',
    ecosystemMallSocOpsLineAStep2: '自动建立模拟商店工作区',
    ecosystemMallSocOpsLineAStep3: '进入虚拟店模拟跑店',
    ecosystemMallSocOpsLineACta: '配包并进入模拟店',
    ecosystemMallSocOpsLineACtaShort: '体验线：进模拟店',
    ecosystemMallSocOpsLineARunning: '正在配包建店…',
    ecosystemMallSocOpsLineAOk: '已配置 {n} 个域试用，正在进入模拟店',
    ecosystemMallSocOpsLineBTag: '线 B · 成交',
    ecosystemMallSocOpsLineBTitle: '付款直接开通',
    ecosystemMallSocOpsLineBDesc: '确认后按当前标准包／已勾选域正式开通真实权益，不走模拟店。',
    ecosystemMallSocOpsLineBStep1: '确认标准包或勾选域',
    ecosystemMallSocOpsLineBStep2: '付款确认开通',
    ecosystemMallSocOpsLineBStep3: '真实门店运营域生效',
    ecosystemMallSocOpsLineBCta: '付款正式开通',
    ecosystemMallSocOpsLineBCtaShort: '成交线：付款开通',
    ecosystemMallSocOpsLineBOk: '已正式开通 {n} 个运营域',
    ecosystemMallSocOpsLineBEmpty: '当前没有待开通的加购域',
    ecosystemMallSocOpsPackDayTitle: '日营运标准包',
    ecosystemMallSocOpsPackDayDesc: '单·出·取·库·付',
    ecosystemMallSocOpsPackHqTitle: '总部增强包',
    ecosystemMallSocOpsPackHqDesc: '日营运 + 总·导·析',
    ecosystemMallSocOpsPackFullTitle: '全量情报包',
    ecosystemMallSocOpsPackFullDesc: '总部增强 + 情报',
    ecosystemMallSocOpsSimStoreName: '运营模拟店 · {pack}',
    ecosystemMallSocOpsSimStoreFallback: '模拟店接口暂未完全就绪，仍将进入虚拟店页面继续体验',
    ecosystemMallSocOpsActive: '已开通',
    ecosystemMallSocOpsTrial: '试用中',
    ecosystemMallSocOpsPotential: '还缺',
    ecosystemMallBadgeAll: '全部',
    ecosystemMallBadgeOwned: '已有',
    ecosystemMallBadgeIntent: '已意向',
    ecosystemMallBadgeAvailable: '可选',
    ecosystemMallSocOpsLoadFail: '载入失败',
    ecosystemMallSocOpsTrialOk: '试用已开启',
    ecosystemMallSocOpsTrialFail: '试用失败',
    ecosystemMallSocOpsListCount: '共 {n} 个模块',
    ecosystemMallSocOpsBrand: 'XRROSS 运营商店',
    ecosystemMallSocOpsChip: 'Leo · SOC · XHM 三位一体',
    ecosystemMallSocOpsSub: '中心＝SOC 门店运行时；亮线＝业务怎么自动转。点域看能力，组套餐试用。',
    ecosystemMallSocOpsScheme: '切换背景配色',
    ecosystemMallSocOpsSchemeLight: '浅灰',
    ecosystemMallSocOpsSchemeMidnight: '深空',
    ecosystemMallSocOpsSchemeSlate: '石板',
    ecosystemMallSocOpsSchemeBrand: '品牌',
    ecosystemMallSocOpsEngine: '运营地图',
    ecosystemMallSocOpsLegendTitle: '怎么看这张图',
    ecosystemMallSocOpsLegendHub: '中心＝SOC 门店运行时（Leo 引导 / XHM 回写）',
    ecosystemMallSocOpsLegendActive: '亮＝已开通／买机含基础',
    ecosystemMallSocOpsLegendPotential: '暗＝还缺（虚线＋黄粒子）',
    ecosystemMallSocOpsLegendTrial: '绿＝试用中',
    ecosystemMallSocOpsLegendHint: '粗线＝日循环业务边；点选后高亮上下游',
    ecosystemMallSocOpsLegendExpand: '点大模块可散出细功能；再点收回',
    ecosystemMallSocOpsLegendHover: '滑过小球看全称与具体功能',
    ecosystemMallSocOpsHoverBelong: '所属',
    ecosystemMallSocOpsZoomHint: '滚轮缩放 · 空白处拖曳平移',
    ecosystemMallSocOpsZoomReset: '重置',
    ecosystemMallSocOpsFs: '全屏',
    ecosystemMallSocOpsExitFs: '退出全屏',
    ecosystemMallSocOpsFsLeft: '左侧拓扑全屏',
    ecosystemMallSocOpsFsRight: '右侧详情全屏',
    ecosystemMallSocOpsSplitHint: '拖曳调整左右宽度',
    ecosystemMallSocOpsSku: '加购 SKU',
    ecosystemMallSocOpsReloading: '开通中…',
    ecosystemMallSocOpsEmpty: '还没有算出运营节点',
    ecosystemMallSocOpsHubLabel: 'SOC 门店运行时',
    ecosystemMallSocOpsHubSub: '运行时',
    ecosystemMallSocOpsHubHint: '杯料人钱在此闭环',
    ecosystemMallSocOpsMetaBasicSolve: '把门店基础运行能力一次装齐，后续业务域才能接上。',
    ecosystemMallSocOpsMetaBasicAuto: '账号、门店档案、基础菜单与设备握手。',
    ecosystemMallSocOpsMetaBasicHuman: '首次开店配置与品牌规则确认。',
    ecosystemMallSocOpsMetaBasicC1: '门店与员工基础档案',
    ecosystemMallSocOpsMetaBasicC2: '菜单／SKU 底座',
    ecosystemMallSocOpsMetaBasicC3: '与设备星图握手',
    ecosystemMallSocOpsMetaBasicD1: '云端创建门店运行时',
    ecosystemMallSocOpsMetaBasicD2: '同步基础菜单与权限',
    ecosystemMallSocOpsMetaBasicD3: '业务域开始可挂载',
    ecosystemMallSocOpsMetaOrderSolve: '把线上下单收成同一条订单流，减少漏单与口头传菜。',
    ecosystemMallSocOpsMetaOrderAuto: '接单、校验、路由到出杯队列。',
    ecosystemMallSocOpsMetaOrderHuman: '异常单、改单与客诉裁决。',
    ecosystemMallSocOpsMetaOrderC1: '多渠道订单汇聚',
    ecosystemMallSocOpsMetaOrderC2: '自动校验与分派',
    ecosystemMallSocOpsMetaOrderC3: '异常单提示',
    ecosystemMallSocOpsMetaOrderD1: '客人下单进入云端',
    ecosystemMallSocOpsMetaOrderD2: '规则校验后入队',
    ecosystemMallSocOpsMetaOrderD3: '推给出杯域开工',
    ecosystemMallSocOpsMetaProduceSolve: '按配方驱动出杯，让「做出一杯」变成可追踪步骤。',
    ecosystemMallSocOpsMetaProduceAuto: '按 BOM／配方推进产线步骤并回写进度。',
    ecosystemMallSocOpsMetaProduceHuman: '设备故障、配方例外时介入。',
    ecosystemMallSocOpsMetaProduceC1: '配方驱动产线',
    ecosystemMallSocOpsMetaProduceC2: '进度回写取货',
    ecosystemMallSocOpsMetaProduceC3: '同步扣减原料建议',
    ecosystemMallSocOpsMetaProduceD1: '订单触发出杯任务',
    ecosystemMallSocOpsMetaProduceD2: '设备／产线执行步骤',
    ecosystemMallSocOpsMetaProduceD3: '完成信号送给取货与库存',
    ecosystemMallSocOpsMetaPickupSolve: '用订单码把「做好了」变成无争议取货。',
    ecosystemMallSocOpsMetaPickupAuto: '排号、叫号、扫码核销。',
    ecosystemMallSocOpsMetaPickupHuman: '取货纠纷与特殊放行。',
    ecosystemMallSocOpsMetaPickupC1: '排号／叫号',
    ecosystemMallSocOpsMetaPickupC2: '扫码核销',
    ecosystemMallSocOpsMetaPickupC3: '取货状态回写支付与分析',
    ecosystemMallSocOpsMetaPickupD1: '出杯完成进入取货队列',
    ecosystemMallSocOpsMetaPickupD2: '客人扫订单码核销',
    ecosystemMallSocOpsMetaPickupD3: '闭环到支付与复盘',
    ecosystemMallSocOpsMetaStockSolve: '做一杯扣一点；缺料时给补货建议而不是靠感觉。',
    ecosystemMallSocOpsMetaStockAuto: '按杯扣料、阈值预警、补货建议单。',
    ecosystemMallSocOpsMetaStockHuman: '确认收发与大额采购放闸。',
    ecosystemMallSocOpsMetaStockC1: 'BOM 扣减',
    ecosystemMallSocOpsMetaStockC2: '缺料预警',
    ecosystemMallSocOpsMetaStockC3: '扫码收发建议',
    ecosystemMallSocOpsMetaStockD1: '出杯触发原料扣减',
    ecosystemMallSocOpsMetaStockD2: '阈值破线生成建议',
    ecosystemMallSocOpsMetaStockD3: '需要时升级到总部',
    ecosystemMallSocOpsMetaHqSolve: '多店与例外集中到总部视角，常態不打扰店长。',
    ecosystemMallSocOpsMetaHqAuto: '汇总破阈值事件与跨店对照。',
    ecosystemMallSocOpsMetaHqHuman: '策略、定价、重大例外决策。',
    ecosystemMallSocOpsMetaHqC1: '多店仪表',
    ecosystemMallSocOpsMetaHqC2: '破阈值升级',
    ecosystemMallSocOpsMetaHqC3: '策略下发到引导域',
    ecosystemMallSocOpsMetaHqD1: '各域上报关键指标',
    ecosystemMallSocOpsMetaHqD2: '破阈值才找人',
    ecosystemMallSocOpsMetaHqD3: '决策回写到门店引导',
    ecosystemMallSocOpsMetaPaySolve: '把应付可记清楚，出款前仍由人手放闸。',
    ecosystemMallSocOpsMetaPayAuto: '记账、对账线索、支付状态同步。',
    ecosystemMallSocOpsMetaPayHuman: '出款前确认与退款裁决。',
    ecosystemMallSocOpsMetaPayC1: '收款／应付记账',
    ecosystemMallSocOpsMetaPayC2: '对账线索',
    ecosystemMallSocOpsMetaPayC3: '出款前人工闸',
    ecosystemMallSocOpsMetaPayD1: '取货完成触发账务事件',
    ecosystemMallSocOpsMetaPayD2: '自动归集待对账项',
    ecosystemMallSocOpsMetaPayD3: '出款前请求确认',
    ecosystemMallSocOpsMetaAnalyticsSolve: '把一天的杯料人钱收成可复盘的数字，而不是周末再对表。',
    ecosystemMallSocOpsMetaAnalyticsAuto: '汇总销售、损耗与峰值。',
    ecosystemMallSocOpsMetaAnalyticsHuman: '解读异常并决定改菜单／排班。',
    ecosystemMallSocOpsMetaAnalyticsC1: '日／周经营摘要',
    ecosystemMallSocOpsMetaAnalyticsC2: '峰值与损耗提示',
    ecosystemMallSocOpsMetaAnalyticsC3: '输出给情报与总部',
    ecosystemMallSocOpsMetaAnalyticsD1: '支付与产线事件入仓',
    ecosystemMallSocOpsMetaAnalyticsD2: '生成经营摘要',
    ecosystemMallSocOpsMetaAnalyticsD3: '异常推给情报／总部',
    ecosystemMallSocOpsMetaGuideSolve: '用对话与指引把店员动作对齐系统，而不是靠微信群喊话。',
    ecosystemMallSocOpsMetaGuideAuto: '下一步动作提示、缺人时外呼建议。',
    ecosystemMallSocOpsMetaGuideHuman: '班表确认与现场例外。',
    ecosystemMallSocOpsMetaGuideC1: '岗位下一步指引',
    ecosystemMallSocOpsMetaGuideC2: '排班／补缺建议',
    ecosystemMallSocOpsMetaGuideC3: '把总部策略落到店员动作',
    ecosystemMallSocOpsMetaGuideD1: '总部策略下发',
    ecosystemMallSocOpsMetaGuideD2: '店员收到下一步',
    ecosystemMallSocOpsMetaGuideD3: '动作回流到订单流',
    ecosystemMallSocOpsMetaIntelSolve: '把经营信号变成可行动情报，而不是一堆报表。',
    ecosystemMallSocOpsMetaIntelAuto: '识别趋势与风险并生成简报。',
    ecosystemMallSocOpsMetaIntelHuman: '决定要不要改组合／加购硬件或软件域。',
    ecosystemMallSocOpsMetaIntelC1: '趋势与风险简报',
    ecosystemMallSocOpsMetaIntelC2: '与设备／软件加购联动建议',
    ecosystemMallSocOpsMetaIntelC3: '回流总部决策',
    ecosystemMallSocOpsMetaIntelD1: '分析域输出信号',
    ecosystemMallSocOpsMetaIntelD2: '生成可行动情报',
    ecosystemMallSocOpsMetaIntelD3: '推给总部做取舍',
    ecosystemMallCatalog: '商品与章节',
    ecosystemMallWebsitePages: '官网产品页',
    ecosystemMallSynergyEdges: '协同边开闸',
    ecosystemMallIntents: '意向／咨询单',
    ecosystemMallVendors: '供应商与人员',
    ecosystemMallMediaBilling: '媒资AI／计费',
    ecosystemMallProductSpecs: '产品规格／缺料',
    ecosystemMallLines: '产线组合',
    ecosystemMallSearch: '搜索推荐',
    ecosystemMallEquipmentDemands: '设备需求单',
    storeAssortmentOptimization: '店铺选品优化',
    storeAssortmentGroup: '店铺选品',
    storeAssortmentDesk: '选品优化工作台',
    storeAssortmentView: '查看',
    storeAssortmentGate: '开闸',
    teaSingleCupParams: '单杯参数',
    teaE1Performance: '智能精度',
    dispenserPrecision: '精準度',
    dispenserMaterialLoss: '物料损耗',
    dispenserMultiMachine: '多机互联',
    teaE1MatchScore: '精度指数',
    teaE1OnTarget: '是否达标',
    teaE1Wear: '磨损指数',
    dataOfBlendExtractorMachine:'冰沙机数据',
    dataOfMilkExtractorMachine:'奶沫机数据',
    beverageOutputData:'出品数据',
    singleCupData:'单杯数据',
    faultLog:'故障日志',
    deliveryPlatform:'外卖平台',
    uber:'Uber',
    otherProducts:'其他产品',
    listOfTeaExtractsProducts:'萃茶机产品',
    machineDebug:'设备调试',
    deviceRdGroup:'设备研发',
    presetCommand:'预设命令',
    commandConfiguration:'命令配置',
    memberHqGroup: '会员 HQ',
    memberHqDashboard: 'HQ 总览',
    memberHqFinance: '财务汇总',
    financeAccountingReports: '会计报表',
    financeAccountingGroup: '财务会计',
    storeCostOptimizeGroup: '成本效率',
    storeCostOptimizeDesk: '成本优化工作台',
    storeCostOptimizeView: '查看',
    storeCostOptimizeGate: '放闸',
    storeOpsCeoDeskGroup: '运营总决策台',
    storeOpsCeoDecisionDesk: 'CEO 运营决策台',
    storeOpsCeoDecisionDeskView: '查看',
    storeOpsCeoDecisionDeskDecide: '决策',
    storeOpsCeoGovernanceGapTitle: '全球整治缺口',
    storeOpsCeoGovernanceGapDesc: '总清单在这里。价目／型号页只跳过来。确认方案不等于改价、不等于批型号、不等于写深圳。',
    storeOpsCeoGovernanceGapConfirm: '确认方案',
    storeOpsCeoGovernanceGapStart: '开始标准流水线',
    storeOpsCeoGovernanceGapEmpty: '目前没有待确认缺口',
    storeOpsCeoGovernanceGapKind: '种类',
    storeOpsCeoGovernanceGapPlan: '方案',
    storeOpsCeoGovernanceGapHonesty: '跨区价差要对账入库后才会出现。本线不自动扇出。',
    storeOpsCeoGovernanceGapConfirmed: '已确认',
    storeOpsCeoGovernanceStepOpen: '打开清单',
    storeOpsCeoGovernanceStepPick: '点缺口',
    storeOpsCeoGovernanceStepConfirm: '确认方案',
    storeOpsCeoGovernanceStepGates: '核对写闸',
    storeOpsCeoGovernanceStepDone: '完成',
    storeOpsCeoGovernanceCoachTitle: '现在请确认方案',
    storeOpsCeoGovernanceCoachHint: '看清步骤再点确认。确认不等于写深圳。',
    aiEngineeringControlGroup: 'AI 工程总控',
    aiEngineeringControlDesk: '工程总控台',
    aiEngineeringControlDeskView: '查看',
    storePnLGroup: '店务 P&L',
    storePnLDesk: 'P&L／现金工作台',
    storePnLDeskView: '查看',
    storePnLDeskGate: '日结／分录',
    opsAnalyticsDesk: '经营仪表',
    hkTaxFilingDesk: '店铺帐税',
    hkTaxFilingDeskView: '查看',
    hkTaxFilingDeskGate: '产包／人闸',
    hkTaxZeroDesc: '开店不用记账：卖货自动入帐，其他单据拍张照，一键准备报税档。不是自动向税局完税。',
    hkTaxZeroHonesty: 'XRROSS 帮你整理帐和报税档；签名上传仍要你自己在税局网站做。',
    hkTaxZeroSales: '卖出',
    hkTaxZeroExpense: '支出',
    hkTaxZeroSurplus: '本年盈余',
    hkTaxZeroPrepare: '准备报税档',
    hkTaxZeroSign: '我核过了',
    hkTaxZeroUpload: '去税局上传',
    hkTaxZeroDownload: '下载报税档',
    hkTaxZeroAdvanced: '进阶（会计栏）',
    hkTaxZeroYa: '课税年度',
    hkTaxZeroCompany: '公司名',
    hkTaxZeroTaxFile: '税务档案编号',
    hkTaxZeroTwoTier: '两级制',
    hkTaxZeroHasEmp: '有雇员',
    hkTaxZeroSaveProfile: '存主档',
    hkTaxZeroRebuild: '重算底稿',
    hkTaxZeroAddAdj: '加调整',
    hkTaxZeroPartner: '推送 Partner',
    hkTaxZeroAck: '税局回执号',
    hkTaxZeroSaveAck: '回填回执',
    hkTaxZeroEmpAdd: '加入雇员',
    hkTaxZeroEmpPack: '产雇主报税包',
    storeReceiptInbox: '店铺单据',
    storeReceiptInboxView: '查看',
    storeReceiptInboxGate: '上传入帐',
    storeReceiptInboxDesc: '拍照上传租金／水电／外购单据，自动入帐并进香港报税底稿。不是自动向税局完税。',
    storeReceiptPickStore: '选店',
    storeReceiptReload: '刷新',
    storeReceiptHonesty: '营业额已从已付订单来；这里只补店外单据。入帐后仍须在报税台人闸签署。',
    storeReceiptTakePhoto: '拍照／选图上传',
    storeReceiptMerchantHint: '商户名（可空）',
    storeReceiptList: '已上传单据',
    storeReceiptEmpty: '尚未上传',
    storeReceiptDate: '日期',
    storeReceiptMerchant: '商户',
    storeReceiptAmount: '金额',
    storeReceiptKind: '科目',
    storeReceiptStatus: '状态',
    storeReceiptActions: '操作',
    storeReceiptConfirm: '确认入帐',
    storeReceiptReject: '作废',
    storeReceiptPreview: '看图',
    storeReceiptBadType: '只接受 JPG／PNG／WebP',
    storeReceiptBadSize: '单张不超过 8MB',
    storeReceiptUploadFail: '图档上传失败',
    storeReceiptIngestOk: '已收单',
    storeReceiptIngestFail: '入列失败',
    storeReceiptBooked: '已入帐',
    storeReceiptBookFail: '入帐失败',
    storeReceiptRejected: '已作废',
    storeReceiptRejectFail: '作废失败',
    storeReceiptOpenAssist: '打开助手',
    storeReceiptIDidCheck: '我做完了，检查',
    storeReceiptStatusDone: '完成',
    storeReceiptStatusCurrent: '进行中',
    storeReceiptStatusTodo: '未开始',
    xhmHardwarePartnerGroup: '工厂／硬件伙伴',
    xhmHardwarePartnerDesk: '伙伴／月结工作台',
    xhmHardwarePartnerDeskView: '查看',
    xhmHardwarePartnerDeskGate: '月结／挂单',
    xhmFamilySlotGroup: 'XHM 三轨槽位',
    xhmFamilySlotDesk: '槽位工作台',
    xhmFamilySlotDeskView: '查看',
    xhmFamilySlotDeskGate: '保存槽位',
    leoBrandOnboardingGroup: 'Brand Agent',
    leoBrandOnboardingDesk: 'Brand 建店工作台',
    leoBrandOnboardingDeskView: '查看',
    leoBrandOnboardingDeskConfirm: '确认写入',
    hkMarketChannelGroup: '香港上市通道',
    hkMarketChannelDesk: 'HK 收款／WhatsApp 工作台',
    hkMarketChannelDeskView: '查看',
    hkMarketChannelDeskGate: '模拟／配置',
    hkMarketSignup: '港店签约上手',
    hkMarketSignupGate: '签约提交',
    cnMarketChannelGroup: '大陆上市通道',
    cnMarketChannelDesk: '陆店收款／社交工作台',
    cnMarketChannelDeskView: '查看',
    cnMarketChannelDeskGate: '模拟／配置',
    cnMarketSignup: '陆店签约上手',
    cnMarketSignupGate: '签约提交',
    brandStorePaymentGroup: '品牌搭建',
    brandOpenPack: '自动开店',
    productShelf: '产品上架',
    produceGuide: '自动设备',
    brandStorePaymentBind: '品牌付款',
    brandAppListing: '品牌上架',
    storeAutonomousMarketingGroup: '店铺自主营销',
    storeAutonomousMarketingDesk: '自主营销工作台',
    storeAutonomousMarketingView: '查看',
    storeAutonomousMarketingGate: '放闸',
    workforceGroup: '排班出勤',
    workforceWeekSchedule: '周排班',
    workforceClock: '打卡出勤',
    workforceSummary: '出勤汇总',
    workforceSmartRoster: '智能排班',
    workforceMySchedule: '我的班表',
    workforcePayroll: '薪资月结',
    memberHqOps: '营运入口',
    distributorReportGroup: '渠道报表',
    distributorDashboard: '渠道总览',
    distributorMembers: '我的会员',
    distributorProfit: '分润明细',
    merchantTokenBillingPlatform: 'AI 点数',
    merchantDataBillingPlatform: '车载数据账单',
    linuxAutoOps: '车载运营',
    linuxAutoEquipment: '车载设备',
    linuxAutoRemoteOps: '远程运维',
    linuxAutoProfileConfig: 'Profile 配置',
    linuxAutoDataBilling: 'CAN 数据账单',
    linuxAutoModelRegistry: '型号注册',
    linuxAutoPartnerDelivery: '伙伴交付',
    linuxAutoFleetMonitor: '车队监控',
    linuxAutoDbcEntitlement: 'DBC 授权',
    linuxAutoCabinFeatures: '座舱功能',
    linuxAutoCanAutoMatch: 'CAN 自动匹配',
    operationAndMaintenanceServices:'运维服务',
    productionList:'出品清单',
    smallMaterial:'小料列表',
    takeoutProducts:'外卖产品',
    pointRule:'积分规则',
    couponManagement:" 优惠券管理",
    couponList:"  优惠券列表",
    additionalProducts:'额外产品',
    type:'产品类型',
    taxAllocation:'税务配置',
    produce:'产品列表',
    produceList4:'出品列表4',
    smoothieMakerProduct:'冰沙机出品',
    machineMenu:'设备菜单',
    systemLog:"系统日志",
    add:'新增',
    edit:'编辑',
    delete:'删除',
    search:'查询',
    reset:'重置',
    detail:'详情',
    batchImport:'批量导入',
    oneClickCopy:'一键复制',
    resetPwd:'重置密码',
    machineList:'设备列表',
    export:'导出',
    log:'日志',
    bindStore:'绑定店铺',
    bindMachine:'绑定设备',
    codeRule:'编码规则',
    batchDelete:'批量删除',
    region:'区域'



  },
  acoount: {
    name: '名称',
    enterpriseName: '企业名称',
    account: '账号',
    password: '密码',
    confirmPassword: '确认密码',
    roleTitle:'角色职称',
    roleName:'角色名称',
    searchKeyword:'账号/手机/邮箱/角色',
    phone:'手机号码',
    email:'邮箱',
    idNumber:'证件号',
    workAddress:'工作地址',
    status:'状态',
    onDuty:'在岗',
    leaveDuty:'离岗',
    takeVacationrm:'休假',
    disable:'禁用',
    profilePicture:'头像',
    confirmPasswordCannotBeEmpty:'确认密码不能为空',
    inconsistentPasswordInput:'密码输入不一致',
    emailFormatError:'邮箱格式错误',
    phoneNumberFormatError:'手机号格式错误',
    notes:'备注',
    empower:'授权',
    contactInformation:'联系方式',
    leoEntityId:'X-ID',
    leoEntityIdFilter:'筛选 X-ID',
    leoPrimaryAnchor:'Leo 主锚',
    leoPrimaryAnchorFilter:'筛选主锚',
    leoPrimaryAnchored:'已完成',
    leoPrimaryNotAnchored:'未完成',
    leoIdentityLinks:'登录对应',
    leoIdentityLinkCountSuffix:' 项',
    leoIdentityLinksTitle:'X-ID 登录对应关系',
    leoIdentityLinkLabel:'登录方式／账号',
    leoIdentityLinkKind:'类型',
    leoIdentityLinkPrimary:'主锚',
    leoIdentityLinkRef:'凭证',
    leoIdentityLinksEmpty:'此 X-ID 尚无挂接登录方式',
    userOrganizationType:'用户组织类型',
    userOrganizationName:'用户组织名称',
    describe:'描述',
    available:'可用',
    deactivate:'停用',

  },
  merchant: {
    account: '登陆账号',
    password: '密码',
    store: '店铺',
    status:'状态',
    available:'正常',
    deactivate:'停用',
    merchantName:'商家名称',
    searchKeyword:'商家名称/负责人/电话/地址',
    sapPageDesc:'金样页：标题｜筛选｜表格｜底栏；主按钮一个、列操作收进更多、中等密度。',
    sapListTitle:'商家列表',
    cooperationType:'商户类型',
    selectCooperationTypeFirst:'请先选择商户类型',
    noUserOrganizationForType:'该类型下暂无用户组织，请先在「用户组织」中配置',
    enterpriseSegment:'经营场景',
    segmentDistributor:'渠道批发',
    segmentShop:'门店商用',
    segmentHome:'家用 Leo',
    businessLicense:'营业执照',
    frontIDCard:'身份证正面',
    backIDCard:'身份证反面',
    head:'负责人',
    Telephone:'联系电话',
    userOrganization:'用户组织',
    businessAddress:'注册地址',
    trade:'营业',
    closeBusiness:'歇业',
    superior:'上级',
    supervisorSubordinateRelation:'上下级关系',
    clickView:'点击查看',
    business:'商家',
    country:'国家',
    address:'地址',
    shopNames:'店铺名称',
    storeType:'门店类型',
    selfService:'自助',
    askFor:'自取',
    SelfPickupTakeoutShop:'自取+外卖店',
    selfServicePickUpTakeout:'自助+自取+外卖',
    businessHours:'营业时间',
    closingTime:'打烊时间',
    operatingCycle:'营业周期',
    Monday:'周一',
    Tuesday:'周二',
    Wednesday:'周三',
    Thursday:'周四',
    Friday:'周五',
    Saturday:'周六',
    Sunday:'周日',
    picture:'图片',
    vatNumber:'VAT增值税号',
    kvtCompanyRegistrationNumber:'KVK公司注册号码',
    invoiceUnifiedNumbering:'发票统编',
    invoiceAccountNumber:'发票账号', 
    POSAPIKey:'POS API Key',
    POSAccount:'POS Account',
    APPAPIKey:'APP API Key',
    APPAccount:'APP Account',
    APPClientKey:'APP Client Key',
    region:'区域'

  },
  device:{
    sapPageDesc:'金样页：标题｜KPI｜筛选｜表格｜底栏；主按钮一个、列操作收进更多、中等密度。',
    sapKpiTitle:'设备概况',
    sapListTitle:'设备列表',
    mapShowLocation:'地图显示位置',
    deviceType:'设备类型',
    totalDevice:'设备总数',
    passConfigName:"名称",
    offLineDevice:'离线设备',
    materialShortageDevice:'缺料设备',
    alertingDevice:'报警设备',
    lockDevice:'锁机设备',
    maintenanceDevice:'需要保养设备',
    businessInformation:'设备业务资料',
    deviceId:'设备ID',
    deviceModel:'型号',
    modelCodeKey:'型号代码',
    modelCodePlaceholder:'例：PT5 或 XRROSS_PT5，需全站唯一',
    modelCodeRequired:'请填写型号代码（对应 Leo model_key）',
    dealer:"零售商",
    deviceImie:'设备编码',
    appVersion:'App版本',
    appKeyword:'软件名称',
    appVersionOp:'版本比较',
    appVersionOpEq:'等于',
    appVersionOpContains:'包含',
    appVersionOpLt:'低于',
    appVersionOpGt:'高于',
    appVersionOpLte:'不高于',
    appVersionOpGte:'不低于',
    appVersionFilter:'机上版本',
    appVersionReportStatus:'版本上报',
    appReportHas:'有上报',
    appReportNone:'从未上报',
    appReportStale:'上报过期(7天)',
    appPublishRel:'对比发版',
    appPublishBehind:'落后发版',
    appPublishEqual:'等于发版',
    appPublishAhead:'高于发版',
    equipmentSerialNumber:'设备序列号',
    posNumber:'刷卡机编码',
    store:'店铺',
    location:'设备位置',
    none:'暂无',
    log:"日志",
    fault:"故障",
    normal:"正常",
    offline:"离线",
    linkOffline:"模组离线",
    onLine:"在线",
    isFault:"是否故障",
    type:"类型",
    fullyAutomatic:"全自动",
    semiAutomatic:"半自动",
    availableMerchants:"可使用商家",
    faultStatistics:"故障统计",
    basicMaintenance:"基础保养",
    deepMaintenance:"深度保养",
    onLineDevice:'在线设备',
    equipmentOnlineStatus:"设备状态:",
    moduleLinkStatus:"模组连线:",
    hostProduceStatus:"主机可制作:",
    hostReadyCanProduce:"可制作",
    hostReadyNeedWake:"需唤醒",
    hostReadyUnknown:"未知",
    linkOnlineHostSleep:"在线·主机休眠",
    macFastRebindEnabled:"MAC快速重绑",
    macFastRebindPending:"重绑未就绪",
    brandName: "品牌名称:",
    telephone: "电话:",
    equipmentModelName: "设备型号/名称:",
    dateOfManufacture: "生产日期:",
    usageDate: "使用日期:",
    menu:"菜单",
    productName :"产品名",
    channelConfiguration :"通道配置",
    channelNumber :"通道号",
    material :"物料",
    shelfLife :"保鲜期",
    alarmListForTheDay: "报警列表(当天)",
    content :"内容",
    time :"时间",
    key: "按键",
    frequency :"次数",
    remoteOperation :"远程操作",
    cloudIris:'雲瞳 · 真屏遥控',
    cloudIrisShort:'云瞳',
    cloudIrisNeedImie:'缺少机码，无法打开云瞳',
    cloudIrisVersionLow:'App 版本低于云瞳最低要求（需 {minVersion}，目前 {appVersion}）',
    cloudIrisNoVersion:'尚无 App 版本上报，无法确认是否支持云瞳',
    cloudIrisNotReadyFamily:'此机型云瞳尚未就绪',
    cloudIrisNotLicensed:'此设备未购买云瞳，请在签约加购中勾选该机',
    cloudIrisNeedUpgradeShort:'云瞳需升级',
    cloudIrisOldVersionShort:'旧版',
    cloudIrisEnd:'结束雲瞳',
    cloudIrisWaiting:'等待设备推流…',
    cloudIrisLive:'已连上，可点触机屏',
    cloudIrisFailed:'雲瞳未就绪',
    cloudIrisUpgradeConfirmTitle:'确认云瞳升级',
    cloudIrisUpgradeConfirm:'将对机码 {imie} 推送 OTA 强更（目标 ≥ {minVersion}，目前 {appVersion}）。\n{detail}\n仅影响此一台，不会改动其他客户灰度名单。',
    cloudIrisUpgradeConfirmOk:'同意并推送',
    cloudIrisUpgradePushSent:'已推送 OTA 检查令（{imie}）',
    cloudIrisUpgradePushOffline:'已加入灰度白名单，设备离线或未 ACK（{imie}）',
    cloudIrisUpgradePushFailed:'云瞳 OTA 推送失败',
    identityAndLink:'身份与连线',
    storeAddress:'门市地址',
    deviceGeo:'设备定位',
    deviceGeoLoading:'定位加载中…',
    deviceGeoNone:'暂无定位',
    menuStatus: "菜单状态",
    updated:  "已更新",
    notUpdated:  "未更新",
    success :"成功",
    lock: "锁机",
    unlock: "解锁",
    startup: "开机",
    shutdown: "关机",
    restart: "重启",
    param: "参数",
    factoryParam: '出厂参数',
    moduleParam: '模块参数',
    paramBaselineOpen: '设置参数',
    paramBaselineTitle: '设置参数（Leo 型号基准）',
    paramBaselineHint: '参数键请与设备配置 JSON path 一致（例：config.stirTime）；保存后供 Leo 与机器实际配置比对。',
    paramBaselineAddRow: '新增参数行',
    paramBaselineSave: '保存',
    paramBaselineRefresh: '重新加载',
    paramKey: '参数键',
    paramKeyPh: '例：config.stirTime',
    paramDisplayName: '显示名称',
    standardValue: '标准值',
    lowerLimit: '下限',
    upperLimit: '上限',
    unit: '单位',
    paramRemark: '备注',
    paramBaselineNoProfile: '该型号尚无可读取的 L1 配置文件（或无 PUBLISHED 版）。请先在「配置文件管理」建立／发布绑定该型号的 Profile。',
    paramBaselineProfileSource: '参数默认来源：{name} · published 版号 {version}',
    paramBaselineApplyPublished: '从最新 published 套用',
    paramBaselineApplyConfirm: '将按最新 published 的 JSON 合并至表格（同键将覆盖标准值与上下限，并新增不存在的键）。确定？',
    paramBaselineApplyDone: '已套用 published 建议值（请确认后保存）',
    paramBaselineTypeUnionTitle: '同设备类型 · 各型号 published 路径联集（参考）',
    paramBaselineTypeUnionMissing: '无 Profile 的型号 ID',


  },
  produce: {
    name: '名称',
    price: '价格',
    uberPrice: 'Uber单价',
    matterType: '物料类型',
    materialRoleBean: '咖啡豆',
    materialRoleMilk: '液态奶',
    materialRolePowder: '粉料',
    materialRoleWater: '水',
    materialRoleTeaLeaf: '茶叶',
    materialRoleTeaBroth: '茶汤',
    materialRoleSyrup: '糖浆',
    materialRoleLiquor: '酒',
    materialRoleConsumable: '耗材',
    matterTypeKind: '类型性质',
    matterTypeKindPhysical: '实体物料',
    matterTypeKindParameter: '参数',
    matterTypeParameterHint: '「参数」类型不参与物料消耗统计，适用于程序、浓度档、水温等制作维度。',
    physicalMaterial: '物理物料',
    physicalMaterialHint: 'V1：先选店仓物理 SKU；未选可勾「按名称新建物理并自动映射」。',
    physicalMaterialRequired: '请选择物理物料，或勾选按名称新建物理物料',
    createPhysicalIfMissing: '按名称新建物理物料并自动映射',
    countsInConsumption: '计入消耗',
    normType: '规格类型',
    matter: '物料',
    min: '最小值',
    max:'最大值',
    shelfLife:'保鲜期',
    unit:'单位',
    hour:'小时',
    step1:'产品资料',
    step2:'产品物料',
    step3:'产品配方',
    step4:'配方组合',
    step5:'产品小料',
    produceName:'出品名称',
    produceCode:'出品编码',
    produceType:'出品类型',
    showSnacks:'显示小吃',
    yes:'是',
    no:'否',
    describe:'描述',
    order:'顺序',
    value:'值',
    unit:'单位',
    norm:'规格',
    select:'选择',
    step:'步骤',
    matterSequence:'物料顺序',
    action:'操作',
    freeSnacks:'免费小料',
    feeBasedMaterials:'收费小料',
    nextStep:'下一步',
    back:'上一步',
    save:'保存',
    saveUpdate:'保存更新',
    productList:'出品菜单',
    selectProduct:'选择出品',
    menuSort:'排序',
    produceImport:'出品导入',
    bind:'绑定',
    bindMachien:'绑定设备',
    smallMatterType:'小料类型',
    listing:'上架',
    productDetail:'产品详情',
    produceEquipment:'制作流水线',
    canMake:'可生产',
    cannotMake:'本店未挂此型号',
    noRecipe:'还没有配方／制作参数',
    noCombo:'还没有规格组合',
    noProduceEquipment:'还没有点单／扫码制作流水线',
    consumableNoMachine:'耗材（不占机）',
    orderOnLeo:'本店无点单机／收银机 → 用手机 Leo 点单',
    isSales:'可下单',
    productListName:"输入出品菜单名称",
    Text1:'输入出品名称',
    Text2:'商家',
    Text3:'物料',
    Text4:'小料',
    Text5:'饮品',
    Text6:'小吃',
    Text7:'新增配方',
    Text8:'更新',
    Text9:'该产品编码已存在',
    Text10:'请完善产品信息',
    Text11:'茶品',
    Text12:'第一段',
    Text13:'第二段',
    Text14:'第三段',
    Text15:'出',
    Text16:'不出',
    Text17:'范围:',
    Text18:'茶叶量:',
    Text19:'仅可填数字', 
    Text20:'冰块量:',
    Text21:'搅拌时间不能大于同段萃茶/萃取时间（上限 {max}）',
    Text22:'萃茶/萃取时间不能小于当前搅拌时间（{min}）',
    Text23:'配方「{name}」搅拌时间超过萃茶/萃取时间（上限 {max}），请调整后再保存',
    codeRule:'编辑规则',
    prefix:'前缀',
    suffix:'后缀',
    review:'预览',
    codeRuleDescribe:'这个格式就是收银系统打印编码的格式',

  },
  business: {
    name: '名称',
    type: '类型',
    homepage: '主页',
    advertisingList: '广告清单',
    pictureOrVideo: '图片/视频',
    addProductAdvertisements:'新增产品广告',
    AddImagesOrvideos:'新增图片/视频',
    userName: '用户名',
    email: '邮箱',
    sex: '性别',
    birthday: '生日',
    phone: '手机号',
    walletBalance: '钱包余额',
    integral: '积分',
    orderNo: '订单号',
    pickupCode: '取餐码',
    orderSource: '来源',
    orderSourceAll: '全部来源',
    orderSourceTable: '桌码',
    orderSourceNormal: '一般',
    tableNo: '桌号',
    store: '店铺',
    amount: '订单金额',
    payAmount: '实付金额',
    receiptsPrice: '实收金额',
    discount: '优惠',
    orderStatus: '订单状态',
    toBePaid: '待支付',
    paid: '已支付',
    processing: '处理中',
    completed: '已完成',
    orderCancellation: '订单取消',
    orderRejection: '订单拒绝',
    paymentMethod: '支付方式',
    wallet: '钱包',
    cash: '现金',
    pos: '刷卡机',
    thirdParty: '第三方',
    otherPay: '其他',
    produce: '产品',
    unitPrice: '单价',
    number: '数量',
    parameter: '参数',
    totalTaxAmount:'总税额',
    taxName:'税名',
    taxAmount:'税额',
    taxRate:'税率',
    orderType: '订单类型',
    pack: '打包',
    dineIn: '堂食',
   
  },
  file: {
    name: '名称',
    version: '版本',
    keyword: '标识',
    file:'文件',
    upload:'上传',
    remark: '备注',
    publishStatus: '发布状态',
    published: '对外最新',
    archived: '已归档',
    backupStatus: '服务器备份',
    backedUp: '已备份',
    notBackedUp: '未备份',
    otaStatus: 'OTA状态',
    otaLiveBacked: '对外最新·已备份',
    otaLiveNoBackup: '对外最新·未备份',
    otaArchivedBacked: '已归档·已备份',
    otaArchivedNoBackup: '已归档·未备份',
    otaLinkBroken: '链接失效',
    otaStatusTipTitle: '状态说明：',
    otaStatusTipLiveBacked: '绿＝正在对外发且服务器有备份，正常。',
    otaStatusTipLiveNoBackup: '橙＝正在对外发但未备份，请补备份或重传。',
    otaStatusTipArchivedBacked: '灰＝已不对外，但可回滚。',
    otaStatusTipArchivedNoBackup: '红＝已归档且无备份，基本不可回滚，建议重传。',
    otaStatusTipLinkBroken: '红「链接失效」＝下载地址空或云端 404/不通，请重新上传 APK。',
    recheckLinks: '重新检查链接',
    history: '历史',
    historyTitle: '版本历史',
    backupNow: '补备份',
    batchBackup: '批量补备份',
    batchArchive: '批量归档',
    batchBackupConfirm: '确认对勾选项执行补备份？',
    batchBackupDone: '批量补备份结束',
    selectFirst: '请先勾选要操作的 APP',
    copyLink: '链接',
    linkCopied: '下载链接已复制',
    linkCopyFailed: '复制失败，请手动复制',
    noDownloadLink: '此 APP 尚无下载链接',
    backupRemoteGone: '云端 APK 已不存在（404）。请重新上传 APK 后再备份。',
    archive: '归档',
    archiveConfirm: '归档后旧设备不再取此版（文件保留可回滚），确认',
    rollback: '回滚',
    rollbackConfirm: '确认回滚为此版本？当前对外最新将归档保留。',
    otaBackupHint: '保存后系统会把包拉到服务器制品仓备份；旧设备仍用原下载链接。',
    otaReuploadHint: '若补备份报 404：云端文件已删，请在此重新上传 APK 后再点确定。',
    otaGray: '灰度',
    otaGrayOff: '全量',
    otaGrayOn: '灰度({n}台)',
    otaGraySet: '设置灰度',
    otaGrayHint: '开=仅白名单机码可升此版；关或名单空=全量。',
    otaGrayMachines: '灰度机码',
    otaGrayMachinesPlaceholder: '一行一个机码，也可用逗号分隔',
    otaForceUpgrade: '强制升级',
    otaForceUpgradeHint: '开=机端不可取消更新；可与灰度并用。',
    otaPushForce: '立即推送',
    otaPushForceConfirm: '向灰度白名单机立即推送强制升级检查？离线机会记为 offline。',
    otaPushForceResult: '推送完成：共 {total}，送达 {delivered}，离线 {offline}',

    pendingIntentGate: 'PendingIntent闸',
    pendingIntentGatePass: '已过闸',
    pendingIntentGateSkip: '已跳过',
    pendingIntentGateNa: '不适用',
    pendingIntentGateFail: '未过闸',
    pendingIntentGateUnknown: '未标记',
    pendingIntentGateTipPass: '发版时已通过 Android 12 PendingIntent 硬闸（可安全作为 OTA 源）。',
    pendingIntentGateTipSkip: '发版时人工跳过硬闸，存在风险。',
    pendingIntentGateTipNa: 'targetSdk 较低或无 UpdateDialog，硬闸不适用。',
    pendingIntentGateTipFail: '已扫描：targetSdk≥31 且 UpdateDialog 缺少 PendingIntent 修法，从此版 App 内 OTA 会崩。',
    pendingIntentGateTipUnknown: '历史版本无闸标记；新发版或回填扫描才会写入。'
  },
  coupon: {
    Text1: '名称',
    Text2: '优惠金额',
    Text3: '消耗积分',
    Text4:'状态',
    Text5:'详情',
    Text6:'可用',
    Text7:'不可用',
    Text8:'有效天数'
   
  },
  pass: {
    name: '名称',
    pass: '通道',
    passNumber: '通道号',
    preDischargeTime: '预出料时间',
    addPass:'新增通道',
    bindPass:'通道绑定',
    passConfigName:'通道配置名称'
   
  },
  operation:{
    business_data:"业务数据看板",
    orderAmount:"订单金额",
    orderQuantity:"订单数量",
    actualAmountReceived:"实收金额",
    top_10_beverage_rankings:"饮品榜单Top10",
    sales_revenue:"销售额",
    order_quantity:"订单数量",
    payment_method:"付款方式",
    real_time_orders_on_the_hour:"整点实时订单",
  },
  dataCenter:{
    Text1:"内容",
    Text2:"数据",
    Text3:"销售量/杯",
    Text4:"销售额/元",
    Text5:"消耗物料/g",
    Text6:"月",
    Text7:"日",
    Text8:"时",
    Text9:"图表",
    Text10:"单杯消耗物料",
    Text11:"排名",
    Text12:"出品消耗物料",
    Text13:"设备消耗物料",
    Text14:"百分比",
    Text15:"排名",
    Text16:"销售量",
    Text17:"销售额",
    Text18:"时间/S",
    Text19:"出品销售量",
    Text20:"出品销售额",
    Text21:"设备销售量",
    Text22:"设备销售额",
    Text23:"总杯量",
    Text24:"总配方量/克",
    Text25:"实际总配方量/克",
    Text26:"坏杯量/杯",
    Text27:"坏杯率/%",
    Text28:"误差率/%",
    Text29:"出品名称",
    Text30:"制作方式",
    Text31:"扫码-全管",
    Text32:"产品-全管",
    fullPipeModeValue:"满管",
    fullPipeMode:"模式",
    calibComplete:"已完成",
    calibIncomplete:"未完成",
    calibValue:"数值",
    calibModeChannel:"通道校准",
    calibModeScale:"小称校准",
    calibMode:"校准模式",
    pipeActualText:"单管实际量(g)",
    Text32Single:"产品-单管",
    Text31Single:"扫码-单管",
    Text33:"手动",
    Text34:"订单号",
    Text35:"门店",
    Text36:"单价",
    Text37:"配方总量",
    Text38:"实际出杯量",
    Text39:"出杯时间",
    Text40:"误差(%)",
    Text41:"坏杯",
    Text42:"正常",
    Text43:"制作完成",
    Text44:"制作失败",
    Text45:"完成时间",
    Text46:"模式",
    Text47:"通道",
    Text48:"状态",
    Text49:"未完成",
    Text50:"已完成",
    Text51:"出品名称",   
    Text52:"杯数", 
    Text53:"总价",  
    Text54:"订单统计",  
    Text55:"订单列表",  
    Text56:"订单金额",  
    Text57:"订单数量",  
    Text58:"实收金额",    
    Text59:"产品金额",   
    Text60:"茶叶量",   
    Text61:"出水量",  
    Text62:"销售量/桶",   
    Text63:"桶",    
    Text64:"偏酸/萃取过短",    
    Text65:" 均衡/萃取适中",    
    Text66:"偏苦/萃取过度",    
    Text67:"味苦/浓度低",    
    Text68:"适中",    
    Text69:"强/浓度高",  
    Text70:"萃取时间",    
    Text71:"水粉比",      
    strongBalance:"強平衡",
    weakBalance:"弱平衡",
    mediumAcid:"中酸",
    strongAcid:"強酸",
    goldenCup:"金杯",
    weakAcid:"弱酸",
    bitter:"苦",
    strongBitter:"強苦",
    weakBitter:"弱苦",  
    extractionTime:"萃取时间",   
    Text72:"动态校准",
  },
  taxation:{
    Text1:"税名",   
    Text2:"税率",   
    Text3:"基数", 
    Text4:"备注", 
    Text5:"国家", 
    Text6:"类型",  
    Text7:"堂食",  
    Text8:"打包",  
    Text9:"产品类型",
    Text10:"税种",
    Text11:"平台外卖",       
  },
  uber:{
    Text1:"uber店铺",   
    Text2:"平台店铺",   
    Text3:"菜单状态",
    Text4:"店铺状态",
     Text5:"已绑定",
     Text6:"未绑定",
     Text7:"同步"
    
  },

  login: {
    title: '系统登录',
    logIn: '登录',
    username: '账号',
    password: '密码',
    readAndAgree:'已阅读并同意',
    pleaseCheckThePrivacyAgreement:'请勾选并同意《隐私政策》《服务条款》与《免责声明》后再登录',
    termTip:'《隐私政策》《服务条款》与《免责声明》',
    Text1:'请输入账号',
    Text2:'请输入账号',
    leoSmartComingSoon: 'Leo Smart 专业站即将上线'


  },
  navbar: {
    logOut: '退出登录',
    dashboard: '首页',
    github: '项目地址',
    screenfull: '全屏',
    theme: '换肤',
    size: '布局大小',
    globalSearchTitle: '站内搜索',
    globalSearchPlaceholder: '搜索菜单／店铺／设备／物料／工单（Ctrl+K）',
    globalSearchHotkeyHint: '打开站内搜索（Ctrl+K）',
    globalSearchRecent: '最近搜索',
    globalSearchSaved: '已存视图',
    globalSearchEmpty: '无结果',
    globalSearchSaveView: '保存当前视图',
    globalSearchSaveViewPrompt: '视图名称',
    globalSearchDefaultViewName: '视图',
    globalSearchSavedOk: '已保存视图',
    globalSearchFooterHint: 'Enter 打开首条 · Esc 关闭',
    globalSearchGroupMenus: '菜单',
    globalSearchGroupStores: '店铺',
    globalSearchGroupEquipment: '设备',
    globalSearchGroupMaterials: '物料',
    globalSearchGroupTickets: '工单',
    globalSearchMissingRoute: '没有可打开的页面'
  },
  tagsView: {
    refresh: '刷新',
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  },
  common:{
    tower:'台',
    yuan:'元',
    cup:'杯',
    place:'位',
    individual:'个',
    language:'语言',
    success:'成功',
    fail:'失败',
    createTime:'创建时间',
    all:'全部',
    common:'全部',
    sureDel:'确定删除',
    tip:'提示',
    status:'状态',
    bing:'绑定',
    pleaseSelectDevice:'请选择设备',
    pleaseSelectMenu:'请选择菜单',
    pleaseSelectModel:'请选择型号',
    pleaseSelect:'请选择',
    code:'编码',
    entering_the_platform:'进入平台',
    date:"日期",
    address_fail:"地址不正确",
    back:'返回',
    pleaseEnter:'请输入',
    uploadImageBtn:'点击上传图片',
    uploadImageBtnTip:'仅支持上传JPG 格式和PNG格式（限制10M以内）',
    uploadVideoBtn:'点击上传视频',
    uploadVideoBtnTip:'仅支持上传mp4或者MP4文件（限制50M以内）',
    videoPlayTip:' 您的浏览器不支持视频播放',
    menuVersion:"菜单版本"
    
  },
  table:{
    search: '查询',
    detail:'详情',
    actions: '操作',
    edit: '编辑',
    publish: '发布',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定',
    add:'新增',
    copy:'复制',
    produceCodeRule:'编码规则',
    batchDeletion:'批量删除',
    batchImport:'批量导入',
    batchCopy:'批量复制',
    export:'数据导出',
    exportAll:'导出全部',
    import:'导入',
    templateDownload:'模板下载',
    dragAndDropUpload:'将文件拖到此处，或点击上传',
    picture:'图片',
    resetPwd:'重置密码',
    more:'更多',
    reset:'重置'
  },
  coffeeData:{
    Text1:"浸泡流量",   
    Text2:"浸泡时间",   
    Text3:"萃取流量",   
    Text4:"萃取压力",   
    Text5:"萃取温度",   
    Text6:"订单类型",   
    Text7:"状态",   
    Text8:"出杯时间",  
    Text9:"粉量",   
    Text10:"设备编码",   
    Text11:"出品名称",   
    Text12:"咖啡液",   
    Text13:"压粉力度",   
    Text14:"粉饼厚度",   
    Text15:"萃取流速",   
    Text16:"萃取腔体位置",  
    Text17:"研磨度1",  
    Text18:"研磨度2",  
     
  },
  channelCmd: {
    desc: '一眼看 A 线直销社媒、B 线授权／头牌：在用、在推、无官方发布 API、等人闸。本页不能发帖。',
    reload: '重新加载',
    v1Note: '第一版只读。有官方发布 API 的渠道：人手只做一次接通／过审，之后由 AI 发。没有官方发布 API 就不做手工发。商务／展会仍人手。',
    fLine: '市场线',
    fKind: '类型',
    fRegion: '地区',
    fStatus: '状态',
    fPromo: '正在推',
    fApi: '有官方 API',
    fHuman: '等人闸',
    fAi: 'AI 代运营',
    fSku: 'SKU',
    fLocale: '语种',
    fQ: '平台／备注',
    reset: '清空筛选',
    yes: '是',
    no: '否',
    lineA: 'A 线直销',
    lineB: 'B 线授权',
    lineBoth: '两线共用',
    aInUse: 'A 在用',
    aPromo: 'A 在推',
    bInUse: 'B 在用',
    noApi: '无 API',
    needsHuman: '等人闸',
    hold: '冻结',
    aiReady: 'AI 已可发',
    afterConnect: '接上后 AI 发',
    humanOnly: '只人手',
    total: '当前条数',
    colA: 'A 线 · 直销社媒',
    colB: 'B 线 · 授权／头牌',
    cPlatform: '平台',
    cStatus: '状态',
    cPromo: '在推',
    cApi: 'API',
    cKind: '类型',
    cRegion: '地区',
    cNote: '备注',
    cAi: '谁干活',
    cFollow: '人手跟进',
    cComms: '通讯',
    comms: '通讯历史',
    chatEmpty: '尚无通讯记录。发帖、OAuth、跟进都请登录在此。',
    sideUs: '我方',
    sideThem: '渠道／对方',
    logInbound: '登录对方回复',
    logOutbound: '登录我方跟进',
    subject: '主题',
    chatPlaceholder: '通讯内容…',
    logSave: '写入历史',
    openLink: '打开链接',
    openFollow: '打开跟进页',
    noFollowUrl: '无公开入口',
    step1: '打开总控',
    step2: '筛线与状态',
    step3: '读在用／在推',
    coachBadge: '现在请做',
    coachHint: '本页只看矩阵，不要在这里发帖。点行可看通讯历史。',
    coachNext: '下一步',
    kind: { social: '社媒', commerce: '电商', license: '授权', web: '官网', email: '邮件' },
    region: { US: '美国', CN: '中国', HK: '香港', JP: '日本', GLOBAL: '全球' },
    status: {
      LIVE: '在发',
      TOKEN_PRESENT: '有凭证',
      NEEDS_TOKEN: '缺凭证',
      NEEDS_OAUTH: '要授权',
      NEEDS_REAUTH: '要重授权',
      NEEDS_HUMAN_GATE: '等人闸',
      HOLD_NO_APP_AUDIT: '应用未过审',
      HOLD_NO_COMPANY_PAGE: '缺公司页',
      NO_API: '无官方 API',
      PROBE: '探测中'
    },
    ai: {
      ai_ready: 'AI 已可发',
      after_connect: '接上后 AI 发',
      human_only: '只人手（BD／条款）',
      no_api_skip: '无 API · 不发'
    }
  },
  bCrm: {
    desc: 'B 端客户台：头牌买家＋经销商。管道阶段、产品分类／SKU 筛选、联络人、活动、统一发推排队。',
    reload: '重新加载',
    applyFilter: '应用筛选',
    v1Note: '可按产品分类筛不同产品线。勾选有邮箱客户后统一发推＝默认排队；实发须运维放行。',
    fType: '账户类型',
    fFunnel: '漏斗',
    fStage: '阶段',
    fRegion: '地区',
    fOwner: '负责人',
    fProdCat: '产品分类',
    fSku: '产品 SKU',
    fPromo: '正在推',
    fPriority: '优先级',
    fHasEmail: '有邮箱',
    fContactStatus: '联络完备度',
    fQ: '名称／备注',
    reset: '清空筛选',
    yes: '是',
    no: '否',
    campaign: '统一发推',
    head: '头牌',
    dealer: '经销',
    promoting: '在推',
    withEmail: '有邮箱',
    total: '当前',
    queue: '排队战役',
    accounts: '客户列表',
    detail: '客户详情',
    contacts: '联络人',
    activities: '活动',
    notes: '备注',
    openLi: 'LinkedIn',
    cContact: '主联络人',
    cEmailAddr: '邮箱',
    cLinkedin: 'LinkedIn',
    cContactStatus: '联络状态',
    cRole: '角色',
    contactStatus: {
      EMAIL_OK: '有BD邮箱',
      LINKEDIN_ONLY: '仅LinkedIn',
      MISSING: '缺联络'
    },
    subject: '主题',
    body: '正文',
    cancel: '取消',
    sendQueue: '加入发推行列',
    campaignHint: '已选 {n} 户（仅有邮箱可勾选）',
    queuedOk: '已排队 {n}，跳过 {s}',
    coachBadge: '现在请做',
    coachHint: '先筛产品分类，再勾选发推。',
    coachNext: '下一步',
    coach1: '打开 B端CRM，看头牌／经销汇总',
    coach2: '按产品分类或 SKU 筛选',
    coach3: '勾选客户并统一发推排队',
    railOpen: '打开',
    railFilter: '产品筛选',
    railCampaign: '统一发推',
    cName: '名称',
    cType: '类型',
    cFunnel: '漏斗',
    cStage: '阶段',
    cPri: '优先',
    cCats: '产品分类',
    cSkus: 'SKU',
    cPromo: '在推',
    cOwner: '负责人',
    cNext: '下一步',
    cEmail: '邮箱',
    cAction: '操作',
    interactions: '互动记录',
    chatEmpty: '尚无往来记录',
    sideUs: '我方',
    sideThem: '客户',
    logReply: '登录客户回信',
    logOutbound: '登录我方发出',
    chatPlaceholder: '粘贴邮件正文或摘要…',
    logSave: '写入记录',
    logOk: '已写入互动记录',
    type: { head_buyer: '头牌买家', dealer: '经销商' },
    funnel: { L: 'License', H: 'OEM／H', DEALER: '经销', BOTH: '两线' },
    stage: {
      lead: '线索',
      contacted: '已联系',
      replied: '已回信',
      negotiating: '洽谈中',
      won: '成交',
      lost: '丢失',
      hold: '搁置'
    },
    cat: {
      HOME_OEM: '家用整机',
      COMMERCIAL_OEM: '商用整机',
      LICENSE: '授权大脑',
      CONSUMABLE: '豆／耗材',
      AFTERSALES: '售后配件',
      OTHER: '其他'
    }
  },
  immersivePromo: {
    sampleTitle: '沉浸推广样板',
    sampleDesc: '上面＝本页真实导航入口（与侧栏同一棵树）；广告带固定在页底，中间卡片自己滑。',
    navEmpty: '目前没有可展示的导航入口，请确认已登录且有菜单权限。',
    navChildren: '查看子菜单',
    sampleHint: '广告区不扮演功能入口。右侧箭头看更多广告。',
    adRailKicker: '为你推荐',
    adMore: '更多',
    adMoreTitle: '更多广告',
    navEnter: '点击进入',
    helpFoot: '导航卡＝进功能；广告带＝推送。点箭头看更全的广告。',
    surface: '推广面',
    surfaceHome: '客户首页',
    surfaceDataCenter: '数据中心',
    portrait: '画像',
    portraitOem: '设备生产商',
    portraitDist: '业务分销商',
    portraitChain: '实体连锁运营者',
    ownedSkusHint: '模拟已购 SKU（逗号分隔）',
    leoInstalled: '已装 Leo',
    leoActive: '近7日活跃',
    strategyLabel: '策略器',
    ownedTitle: '已开通功能',
    promoTitle: '可加购能力',
    promoLead: '卡片外观像功能；文案像广告（便利／好处）。鼠标移上去看详细说明，再决定试用。',
    zoneOwnedHint: '功能入口',
    zoneUnlockHint: '能力发现 · 广告文案',
    tagOwned: '可用',
    tagPromo: '加购',
    tagCapability: '可开通',
    hoverHint: '移上查看详情',
    adDetailKicker: '为什么值得试',
    adDetailClose: '关闭',
    leoQrHint: '扫码安装 Leo：苹果 App Store；安卓海外 Google Play，大陆走本区节点。',
    leoQrAlt: 'Leo 扫码下载',
    trialBadge: '免费试用',
    freeUpgradeBadge: '免费升级',
    adPromoPriceLabel: '当前优惠',
    adPriceLabel: '价格',
    adPriceFallback: '免费试用 · 优惠价另计',
    ctaOpen: '打开',
    ctaTrial: '先试用',
    ctaFreeUpgrade: '免费升级',
    ctaSign: '试用后再签约',
    ctaSampleOnly: '样板 CTA：正式试用／签约另接 entitlement',
    ctaTrialHint: '先试用，用好了再决定要不要签约，现在不会收费。',
    ctaPathMissing: '这则广告还没接到可进的页面，请稍后再试。',
    ctaTrialFirst: '下一步是试用。试用满意再签约，不会现在拉你去签约台。',
    ctaFreeUpgradeFirst: '下一步：升级机器 → 下载手机 App → 打开云瞳开始用。不用懂 AI，跟着做即可。',
    freeUpgradeStarted: '已开始免费升级引导：先升级机器，再装 App，就能用。',
    noPromo: '此画像本域暂无可加购能力卡',
    reload: '重新加载',
    goPortraits: '客户画像',
    goOrchestrate: '广告编排',
    loadFail: '加载推广面失败',
    orchDesc: '人只选模式与框；真正排出档期／对象／内容顺序的永远是 AI。',
    orchMode: '编排模式',
    orchMode1: '1 · 人工框＋AI 编排',
    orchMode2: '2 · 全开接管',
    orchMode1Hint: '先设范围／内容／时间（可只设几项），保存后 AI 只在框内编排页底广告。',
    orchMode2Hint: '不设限制，由 AI 全面决定谁／什么／何时。仍禁止一次全推；月主题钉住，其余按画像补。',
    orchAudience: '推广范围',
    orchContent: '推广内容',
    orchTheme: '本月主题',
    orchThemeHint: '空白＝用当月默认（现为 Leo＋云瞳）。主题会一直钉在广告带；其余按客户画像补。',
    orchThemeSkus: '主题 SKU',
    orchSchedule: '推广时间',
    orchSkus: 'SKU／域包',
    orchAny: '不限（空白＝该维度不卡）',
    orchDates: '起迄日期',
    orchHours: '每日时段',
    orchStart: '开始',
    orchEnd: '结束',
    orchDailyStart: '每日开始',
    orchDailyEnd: '每日结束',
    orchSave: '保存',
    orchSaveOk: '已保存，AI 会按此框编排',
    orchSaveFail: '保存失败',
    orchLoadFail: '加载编排设置失败',
    orchGoSample: '沉浸推广样板',
    orchHelpFoot: '结果落在页底广告带，不是再造功能入口。时区 Asia/Shanghai。',
    contentDesc: '商城推荐固定四格：标题、正文、图片、视频。文案必出繁／简／英／日；每格可 AI 生成，也可一键全部生成。不满意就改或上载自己的图／视频。',
    contentList: '推荐内容',
    contentTitleCol: '标题',
    contentFmtTitle: '标题',
    contentLangTw: '繁中',
    contentLangZh: '简中',
    contentLangEn: 'EN',
    contentLangJa: '日本語',
    contentFmtBody: '正文',
    contentFmtImage: '图片',
    contentFmtVideo: '视频',
    contentGenAll: '一键全部生成',
    contentHint: '人的建议',
    contentHintPh: '例如：强调省路费、先试用七天、少讲规格多讲好处（只当方向，不会原文上稿）',
    contentGenPrompts: '生成提示词',
    contentGenPromptNote: 'Cursor／产品写的生成提示词；点 AI 生成会套这些去调 Gemini。可改后直接生成或先保存。',
    contentPreview: '广告预览',
    contentPreviewEmptyImg: '还没有图，请生成或上载',
    contentPreviewEmptyVideo: '还没有短片。点「生成」会出可播画面，也可上载成片。',
    contentPreviewStoryboard: '视频分镜预览',
    contentGenerate: 'AI 生成',
    contentSave: '保存上线',
    contentHook: '卡片一句',
    contentBlurb: '短句',
    contentDetail: '详文',
    contentBenefits: '好处（一行一条）',
    contentBenefitsPh: '每行一条',
    contentSocial: '社媒帖正文',
    contentSource: '来源',
    contentImagePromptPh: '画面提示（AI 会写；可改）',
    contentVideoPromptPh: '分镜／脚本（成片请上载）',
    contentNote: '这是给客户的推荐，不是硬广。图片／视频可 AI 生成，也可上载替换。',
    contentSaveOk: '已保存并上推荐带',
    contentSaveFail: '保存失败',
    contentGenOk: 'AI 已出稿并上线',
    contentGenLlmSkip: '文案 AI 没连上，已保留原商品稿，没有把你的建议贴上去。',
    contentGenImageFail: '图片 AI 没连上，没有用底图加字冒充。',
    contentGenVideoSkip: '短片要先有真图，这次没生成。',
    contentGenFail: '生成失败',
    contentLoadFail: '加载内容库失败',
    contentHelpFoot: '投放看「广告编排」；这里只管商城四格内容。页内预览可看图／视频。'
  },
  addonDeviceScope: {
    title: '选择设备范围',
    hint: '云瞳等按台计费：请勾选要开通的机台或门店；费用＝单价×台数。',
    confirm: '确认选购',
    quoteLine: '{count} 台 × {unit} = {total} {currency}'
  },
  commerceMatrixAlert: {
    title: '商业全景有 {n} 个未归类页面，租户侧栏已隐藏',
    openMatrix: '去处理'
  },
  capabilityAdoptionBanner: {
    title: 'Leo 还有这些能力你还没用过',
    start: '开始引导',
    dismiss: '暂不'
  },
  billingAddonGuide: {
    panelTitle: '我的加购',
    sidebarPathHint: '固定入口：侧栏 → 服务签约 → 加购签约 → 加购总览',
    trialSection: '试用中',
    paySection: '待付款',
    goPay: '去付款',
    goAddonHub: '打开加购总览',
    trialEnds: '试用至 {date}',
    bannerTrial: '您有加购功能试用中；入口在首页「我的加购」与侧栏「加购签约」。',
    bannerPay: '「{sku}」试用已结束，请完成付款以继续使用。',
    bannerPayBtn: '去付款',
    bannerDismiss: '稍后提醒',
    sidebarBadgeTrial: '试用',
    sidebarBadgePay: '待付',
    sidebarBadgeTitle: '加购试用或待付款',
    promoTrialPathHint: '待付或待确认项目在右上角购物车。'
  },
  trialFeature: {
    badgeTrial: '试用',
    summaryPill: '试用中 {n} 项',
    tooltipActive: '{name}：试用中，剩余 {days} 天',
    tooltipExpiring: '{name}：试用即将结束（剩 {days} 天），请签约续用',
    tooltipExpired: '{name}：试用已结束，请签约开通',
    tooltipPaidActive: '{name}：已付费开通',
    popoverKicker: '试用状态',
    trialStartOk: '试用已开通',
    trialStartFail: '试用开通失败',
    trialAlreadyActive: '已在试用中',
    endTrial: '结束试用',
    endTrialConfirm: '结束试用后，云瞳入口会关闭，也不会再提醒付款；买机自带的基础功能不受影响。确定结束？',
    endTrialHint: '不想继续可随时结束试用，不影响买机基础功能。',
    endTrialOk: '已结束试用',
    endTrialFail: '结束试用失败',
    addToCart: '加入购物车',
    addToCartOk: '已加入购物车',
    addToCartFail: '加入购物车失败'
  },
  trialReadiness: {
    title: '试用就绪',
    autoDetectIntro: '以下三项由系统自动检测，无需手动查设置；点「重新检测」可刷新。',
    refresh: '重新检测',
    scopeTitle: '试用设备范围',
    scopeHint: '默认全部型号与设备；可选型号、门店或指定机码（SN/IMIE）。',
    modelPlaceholder: '型号（不选＝全部）',
    storePlaceholder: '门店（不选＝全部）',
    devicePlaceholder: '机码（不选＝范围内全部）',
    deviceEmptyHint: '当前筛选下没有可选设备；请清空型号／门店筛选，或确认品牌下已绑定机码。',
    applyScope: '套用范围',
    scopeSaved: '试用范围已更新',
    scopeSaveFail: '更新试用范围失败',
    guideTitle: '怎么立刻试用云瞳',
    guideStep1: '确认云端试用已开（上方云端项为 ✅）。',
    guideStep2: '选好要试的设备范围，至少一台在线且机型支持云瞳。',
    guideStep3: '打开设备列表 → 该行操作 → 云瞳。',
    guideStep4: '手机端可装 Leo App 远端看机（选填）。',
    openEntry: '去设备列表',
    deviceOnline: '在线',
    deviceOffline: '离线',
    samplesTitle: '范围内设备快照',
    sampleNoIris: '机型不支持云瞳',
    leoAppLoggedIn: '近 {days} 天内检测到 Leo App 登录（品牌 {brandLogins7d} 次）。',
    leoAppNotSeen: '近 {days} 天未检测到 Leo App 登录；请到 SOC 应用商店下载安装（不挡 SOC 试用）。',
    leoAppDetectHint: '自动查会员登录记录，不用自己找设置。',
    cloudReady: '云端试用权限已开，可直接用 SOC 云瞳。',
    cloudMissing: '云端试用尚未生效，请刷新或重新开通。',
    cloudDetectHint: '自动查加购 entitlement 是否仍在试用期。',
    cloudTrialBypassNote: '试用期间即使角色未勾「云瞳遥控」也可开云瞳。',
    deviceReady: '范围内 {ready}/{total} 台可试（支持云瞳且在线）。',
    deviceNone: '范围内尚无设备，请先绑定或调整筛选。',
    deviceNoIrisSupport: '范围内 {total} 台设备，但尚无支持云瞳的机型（泡茶机／咖啡机族）。',
    deviceNeedsOnline: '范围内 {irisCapable} 台支持云瞳，仅 {online} 台在线；请开机联网。',
    deviceDetectHint: '自动查设备在线状态与机型是否支持云瞳。',
    actionLeoApp: '去 SOC 应用商店下载',
    actionDevices: '查看设备列表',
    check: { leoApp: 'Leo App（手机）', cloud: '云端权限', device: '设备在线＋云瞳支持' }
  },
  billingCart: {
    title: '待办账单',
    empty: '暂无待付或待确认项目',
    refresh: '刷新',
    trackAddon: '加购',
    trackContract: '签约',
    statusConfirm: '待确认',
    statusPay: '待付款',
    statusTrial: '试用待购',
    statusRenew: '待续费'
  },
  billingOrder: {
    documentTitle: 'XRROSS 服务订单',
    documentSubtitle: '请核对费用明细与汇总后确认或付款（商业 Order Form）',
    orderNo: '订单编号',
    orderDate: '开单日期',
    partyTitle: '订单双方',
    seller: '卖方',
    buyer: '买方（品牌商）',
    currency: '币种',
    billType: '订单类型',
    lineItems: '订单明细',
    salesOrderTitle: '销售订单明细',
    scheduleOfFeesTitle: '费用明细（Schedule of Fees）',
    stickyPayLabel: '本档应付',
    stickyPayHint: '方案：{scheme} · 目前 {devices} 台',
    deviceSummaryHint: '按设备类别与单价分组；同价同类合并显示台数。',
    feeSummaryTitle: '费用汇总',
    listExTaxUsd: '美金价目（未税）',
    fxRate: '汇率',
    subtotalExTax: '未税小计',
    addonExtra: '加购（雲瞳等）',
    taxAmount: '税额',
    colLineNo: '序号',
    colSku: 'SKU',
    colMachineCode: '机码',
    colDeviceType: '设备类型',
    colModel: '型号',
    colSite: '归属',
    colService: '服务项',
    colServiceDefault: '设备数据年费',
    grandTotal: '合计',
    colDescription: '服务说明',
    colSegment: '场景',
    colQty: '数量',
    colUom: '单位',
    colUnitPrice: '单价',
    colBillingFreq: '计费周期',
    colAmount: '行金额',
    freqYearly: '年',
    freqMonthly: '月',
    termsTitle: '条款与声明',
    termsHint: '付款前请展开阅读；确认或付款即表示同意下列条款。',
    paymentTermsTitle: '付款条款',
    paymentTermsSummary: '本单付款条件：{term}。',
    paymentTermsSummaryDefault: '本单以订单所列币种与金额为准，须于指定期限内完成付款。',
    paymentTermsBody1: '逾期未付可能暂停服务；已付金额依合同／加购条款处理（另有书面约定者除外）。',
    paymentTermsBody2: '微信／PayPal 等通道手续费、汇率差异由付款方自行承担；到账以 XRROSS 公司收款账户入账为准。',
    usageTermsTitle: '使用条款',
    usageTermsSummaryContract: '本服务合同涵盖之 SOC 门户、设备数据或按店订阅功能，仅供授权品牌商及其门店／设备使用。',
    usageTermsSummaryAddon: '加购「{sku}」仅在付款／试用授权范围内启用；到期未续费将自动降级或停用相关功能。',
    usageTermsBody1: '您应确保有权代表企业签约并付款；账号操作与设备远程操作之后果由企业自行负责。',
    usageTermsCancelAnytime: '本加购标示可随时取消；取消后下一计费周期不再扣款，已付期间不退费。',
    serviceTermsTitle: '服务条款与免责',
    serviceTermsBody1: 'XRROSS SOC 平台服务依《隐私政策》《服务条款》与《免责声明》提供。',
    serviceTermsBody2: '电子确认、付款时间戳与账号纪录得作为履约证据。',
    viewPlatformTerms: '查看平台完整条款',
    totalDue: '应付合计',
    promoTitle: '优惠券',
    promoSelectHint: '可选一张或多张优惠券，套用后更新应付金额（每单仅可套用一次）。',
    promoApplyBtn: '套用优惠券',
    promoAppliedTitle: '已套用优惠',
    promoDiscount: '优惠减免',
    promoSubtotalBefore: '优惠前小计',
    promoEmpty: '目前没有可用的优惠券',
    trialEndsAt: '试用截止',
    paymentTermNet7: '开票后 7 日内付款',
    paymentTermNet15: '开票后 15 日内付款',
    paymentTermNet30: '开票后 30 日内付款',
    paymentTermNet45: '开票后 45 日内付款',
    paymentTermNet60: '开票后 60 日内付款',
    paymentTermPrepaid: '预付／先付后用',
    paymentTermDueOnReceipt: '收票即付'
  },
  brandServiceContract: {
    title: '服务签约',
    pageDesc: '按品牌商制定计费条款，支持邮件确认／电子签后激活；条款写入 terms_json 供自动账单。',
    helpTitle: '本页操作说明（点击展开）',
    help1: '新建签约：选品牌商、计费方法、付款与确认方式，保存为草稿。',
    help2: '发送确认邮件或门户确认／标记电子签后，再点激活。',
    help3: '激活后开服闸认 ACTIVE 数据服务合同；Leo 基础买机即含，加购可试用可取消。',
    create: '新建签约',
    tabContracts: '合同列表',
    tabEntitlementTree: '权限树已购',
    treeNeedBrand: '请先选品牌商，再按侧栏同一棵树查看已购／待购。',
    treePickContract: '选合同',
    treeInContract: '在合同',
    treeLockedPrice: '锁价',
    treeQty: '数量',
    treePayable: '应付',
    treeLineStatus: '状态',
    treeStatusInScope: '已购',
    treeStatusNotPurchased: '待购',
    treeFilterInContract: '已购筛选',
    treeFilterAll: '全部',
    treeFilterPurchased: '仅已购',
    treeFilterNotPurchased: '仅待购',
    treeFilterKeyword: '搜菜单／SKU',
    createTitle: '新建品牌服务签约',
    bundleTier: '四档算价',
    bundleTierT1: '① 纯 SOC $49/店/月',
    bundleTierT2: '② 全店打包 $199/店/月',
    bundleTierT3: '③ 纯设备按台',
    bundleTierT4: '④ SOC $99 + 按台',
    bundleTierPaperLock: '纸质锁定（不重算价目）',
    priceBookSku: '价目表模板',
    priceBookSkuPh: '从 HQ 价目表选合同计价模板',
    needPriceBookSku: '请先选四档算价或价目表模板',
    brand: '品牌商',
    brandId: '品牌商ID',
    status: '状态',
    statusDraft: '草稿',
    statusPendingHqApproval: '待总部审',
    statusApproved: '已批准',
    statusPendingTenantConfirm: '待租户确认',
    statusPendingPay: '待付款',
    statusActive: '已激活',
    statusSuspended: '已暂停',
    statusExpired: '已到期',
    statusCancelled: '已取消',
    contractNo: '合同号',
    pricingMethod: '计费方法',
    pricingTiered: '年费＋台数阶梯',
    pricingPerDevice: '每台周期费',
    pricingPerStoreMonth: '按店／月（含最少月数）',
    pricingPerDeviceMonth: '按台／月（含最少月数）',
    pricingPerStoreDay: '按店／天现结',
    pricingPerDeviceDay: '按台／天现结',
    minContractMonths: '最少签约月数',
    periodMonths: '本合同月数',
    dayCount: '使用天数',
    pricingSocStore: 'SOC 按店订阅（推荐）',
    addonPricingOneTime: '一次性加购',
    addonPricingPerDeviceYear: '每台／年',
    addonPricingPerStoreYear: '每店／年',
    addonPricingPerHouseholdYear: '每户／年',
    addonPricingTrialThenPaid: '试用后付费',
    addonPricingAiPoints: 'AI 点数包',
    addonPricingModule: '模块加购',
    addonPricingCustomQuote: '项目报价',
    paymentTerm: '付款条件',
    currency: '币种',
    tierCode: '合同档位',
    period: '计费周期',
    unitPrice: '单台金额',
    tiers: '阶梯价目',
    addTier: '加一行阶梯',
    legacyOral: '口头旧约',
    confirmSection: '签约确认',
    confirmChannel: '确认通道',
    confirmStatus: '确认状态',
    confirmNone: '未确认',
    confirmPendingEmail: '待邮件确认',
    confirmPendingEsign: '待电子签',
    confirmEmailOk: '邮件已确认',
    confirmSigned: '已电子签',
    confirmPortalOk: '门户已确认',
    confirmRejected: '已拒绝',
    confirmExpired: '确认已过期',
    confirmPendingTenant: '待租户确认',
    cycleYearly: '按年',
    cycleQuarterly: '按季',
    cycleMonthly: '按月',
    cycleDaily: '按天',
    paymentTermDepositBalance: '订金＋尾款',
    paymentTermInstallment: '分期付款',
    chEmail: '邮件确认',
    chEsign: '电子签',
    chPortal: '门户确认',
    chManual: '线下／口头',
    confirmEmail: '收件邮箱',
    signerRole: '签署人角色',
    signerName: '签署人姓名',
    mailLocale: '邮件语言',
    requireConfirm: '激活前须确认',
    addonTitle: 'SOC／Leo 加购（试用可取消）',
    addonHint: '买机含 Leo 基础免费；此表仅加购。家用／商用分清单。',
    addonHome: '家用',
    addonCommercial: '商用',
    addonName: '名称',
    addonTrialDays: '试用天',
    addonUsdPrice: 'USD 标价',
    addonBillingCycle: '付费周期',
    addonBillingYearly: '年付',
    addonBillingMonthly: '月付',
    addonCancel: '可取消',
    addonStartTrial: '开始试用',
    addonWxPay: '微信支付',
    addonPaypal: 'PayPal',
    addonPaypalOpen: '已打开 PayPal 付款页（海外 USD）',
    addonPaypalStub: 'Stub 已记开通（不是真收款）',
    addonPaypalNoUrl: '没有 PayPal 跳转网址',
    addonWxTitle: 'XRROSS 公司微信收款',
    addonWxHonesty: '扫码付款进公司户（卖 SOC／硬件），不是店客单。未配商户密钥时为模拟码。',
    addonWxSim: '模拟已付',
    addonWxPaid: '已记已付（模拟≠真到账，除非已配公司商户）',
    addonWxQrFail: '无法产生收款码',
    addonWxNoEntitlement: '找不到加购试用单，请先试用',
    addonNeedBrand: '请先在上方筛选品牌商再试用',
    addonTrialOk: '已开始试用',
    quoteLine: '预估应付 {amount} {currency}（机 {devices}／店 {stores}，周期 {period}）',
    quoteTrackA: 'A 小计（设备数据）',
    quoteTrackB: 'B 小计（店务运营）',
    quoteBundle: '套餐价',
    quotePayable: '应付',
    quoteExTax: '未税小计',
    quoteExTaxShort: '未税',
    quoteTax: '税额',
    quoteTaxInclusive: '含税合计',
    taxRegion: '计税税区',
    quoteExportPdf: '导出报价单',
    quotePrintTitle: '官方结构报价单',
    needBrandPricing: '请选择品牌商与计费方法',
    needEmail: '邮件确认须填写收件邮箱',
    sendEmail: '发确认邮',
    portalAck: '门户确认',
    markEsign: '标记已签',
    esignUrlHint: '签章凭证 URL（可选）',
    activate: '激活',
    suspend: '暂停',
    suspendReason: '暂停原因（可选）',
    actions: '操作',
    mailSent: '确认邮件已发送',
    mailStub: '邮件通道未通，已生成令牌（可手工确认）',
    summaryTitle: '签约总表',
    summaryPageDesc: '看各品牌商要确认、要付钱、已开通的费用单；点详情看明细。',
    summarySimpleIntro: '三种费用会列在这里：① 平台服务费（管设备／数据）② 额外买的功能 ③ 买机器的付款单。每一行就是一笔事，不是重复数据。',
    summaryGoDesk: '新建签约',
    startPipeline: '开始标准流水线',
    pipelineTitle: '签约标准流水线',
    pipelineDesc: '草稿 → 总部批 → 品牌签回 → 付款 → 开通；点节点可跳到对应页并开助手。',
    pipelineNow: '当前',
    flowNode_bsc_draft: '建草稿',
    flowNode_bsc_hq_approve: '总部批',
    flowNode_bsc_tenant_confirm: '品牌签回',
    flowNode_bsc_pay: '付款',
    flowNode_bsc_active: '已开通',
    addonStartPipeline: '开始加购流水线',
    addonPipelineTitle: '加购标准流水线',
    addonPipelineDesc: '试用／直购 → 付款 → 开通（标准 SKU 免总部批）。',
    flowNode_sla_start: '试用／直购',
    flowNode_sla_pay: '付款',
    flowNode_sla_active: '已开通',
    quickAll: '全部',
    quickActionAdmin: '待我处理',
    quickActionTenant: '待我确认',
    quickPay: '待付款',
    quickOverdue: '已逾期',
    quickActive: '已开通',
    statPendingPay: '待付款',
    statOverdue: '已逾期',
    statActive: '已开通',
    filterBrandPh: '搜品牌商',
    filterTypePh: '费用类型',
    showAdvanced: '更多筛选',
    hideAdvanced: '收起筛选',
    colBrand: '品牌商',
    colItem: '什么费用',
    colSituation: '现在怎样',
    colAmount: '应付',
    colDueDate: '下次到期',
    trackShortContractA: '平台服务费',
    trackShortAddonB: '额外功能',
    trackShortHardware: '买机器',
    situationPendingHq: '等你批准',
    situationPendingConfirm: '等你确认签约',
    situationPendingPay: '待付款',
    situationOverdue: '已逾期',
    situationActive: '已开通',
    situationSuspended: '已暂停',
    situationDraft: '草稿',
    situationHardware: '硬件付款',
    situationOther: '其他',
    actionApprove: '批准',
    actionConfirm: '去确认',
    actionReject: '驳回',
    goDesk: '签约台',
    paymentStatus: '付款状态',
    payUnpaid: '未付',
    payPaid: '已付',
    payPartial: '部分付',
    payOverdue: '逾期',
    amountDue: '应付',
    amountPaid: '已付金额',
    nextDueAt: '下次到期',
    expiredOnly: '仅到期／逾期',
    editPayment: '编辑付款',
    editPaymentTitle: '编辑付款状态',
    totalContracts: '合同数',
    totalActive: '已激活',
    totalUnpaid: '未付／部分',
    totalOverdue: '付款逾期',
    totalDue: '应付合计',
    totalOutstanding: '未结合计',
    viewDetail: '详情',
    detailTitle: '签约详情',
    detailPageDesc: '正式销售订单（机型／数量／单价／汇总）与收费历史；与确认页同一套 Order Form。',
    backSummary: '返回总表',
    goConfirmOrder: '打开确认／签回',
    detailPayWaitHq: '此单尚待总部核准，核准后才可确认／付款。',
    detailPayWaitConfirm: '请先完成门户确认／签回，状态变为待付款后才会出现付款钮。',
    detailPayNoAction: '目前状态不可付款；请用右上角「打开确认／签回」或「去付款」（待付款时）。',
    detailMerchant: '商户',
    detailScope: '产品／服务范围',
    detailPricing: '价格与计费',
    detailDates: '生效与到期',
    detailChargeHistory: '收费历史',
    chargeTime: '时间',
    chargeEvent: '事件',
    chargeNote: '备注',
    amountDelta: '已付增减',
    effectiveFrom: '生效起',
    effectiveTo: '生效迄／到期',
    devicesStores: '计费台数／店数',
    detailLoadFail: '加载详情失败',
    track: '轨道',
    trackContractA: '服务合同',
    trackAddonB: '加购',
    trackHardware: '硬件采购',
    deskPhase: '待办阶段',
    phasePendingHq: '待总部审',
    phasePendingConfirm: '待确认',
    phasePendingPay: '待付款',
    phaseOverdue: '逾期',
    phaseSuspended: '已停服',
    hqApprove: '总部批准',
    hqReject: '总部驳回',
    hqApproveOk: '已批准并通知品牌商',
    hqRejectOk: '已驳回',
    submitApproval: '提交审批',
    batchSelected: '已选 {n} 笔',
    batchSubmit: '批量提交审批',
    batchHqApprove: '批量总部批准',
    batchHqReject: '批量总部驳回',
    batchSendEmail: '批量发确认信',
    batchActivate: '批量激活',
    batchSuspend: '批量暂停',
    batchClear: '取消选择',
    batchAllOk: '{n} 笔全部成功',
    batchPartial: '成功 {ok} 笔，失败 {fail} 笔（{err}）',
    batchConfirmSubmit: '确认将 {n} 笔合同提交总部审批？',
    batchConfirmActivate: '确认激活 {n} 笔合同？',
    contractLineItem: '服务项目',
    priceLockedHint: '以下单价已从价目表锁定，确认后写入合同',
    discountPct: '折扣％',
    discountPctPh: '0 表示无折扣',
    discountReasonPh: '优惠原因（可选）',
    hqRejectReasonPh: '驳回原因',
    billingConfirmTitle: '账单／合同确认',
    schemePickTitle: '选择计费方案',
    addonTrackBTitle: '加购一并出单（Track B）',
    addonTrackBHint: '雲瞳等加购与 Track A 服务合同同页列出；计费 entitlement 独立，总表可合并查看。',
    cloudIrisPickHint: '确认签回前可勾选要开通雲瞳的机台；金额按台数重算。',
    cloudIrisPickBtn: '选机',
    cloudIrisPickOk: '雲瞳选机已更新',
    schemePickHint: '请按机台规模选择套餐／按台年费／台数阶梯等方案；点选后下方金额与明细会立刻更新；鼠标移到方案上可看说明与单价组成，锁定后再确认签回。',
    schemePickHintSimple: '点一张卡片选方案；展开后在同一张卡里选数量档，下方「应付」会立刻更新。',
    schemePickHintPaperLock: '纸质合同已锁年费与台数上限，不按价目表重算；请确认后签回。',
    tierEmbedTitle: '选数量档（越多越省）',
    tierEmbedHint: '点一档即可；目前落档已标示。选更高档＝预购到该档最少台数，单价更低。',
    storeTierEmbedTitle: '选店数档（越多越省）',
    storeTierEmbedHint: '点一档即可；目前落档已标示。选更高档＝预购到该档最少店数。',
    brandRoleTitleReadonly: '您的类型',
    brandRoleLockedHint: '由平台定案，不可自改',
    schemeCardBlurbDefault: '点选后即可在下方查看应付与明细。',
    deviceTierLadderHint: '数量越多单台越便宜。下表用您目前台数对比各档；升档可省多少一眼可见。',
    storeTierLadderHint: '店数越多单店越便宜。下表用您目前店数对比各档。',
    tierLadderTitle: '台数阶梯（越多越省）',
    storeTierLadderTitle: '店数阶梯（越多越省）',
    tierLadderBand: '档位',
    tierLadderRange: '台数范围',
    tierLadderDiscount: '折扣',
    tierLadderUnit: '有效单价',
    tierLadderQty: '计费台数',
    tierLadderQtyStore: '计费店数',
    tierLadderTotal: '合计',
    tierLadderSaveVsPrev: '比上一档省',
    tierLadderSaveVsPrevAmt: '比上一档同台数省 {amount}',
    tierLadderCurrent: '目前落档',
    tierLadderNegotiated: '特批协商',
    tierLadderNeedPrepaid: '须预购≥{count}',
    tierLadderNeedPrepaidStore: '须预购≥{count}店',
    tierLadderFootnote: '以上以目前 {count} 台对比；若选「预购锁档」，须达到该档最少台数才能用更低单价。',
    schemeHoverHint: '将鼠标移到方案上查看详细说明与单价组成',
    schemeUnitComposeTitle: '单价组成',
    schemeUnitComposeEmpty: '本方案暂无逐台／逐店单价拆解（以合计为准）。',
    schemeUnitComposeFlat: '单价 {unit} {currency} × {qty}',
    schemeUnitComposeTotalOnly: '本方案按合计报价 {total} {currency}（无更细单价拆解）。',
    schemeExplain_DEFAULT: '该方案按价目表估算；锁定后写入合同应付与明细。',
    schemeExplain_T1: '① 纯 SOC：只收门店 SOC 订阅（按店／月），账单不含机台数据年费。已有机台请改选②全店打包或④ SOC＋按台；本档适合先开通门户、暂不算设备年费。',
    schemeT1DeviceGuideTitle: 'T1 纯 SOC 不含机台费用',
    schemeT1DeviceGuideDesc: '当前品牌子树约有 {count} 台设备。选 $49／月只收 SOC，不会自动加上设备年费。若机台也要计费，请改选「全店打包」或「SOC＋按台分项」。',
    schemeT1DeviceBlockTitle: '方案备注（T1 纯 SOC）',
    schemeT1DeviceBlockDesc: '当前品牌子树约有 {count} 台设备。已有机台时 T1（$49／纯 SOC）通常不适用，建议改选「全店打包」或「SOC＋按台分项」后再锁定。',
    brandRoleTitle: '品牌商类型（影响推荐）',
    brandRoleOperator: '品牌运营商',
    brandRoleEquipment: '做设备（厂／通路）',
    schemeRecommendTitle: '系统推荐 · 最划算',
    schemeRecommendBadge: '推荐',
    schemeRecommendApply: '采用推荐方案',
    schemeRecommendApplied: '已套用推荐方案与付款节奏',
    schemeRecommendReasonNone: '暂无可推荐方案，请人工选择。',
    schemeRecommendReasonEquipment: '判定为做设备（约 {deviceCount} 台、{storeCount} 店）：不必买 SOC，推荐纯设备档 {code}，年化约 {amount} {currency}。',
    schemeRecommendReasonOperator: '判定为品牌运营商（约 {storeCount} 店、{deviceCount} 台）：在可选方案中 {code} 年化约 {amount} {currency} 最划算。',
    schemeRecommendReasonOperatorAnnual: '判定为品牌运营商：推荐 {code}，并以预缴年 85 折计，年化约 {amount} {currency}（含月费折扣口径）。',
    schemeExplain_T2: '② 全店打包：按店／月打包 SOC 能力（比纯 SOC 档更高），仍以门店订阅为主；适合全店数字化但暂不拆机台明细的场景。',
    schemeExplain_T3: '③ 纯设备按台（年）：只收品牌子树下各机台设备数据年费，按型号／机码列明细；不含 SOC 店费。适合「已有机台、按台计费」的现况合同。',
    schemeExplain_T4: '④ SOC＋按台分项：门店 SOC 订阅＋各机台设备年费一并报价；适合门户与机台数据服务都要的完整档。',
    schemeExplain_PER_DEVICE_YEARLY: '按台年费：品牌子树每台设备一条明细，单价来自价目表对应 SKU（如配料机年费），合计＝各台行金额之和。',
    schemeExplain_TIERED_ANNUAL_POOL: '台数池阶梯年费：按品牌子树台数落入价目阶梯（台越多单价可能更划算）；现况明细仍可按台列示便于对账。',
    schemeLockBtn: '锁定此方案',
    schemeLockOk: '计费方案已锁定',
    schemeLockFail: '锁定方案失败（需后台已部署选方案接口）',
    deviceTierLockTitle: '台数档位（设备数据）',
    deviceTierLockHint: '可按现况台数自动落档，或选预购台阶：按该档最少台数预缴，档内单价锁定。',
    deviceTierModeActual: '现况台数（{count} 台）',
    deviceTierModePrepaid: '预购台阶锁档',
    committedDeviceCountLabel: '承诺台数',
    committedDeviceCountHint: '须 ≥ 现况台数；锁定后按承诺台数算档与应付。',
    committedDeviceCountInvalid: '承诺台数须不少于现况 {min} 台',
    storeTierLockTitle: '店数档位（按店计划）',
    storeTierLockHint: '选店铺计划后可按现况店数落档，或选预购台阶：按该档最少店数预缴。',
    storeTierModeActual: '现况店数（{count} 店）',
    storeTierModePrepaid: '预购台阶锁档',
    tierBandPickHint: '请选择台阶；预缴数量＝该档下限与现况的较大者。',
    tierBandPrepaidMin: '预缴 {count} 台',
    storeTierBandPrepaidMin: '预缴 {count} 店',
    tierBandRequired: '请先选择一个台阶',
    tierBandUnavailable: '该台阶对现况数量不可用，请改选更高档',
    tierGrowthPolicyHint: '合同期内多出来的数量（仍在本档）按同档单价×剩余期限补差；跨下一档须改签，不自动升档。',
    paymentCadenceTitle: '付款节奏（付款条件优惠）',
    paymentCadenceHint: '月费固定部分可按月缴，或一次预缴全年享 85 折（按台年费等不打折）。选好后点锁定，应付金额会更新。',
    paymentCadenceMonthly: '按月缴',
    paymentCadenceMonthlyNote: '当期月费固定部分（其它年费行另计）',
    paymentCadenceAnnual: '预缴年 · 85 折',
    paymentCadenceAnnualNote: '月费×12×0.85 一次付清（其它年费行原价）',
    paymentCadenceLockBtn: '锁定此付款节奏',
    paymentCadenceLockOk: '付款节奏已锁定，应付已更新',
    paymentCadenceLockFail: '锁定付款节奏失败',
    billingConfirmDesc: '总部已批准后，请在此电子确认条款；确认后进入待付款（P0-2）。',
    billingConfirmBtn: '我确认条款',
    billingConfirmOk: '已确认，请完成付款',
    billingConfirmDone: '本单已确认或不可再确认',
    billingConfirmMissing: '缺少 track／sourceId 或无权查看',
    billingPayActive: '服务已开通'
  },
  opsAnalytics: {
    subtitle: '本店／本区图表 + AI 建议；对手情报另计加购',
    month: '月份',
    storeId: '店铺 ID',
    query: '查询',
    goPnl: 'P&L 工作台',
    skuHint: '图表／本区：COM_ANALYTICS_AI；对手＋深度建议：COM_COMPETITOR_INTEL＋AI 点数',
    areaTitle: '本区店铺对比',
    store: '店铺',
    compTitle: '竞争对手分析',
    compSku: '竞争情报加购',
    compName: '对手',
    rating: '评分',
    reviews: '评论数',
    priceBand: '价带',
    salesHonesty: '销售诚实态',
    aiTitle: 'AI 建议（短）',
    catalogTitle: '报表目录（最大集）',
    kpi: { revenue: '营收', gross: '毛利', net: '净额', aov: '客单', tickets: '单量', labor: '人工占比' },
    charts: { rev: '营收趋势', hour: '时段热力', item: '品项排行', channel: '渠道结构', area: '本区排名' }
  },
  tokenBilling: {
    pageTitle: 'AI 点数账单平台',
    pageLead: '按当前登录企业汇总 Leo 用量与入账扣款；对外显示 AI 点数，内部仍为 token ledger。维护上游成本与参考售价用于毛利估算（近 30 日）。'
  },
  leoE2: {
    webMarketSearch: '热销网搜',
    webMarketHintTitle: '热销网搜已接后端（草案）',
    webMarketHintDesc: '会搜公开资料并解析用料草案，仅 DRAFT；仍须物料 ID 预检与人闸。不等于生产硬绿，不会自动下发。',
    webQuery: '网搜关键词',
    webQueryPh: '例：新茶饮 热销 茉莉奶绿 用料（可空，用默认热销查询）',
    webSearchBtn: '网搜并转入开场',
    webSearchFail: '热销网搜失败',
    e21Tab: 'E21 智能配方',
    e21AlertTitle: 'E21 对话试泡闭环（茶机一期 · 模拟机先）',
    e21Banner: '流程：开会话 → 首次应用人闸 → 试泡 → 口味反馈微调 → 正式保存 PRIVATE+VERIFIED。PRODUCTION 可聊禁下发。硬规：泡茶机试泡＝茶叶（散叶），不是茶粉。',
    e21Entry: '入口',
    e21HasMenu: '有菜单／品项文字',
    e21CompetitorPaste: '竞品用料贴上',
    e21MenuText: '菜单文本',
    e21MenuPh: '粘贴客户菜单／竞品用料，将编译草案并作 E21 开场',
    e21ApplyOpener: '转入开场话',
    e21TrialMaterial: '当前试泡物料：{label}',
    e21TeaLeaf: '茶叶',
    e21TargetUrn: '目标机 URN',
    e21DeviceOpsMode: 'deviceOpsMode',
    e21StartMessage: '开场话',
    e21Start: '开会话',
    e21ConfirmFirst: '确认首次应用',
    e21Trial: '试泡',
    e21FormalSave: '正式保存',
    e21TurnFeedback: '多轮／反馈',
    e21TurnPh: '例如：这泡偏苦再淡一点／满意了正式保存',
    e21SendTurn: '发送 turn',
    e21SendFeedback: '发送 feedback',
    e21SessionState: '会话状态',
    e21NeedUrnAndMessage: '请填目标机与开场话',
    e21SessionOpened: 'E21 会话已开',
    e21StartFail: '开会话失败',
    e21FirstConfirmed: '首次应用已确认',
    e21FirstCancelled: '已取消首次应用',
    e21FirstFail: '首次应用失败',
    e21TrialStarted: '试泡已发起',
    e21TrialFail: '试泡失败',
    e21NeedUtterance: '请输入话术',
    e21TurnFail: 'turn 失败',
    e21NeedFeedback: '请输入反馈',
    e21FeedbackOk: '已收反馈',
    e21FeedbackFail: 'feedback 失败',
    e21Saved: '已正式保存 PRIVATE+VERIFIED',
    e21SaveCancelled: '已取消保存',
    e21SaveFail: '正式保存失败',
    e21HotSellOpener: '搜一下市场上热销的茶'
  },
  x600hProductionOrder: {
    pageDesc: '双轨产线：安卓先联云、9100 先 HF 配网；再绑码／厂检／出厂。页上可开工厂标准流水线。',
    startStandardPipeline: '开始全自动流水线',
    socPipelineNodeTodo: '未开始',
    socPipelineNodeCurrent: '进行中',
    socPipelineNodeDone: '已完成',
    startOpenStorePipeline: '开始开店流水线',
    startBusinessHoursPipeline: '开始营业时间流水线',
    pipelineStarted: '已打开批量加设备全自动流水线（含建工厂），请按节点逐步做。',
    togoOpen: '工单待办',
    togoTitle: '工单待办',
    togoRemain: '还差 {n} 步',
    togoAllDone: '四步都过了',
    togoStuck: '卡住',
    togoHint: '打勾只认系统状态。点卡住的步骤可跳真页，或开口跟 Leo 说、填同一张单。',
    togoVoice: '跟 Leo 说',
    togoClose: '关闭',
    togoLoadFail: '待办清单加载失败',
    togoStep_demand_placed: '需求已落单',
    togoStep_hq_confirm: '总部确认',
    togoStep_factory_ready: '工厂可交货',
    togoStep_customer_activate: '客户现场激活',
    flowNow: '当前',
    flowHint: '格子连成一条线：绿的已过、黄的是卡住这一步、灰的还没到。点格子跳到本单对应位置。',
    flowNode_hq: '总部确认',
    flowNode_open: '打开本单',
    flowNode_bind: '机读绑码',
    flowNode_handshake: '9100握手',
    flowNode_ship: '出厂确认',
    flowNode_activate: '客户激活',
    simplePipelineTitle: '全自动流水线：批量加设备',
    simplePipelineDesc: '为配合全球设备统一管理：建工厂 → 登记供应伙伴 → 建产线单 → 等系统确认。不要用设备列表手建顶替。',
    pipelineNow: '当前',
    pipelineDone: '完成',
    pipelineTodo: '未开始',
    pipelineWaitHq: '等待系统确认',
    flowNode_bbds_create_factory: '建工厂',
    flowNode_bbds_register_s0: '登记供应厂',
    flowNode_bbds_create_order: '建产线单',
    flowNode_bbds_wait_hq: '等系统确认'
  },
  deviceOrderLifecycle: {
    title: '设备主链引导',
    desc: '建单到客户：S1～S7 跳真页；可按总部／品牌／工厂开智能引导。',
    roleHq: '总部',
    roleBrand: '品牌',
    roleFactory: '工厂',
    hintHq: '总部：审单、发号、看全链。',
    hintBrand: '品牌：建单、收货／下放、客户激活入口。',
    hintFactory: '工厂：联云／配网、绑码、首检、出厂（主 UI 仍在 Leo 工厂包）。',
    startSmartGuide: '开本角色智能引导',
    openPage: '打开本步真页',
    prev: '上一步',
    next: '下一步',
    guideStarted: '智能引导已开始，可在 Leo 助手继续检查。',
    guideStartFail: '无法开始智能引导（权限或后台未重启）',
    s1Title: '建产线订单',
    s1Short: '品牌建单',
    s1Body: '在「产线订单」新建订单：数量、型号、云区。提交后等总部确认。',
    s2Title: '总部确认',
    s2Short: '审单钉死',
    s2Body: '总部确认后数量／型号／云区钉死，进入可发号与产线。',
    s3Title: '发号同步',
    s3Short: '跨区发号',
    s3Body: '在「发号同步」确认号段与跨区副本 ACK。',
    s4Title: '联云／配网与绑码',
    s4Short: '工厂产线',
    s4Body: '安卓先「生产联云」、9100 先「生产配置」；再机读绑码与厂检／首检。禁止手填主路径。',
    s5Title: '出厂确认',
    s5Short: '可交货',
    s5Body: '首检通过后出厂确认。未出厂则客户不可激活；出厂≠开始计费。',
    s6Title: '品牌收货／下放',
    s6Short: '到店／客户',
    s6Body: '品牌在设备列表完成收货或下放给门店／终端客户。',
    s7Title: '客户首启／设备激活',
    s7Short: '激活开收',
    s7Body: '用 Leo「设备激活」选云区→WiFi；日常换网用「WIFI设置」只改 STA。首启后写客户激活（出厂≠开收）。硬件认证页可核对开收闸。'
  },
  globalDevice: {
    catalogTitle: '型号目录',
    catalogDesc: '新型号须申请待审；仅东京写中心可批准写入总表。',
    catalogHint: '全球型号 Catalog：节点申请 → 东京审批',
    catalogApply: '申请新型号',
    applyManageTitle: '型号申请',
    applyManageDesc: '管理各节点型号申请：提交、待审列表、东京批准／拒绝。',
    submitApply: '提交申请',
    applyRequired: '请填写型号代码与名称',
    applySubmitted: '已提交，状态为待审',
    modelKey: '型号代码',
    modelName: '型号名称',
    deviceFamily: '设备族',
    applyStatus: '申请状态',
    applicantRegion: '申请区',
    publishedModelId: '已发布型号ID',
    rejectReason: '拒绝原因',
    notes: '备注',
    approve: '批准',
    reject: '拒绝',
    confirmApprove: '确认批准并写入东京总表？',
    approved: '已批准并写入总表',
    rejected: '已拒绝',
    waitingTokyo: '待东京审核',
    centerRole: '写中心角色',
    statusPending: '待审 PENDING',
    statusApproved: '已批 APPROVED',
    statusRejected: '已拒 REJECTED',
    openApplyManage: '打开型号申请管理',
    governanceGapJump: '整治缺口',
    simplePipelineTitle: '全自动流水线：申请新机型',
    simplePipelineDesc: '为配合全球设备统一管理：打开申请页 → 提交一条 → 等东京批准。不要在本地私自建正式型号。',
    pipelineNow: '当前',
    pipelineDone: '完成',
    pipelineTodo: '未开始',
    pipelineWaitTokyo: '等待东京',
    startSimplePipeline: '开始全自动流水线',
    pipelineStarted: '已打开型号申请全自动流水线，请按节点逐步做。',
    flowNode_bcas_open_apply: '打开申请页',
    flowNode_bcas_submit_apply: '提交申请',
    flowNode_bcas_wait_tokyo: '等东京审核'
  },
  dispenserDataCenter: {
    precisionDesc: '精準度 = 实际出料 ÷ 配方出料；用于配料机出料校准与出品质量监视。',
    lossDesc: '按物料对比配方出料与实际出料差额，定位损耗与超量。',
    multiMachineDesc: '配料机与泡茶机供料绑定工作台入口（复用多机互联）。',
    refresh: '刷新',
    imiePlaceholder: '设备 IMIE（可空＝租户汇总）',
    days7: '近 7 天',
    days30: '近 30 天',
    days90: '近 90 天',
    avgPrecision: '平均精準度',
    onTargetRate: '达标率',
    dispenseCount: '出料次数',
    precisionTrend: '精準度趋势（日均）',
    recentDispenses: '最近出料',
    noTrend: '暂无趋势数据；后端合入后自动展示',
    noRows: '暂无明细',
    colTime: '时间',
    colMaterial: '物料',
    colRecipe: '配方出料',
    colActual: '实际出料',
    colPrecision: '精準度',
    colDelta: '差额',
    totalRecipe: '配方合计',
    totalActual: '实际合计',
    totalDelta: '损耗差额',
    lossRate: '损耗率',
    lossByMaterial: '按物料损耗',
    loadFailedFriendly: '精準度／损耗接口暂不可用（后端未合入或网络异常），页面已降级为空态。',
    multiMachineReuseTitle: '配料机多机互联',
    multiMachineReuseBody: '本页深链至既有「多机互联工作」台，配置饮料机／配料机与泡茶机绑定。',
    openEarlyBrew: '打开多机互联工作台',
    openInNewTab: '新标签打开'
  },
  leoAiBill: {
    pageDesc: '美金硬闸只挡云修单；桌面聊天请看 Cursor 官方 Spending。',
    startPipeline: '开始标准流水线',
    usdCapLine: '月美金上限（只挡云修单）',
    usdExhausted: '美金已触顶',
    gateScope: '只挡云修单 Healer 新开跑；不挡桌面 Cursor 聊天',
    roundsCap: '月轮次上限',
    usdCap: '月美金上限',
    saveCaps: '保存双帽',
    savedCaps: '已保存轮次上限与美金上限',
    tableTitle: '总账单（美金＋Token）',
    colSubject: '科目',
    colUsd: '美金',
    colTokens: 'Token',
    colGated: '是否受闸',
    colHint: '说明',
    colAgent: 'Agent',
    gatedYes: '挡云修单',
    gatedNo: '只展示',
    na: '—',
    tokenNotSecondMoney: 'Token 是同一笔云 Agent 用量，不是第二笔钱。点行看细项。',
    detailTitle: '云修单细项',
    desktopHint: '桌面写码请看 Cursor 官方 Spending',
    guideStarted: '已开标准流水线',
    guideStartFail: '开流水线失败'
  },
  x600hAftersales: {
    title: 'X600H 家用售后',
    desc: '换机／退货／政策 FAQ 进度可查；节点可点、状态可见。公开条款在购买页。',
    openTerms: '保固与退货条款',
    startLine: '开一条线',
    startHint: '也可在 Leo 开口说——同一条 playbook。',
    startReplace: '开始先换新',
    startReturn: '开始 30 天退货',
    startFaq: '问保固／退货 FAQ',
    myProcess: '我的进程',
    refresh: '刷新',
    noActive: '暂无进行中的售后线——请上方开线或在 Leo 开口。',
    pleaseDo: '请完成：',
    followPipeline: '请依序完成流水线',
    coachDefault: '蓝框＝当前步。点节点可看状态。',
    openAssist: '打开助手',
    iDidCheck: '我做完了 · 再检查',
    statusDone: '完成',
    statusCurrent: '进行中',
    statusTodo: '未开始'
  },
  storeHomeFeedTitle: '首页推荐',
  storeHomeFeedDesc: '人定方向、AI 排版：钉位爆品 + 千人千面马赛克',
  storeHomeFeedSave: '保存方向',
  storeHomeFeedReload: '刷新',
  storeHomeFeedAnalytics: '效果看板',
  storeHomeFeedTheme: '战役主题',
  storeHomeFeedMode: '模式',
  storeHomeFeedModeDirection: '方向框内 AI 排',
  storeHomeFeedModeFull: '更开放（仍禁一次塞满）',
  storeHomeFeedPins: '钉位商品 ID',
  storeHomeFeedBoostCats: '加权品类',
  storeHomeFeedBan: '禁推 ID',
  storeHomeFeedGuarantee: '保量 %',
  storeHomeFeedExplore: '探索 %',
  storeHomeFeedEnabled: '启用',
  storeHomeFeedIdsHint: '逗号分隔数字 ID',
  storeHomeFeedCatsHint: '如 特调,茶饮',
  storeHomeFeedSaved: '已保存',
  storeHomeFeedImp: '曝光',
  storeHomeFeedClick: '点击',
  storeHomeFeedAdd: '加购',
  storeHomeFeedPay: '成交',
  storeHomeFeedPipeline: '标准流水线',
  storeHomeFeedStartPipeline: '开始标准流水线',
  storeHomeFeedCheckGuide: '检查引导',
}


// WEBPACK FOOTER //
// ./src/lang/zh.js